webpackJsonp([115],{

/***/ 1000:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1001:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1002:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 13:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ADD_NOTIFICATION */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return REMOVE_NOTIFICATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return REPLACE_NOTIFICATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NEW_NOTIFICATION; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__session__ = __webpack_require__(17);
var _mutations, _actions;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





var ADD_NOTIFICATION = 'ADD_NOTIFICATION';
var REMOVE_NOTIFICATION = 'REMOVE_NOTIFICATION';
var REPLACE_NOTIFICATION = 'REPLACE_NOTIFICATION';

var NEW_NOTIFICATION = 'NEW_NOTIFICATION';

var initialState = function initialState() {
  return {
    idForNextNotification: 1,
    entities: {}
  };
};

/* harmony default export */ __webpack_exports__["d"] = ({
  state: initialState(),
  getters: {
    nextNotification: function nextNotification(state) {
      var nextId = Object.keys(state.entities).map(function (key) {
        return parseInt(key);
      }).sort()[0];
      return state.entities[nextId];
    },
    notificationToShow: function notificationToShow(state) {
      return !!Object.keys(state.entities).length;
    }
  },
  mutations: (_mutations = {
    RESET_STATE: function RESET_STATE() {
      // Don't reset state here, because it would erase app update notifications
    }
  }, _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__session__["c" /* REMOVE_SESSION */], function (state) {
    state.entities = initialState().entities;
  }), _defineProperty(_mutations, ADD_NOTIFICATION, function (state, payload) {
    state.entities = Object.assign({}, state.entities, _defineProperty({}, payload.id, payload));
    state.idForNextNotification += 1;
  }), _defineProperty(_mutations, REMOVE_NOTIFICATION, function (state, payload) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].delete(state.entities, payload.id);
  }), _defineProperty(_mutations, REPLACE_NOTIFICATION, function (state, payload) {
    if (payload.id) {
      state.entities[payload.id] = payload;
    } else {
      state.entities = Object.assign({}, state.entities, _defineProperty({}, state.idForNextNotification, Object.assign({}, payload, {
        id: state.idForNextNotification
      })));
      state.idForNextNotification += 1;
    }
  }), _mutations),
  actions: (_actions = {}, _defineProperty(_actions, REMOVE_NOTIFICATION, function (_ref, payload) {
    var commit = _ref.commit,
        state = _ref.state,
        rootState = _ref.rootState;

    commit(REMOVE_NOTIFICATION, payload);
    return;
  }), _defineProperty(_actions, NEW_NOTIFICATION, function (_ref2, payload) {
    var commit = _ref2.commit,
        state = _ref2.state,
        rootState = _ref2.rootState;

    // Only show errors if logged in. This keeps odd errors from showing that happened because
    // user wasn't logged in
    if (payload.bypassLoginCheck || rootState.session.authToken) {
      payload.id = state.idForNextNotification;
      commit(ADD_NOTIFICATION, payload);
      return payload.id;
    }

    // eslint-disable-next-line no-console
    console.log('Not queing notification because user not logged in');
    return;
  }), _actions)
});

/***/ }),

/***/ 136:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return formatTimestamp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return formatChartHourlyTimestamp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return formatChartDailyTimestamp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return formatChartWeeklyTimestamp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return formatLastSeen; });
/* unused harmony export formatCountdown */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return dateDifferenceInWords; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_date_fns__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_date_fns___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_date_fns__);


var TIME_FMT = 'hh:mm ss[s] A';

var formatTimestamp = function formatTimestamp(datetime) {
  if (!datetime) return null;
  var ldatetime = new Date(datetime);
  if (Object(__WEBPACK_IMPORTED_MODULE_0_date_fns__["isToday"])(ldatetime)) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_date_fns__["format"])(ldatetime, '[Today] ' + TIME_FMT);
  } else if (Object(__WEBPACK_IMPORTED_MODULE_0_date_fns__["isYesterday"])(ldatetime)) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_date_fns__["format"])(ldatetime, '[Yesterday] ' + TIME_FMT);
  } else {
    return Object(__WEBPACK_IMPORTED_MODULE_0_date_fns__["format"])(ldatetime, 'ddd MM/DD/YY ' + TIME_FMT);
  }
};

var formatChartHourlyTimestamp = function formatChartHourlyTimestamp(datetime) {
  if (!datetime) return null;
  var ldatetime = new Date(datetime);
  if (Object(__WEBPACK_IMPORTED_MODULE_0_date_fns__["isToday"])(ldatetime)) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_date_fns__["format"])(ldatetime, '[Today] ha');
  } else if (Object(__WEBPACK_IMPORTED_MODULE_0_date_fns__["isYesterday"])(ldatetime)) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_date_fns__["format"])(ldatetime, '[Yesterday] ha');
  } else {
    return Object(__WEBPACK_IMPORTED_MODULE_0_date_fns__["format"])(ldatetime, 'M/D ha');
  }
};

var formatChartDailyTimestamp = function formatChartDailyTimestamp(datetime) {
  if (!datetime) return null;
  var ldatetime = new Date(datetime);

  if (Object(__WEBPACK_IMPORTED_MODULE_0_date_fns__["isToday"])(ldatetime)) {
    return 'Today';
  } else if (Object(__WEBPACK_IMPORTED_MODULE_0_date_fns__["isYesterday"])(ldatetime)) {
    return 'Yesterday';
  } else if (Object(__WEBPACK_IMPORTED_MODULE_0_date_fns__["differenceInWeeks"])(Object(__WEBPACK_IMPORTED_MODULE_0_date_fns__["addDays"])(new Date(), 1), ldatetime) < 1) {
    // Print timestamp as day name if less than 1 week ago.
    // If today is Friday, then previous Saturday will print as day but previous Friday will print as date
    return Object(__WEBPACK_IMPORTED_MODULE_0_date_fns__["format"])(ldatetime, 'ddd');
  } else {
    return Object(__WEBPACK_IMPORTED_MODULE_0_date_fns__["format"])(ldatetime, 'M/D');
  }
};

var formatChartWeeklyTimestamp = function formatChartWeeklyTimestamp(datetime) {
  if (!datetime) return null;

  var ldatetime = new Date(datetime);
  if (Object(__WEBPACK_IMPORTED_MODULE_0_date_fns__["isThisWeek"])(ldatetime)) {
    return 'This week';
  } else if (Object(__WEBPACK_IMPORTED_MODULE_0_date_fns__["differenceInWeeks"])(new Date(), ldatetime) < 2) {
    return 'Last week';
  } else {
    return Object(__WEBPACK_IMPORTED_MODULE_0_date_fns__["format"])(ldatetime, '[Week of] M/D');
  }
};

var formatLastSeen = function formatLastSeen(datetime) {
  if (!datetime) return '';

  var ldatetime = new Date(datetime);
  if (Object(__WEBPACK_IMPORTED_MODULE_0_date_fns__["isFuture"])(ldatetime)) {
    return 'less than a minute ago';
  }
  return Object(__WEBPACK_IMPORTED_MODULE_0_date_fns__["distanceInWordsToNow"])(ldatetime, { addSuffix: true });
};

var formatCountdown = function formatCountdown(datetime) {
  if (!datetime) return '';
  var ldatetime = new Date(datetime);
  return Object(__WEBPACK_IMPORTED_MODULE_0_date_fns__["distanceInWordsToNow"])(ldatetime, { addSuffix: true });
};

var dateDifferenceInWords = function dateDifferenceInWords(datetime) {
  if (!datetime) return null;

  var ldatetime = new Date(datetime);
  if (Object(__WEBPACK_IMPORTED_MODULE_0_date_fns__["isToday"])(ldatetime)) {
    return 'Today';
  } else if (Object(__WEBPACK_IMPORTED_MODULE_0_date_fns__["isYesterday"])(ldatetime)) {
    return 'Yesterday';
  } else if (Object(__WEBPACK_IMPORTED_MODULE_0_date_fns__["isTomorrow"])(ldatetime)) {
    return 'Tomorrow';
  } else {
    return Object(__WEBPACK_IMPORTED_MODULE_0_date_fns__["differenceInCalendarDays"])(ldatetime, new Date()) + ' days from now';
  }
};

/***/ }),

/***/ 17:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CREATE_SESSION; });
/* unused harmony export NEW_SESSION */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return NEW_SESSION_FROM_META_OBJECT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return UPDATE_SESSION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return REMOVE_SESSION; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_object_path__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_object_path___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_object_path__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_notifications__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_date__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_date_fns__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_date_fns___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_date_fns__);
var _mutations, _actions;

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }







var CREATE_SESSION = 'CREATE_SESSION';
var NEW_SESSION = 'NEW_SESSION';
var NEW_SESSION_FROM_META_OBJECT = 'NEW_SESSION_FROM_META_OBJECT';
var UPDATE_SESSION = 'UPDATE_SESSION';
var REMOVE_SESSION = 'REMOVE_SESSION';

var initialState = function initialState() {
  return {
    user: {
      id: ''
    },
    organization: {
      id: ''
    },
    authToken: '',
    expiresAt: '',
    passwordExpiration: ''
  };
};

/* harmony default export */ __webpack_exports__["e"] = ({
  state: initialState(),
  getters: {
    currentUser: function currentUser(state) {
      return state.user || {};
    },
    currentOrganization: function currentOrganization(state) {
      return state.organization || {};
    }
  },
  mutations: (_mutations = {}, _defineProperty(_mutations, UPDATE_SESSION, function (state, payload) {
    if (payload.user) {
      state.user = Object.assign({}, state.user, payload.user);
    }
    if (payload.organization) {
      state.organization = Object.assign({}, state.organization, payload.organization);
    }
    if (payload.authToken) {
      state.authToken = payload.authToken;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.defaults.headers.common['X-AUTH-TOKEN'] = payload.authToken;
    }
    if (payload.expiresAt) {
      state.expiresAt = payload.expiresAt;
    }
    if (payload.passwordExpiration) {
      state.passwordExpiration = payload.passwordExpiration;
    }
  }), _defineProperty(_mutations, REMOVE_SESSION, function (state) {
    // Remove everything except for user id so we can use user id on login to determine
    // whether all state needs reset or not
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.delete('/sessions?data=1').then(function (response) {
      console.log(response);
    }).catch(function (error) {
      // eslint-disable-next-line
      console.error(error);
    });
    Object.assign(state, initialState(), { user: { id: state.user.id } });
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.defaults.headers.common['X-AUTH-TOKEN'] = undefined;
  }), _mutations),
  actions: (_actions = {}, _defineProperty(_actions, NEW_SESSION, function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(_ref, payload) {
      var commit = _ref.commit,
          state = _ref.state;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (payload.user.id !== state.user.id) {
                commit('RESET_STATE', null, { root: true });
              }
              commit(UPDATE_SESSION, payload);

            case 2:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    return function (_x, _x2) {
      return _ref2.apply(this, arguments);
    };
  }()), _defineProperty(_actions, NEW_SESSION_FROM_META_OBJECT, function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(_ref3, payload) {
      var dispatch = _ref3.dispatch;

      var today, nextWeek, fewWeeks, expirationDate, daydiff, _daydiff;

      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return dispatch(NEW_SESSION, {
                user: {
                  id: payload.user_id
                },
                organization: {
                  id: payload.organization_id
                },
                authToken: payload.auth_token,
                expiresAt: payload.expires_at,
                passwordExpiration: payload.password_expiration
              });

            case 2:
              today = new Date();
              nextWeek = Object(__WEBPACK_IMPORTED_MODULE_4_date_fns__["addDays"])(today, 7);
              fewWeeks = Object(__WEBPACK_IMPORTED_MODULE_4_date_fns__["addDays"])(today, 21);
              // var nextMonth = addDays(today,30)

              expirationDate = payload.password_expiration == null ? new Date(2200, 1, 1) : new Date(payload.password_expiration);
              // console.log( "today: " + today + " nextWeek: " + nextWeek + "few weeks: " + fewWeeks + " next Month: " + nextMonth + " expiration Date: " + expirationDate)

              if (!(expirationDate < nextWeek)) {
                _context2.next = 12;
                break;
              }

              daydiff = Object(__WEBPACK_IMPORTED_MODULE_3__utils_date__["a" /* dateDifferenceInWords */])(expirationDate);
              _context2.next = 10;
              return dispatch(__WEBPACK_IMPORTED_MODULE_2__store_notifications__["a" /* NEW_NOTIFICATION */], {
                text: 'ALERT: Password Expires ' + daydiff + '.',
                link: ['Change password', '/me'],
                color: 'error'
              });

            case 10:
              _context2.next = 16;
              break;

            case 12:
              if (!(expirationDate < fewWeeks)) {
                _context2.next = 16;
                break;
              }

              _daydiff = Object(__WEBPACK_IMPORTED_MODULE_3__utils_date__["a" /* dateDifferenceInWords */])(expirationDate);
              _context2.next = 16;
              return dispatch(__WEBPACK_IMPORTED_MODULE_2__store_notifications__["a" /* NEW_NOTIFICATION */], {
                text: 'WARNING: Password Expires ' + _daydiff + '.',
                link: ['Change password', '/me'],
                color: 'warning'
              });

            case 16:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    return function (_x3, _x4) {
      return _ref4.apply(this, arguments);
    };
  }()), _defineProperty(_actions, CREATE_SESSION, function () {
    var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(_ref5, payload) {
      var dispatch = _ref5.dispatch;

      var _ref7, meta, detail, rpt;

      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              _context3.next = 3;
              return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/sessions', {
                meta: {
                  email: payload.email,
                  password: payload.password,
                  mfa_code: payload.mfa_code
                }
              });

            case 3:
              _ref7 = _context3.sent;
              meta = _ref7.data.meta;

              if (!meta.google_mfa) {
                _context3.next = 9;
                break;
              }

              return _context3.abrupt('return', { meta: meta });

            case 9:
              if (meta.auth_token) {
                _context3.next = 11;
                break;
              }

              throw new Error('No auth_token');

            case 11:
              _context3.next = 13;
              return dispatch(NEW_SESSION_FROM_META_OBJECT, meta);

            case 13:
              return _context3.abrupt('return', { success: true });

            case 16:
              _context3.prev = 16;
              _context3.t0 = _context3['catch'](0);
              detail = __WEBPACK_IMPORTED_MODULE_1_object_path___default.a.get(_context3.t0, 'response.data.errors.0.detail');
              rpt = __WEBPACK_IMPORTED_MODULE_1_object_path___default.a.get(_context3.t0, 'response.data.errors.0.reset_password_token');

              if (!(detail && (detail.includes('password invalid') || detail.includes('not found')))) {
                _context3.next = 24;
                break;
              }

              return _context3.abrupt('return', { error: 'Email or password is incorrect.' });

            case 24:
              if (!rpt) {
                _context3.next = 28;
                break;
              }

              return _context3.abrupt('return', {
                error: 'Login failed: \'' + _context3.t0.message + '\'',
                reset_password_token: rpt
              });

            case 28:
              return _context3.abrupt('return', {
                error: 'Login failed: \'' + _context3.t0.message + '\''
              });

            case 29:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, this, [[0, 16]]);
    }));

    return function (_x5, _x6) {
      return _ref6.apply(this, arguments);
    };
  }()), _actions)
});

/***/ }),

/***/ 18:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return roles; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return passwordExpirationOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return sessionExpirationOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return sysAdmin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return sysRo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return orgAdmin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return readOnlyUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return orgManager; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return computePaginateSortFilterParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return nullifyBlankStrings; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return computedCollectionCount; });
var roles = [{ text: "System Admin", value: 1 }, { text: "System Read-only User", value: 2 }, { text: "Admin", value: 4, org: true }, { text: "Manager", value: 8, org: true }, { text: "Read-only User", value: 16, org: true }];

var passwordExpirationOptions = [{ text: "Never", value: -1 }, { text: "3 months", value: 7884009 }, { text: "6 months", value: 15768017 }, { text: "1 year", value: 31556926 }];

var sessionExpirationOptions = [{ text: "Never", value: -1 }, { text: "1 hour", value: 10800 }, { text: "24 hours", value: 86400 }, { text: "1 week", value: 604800 }, { text: "1 month", value: 2629744 }];

var sysAdmin = function sysAdmin() {
  return this.$store.getters.currentUser.roles_mask === 1;
};

var sysRo = function sysRo() {
  return this.$store.getters.currentUser.roles_mask === 2;
};

var orgAdmin = function orgAdmin() {
  return this.$store.getters.currentUser.roles_mask === 4;
};

var readOnlyUser = function readOnlyUser() {
  return this.$store.getters.currentUser.roles_mask === 16 || this.$store.getters.currentUser.roles_mask === 2;
};

var orgManager = function orgManager() {
  return this.$store.getters.currentUser.roles_mask === 8;
};

var computePaginateSortFilterParams = function computePaginateSortFilterParams(params) {
  if (!params || !Object.keys(params).length) return {};
  var _params$sortModel = params.sortModel,
      sortModel = _params$sortModel === undefined ? [] : _params$sortModel,
      _params$filterModel = params.filterModel,
      filterModel = _params$filterModel === undefined ? {} : _params$filterModel,
      startRow = params.startRow,
      endRow = params.endRow;

  var sortString = sortModel.map(function (_ref) {
    var sort = _ref.sort,
        colId = _ref.colId;

    var sortString = "";

    if (sort === "desc") sortString += "-";

    switch (colId) {
      case "dev_eui":
      case "end_device_eui":
        // Sort first by name, then by EUI
        sortString += "end_device.name,";
        if (sort === "desc") sortString += "-";
        sortString += colId;
        break;
      case "gw_eui":
        // Sort first by name, then by EUI
        sortString += "gateway.name,";
        if (sort === "desc") sortString += "-";
        sortString += colId;
        break;
      case "application_network_id":
        sortString += "application_network.name";
        break;
      case "app_eui":
        sortString += "application_network.name";
        break;
      default:
        sortString += colId;
    }

    return sortString;
  }).join(",");

  var filters = {};
  for (var key in filterModel) {
    filters["q[" + key + "]"] = filterModel[key].filter;
  }

  return Object.assign({
    skip: startRow,
    limit: endRow - startRow,
    sort: sortString
  }, filters);
};

var nullifyBlankStrings = function nullifyBlankStrings(obj) {
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = Object.keys(obj)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var k = _step.value;

      if (obj[k] === "") {
        obj[k] = null;
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }
};

var computedCollectionCount = function computedCollectionCount(_ref2) {
  var endRow = _ref2.endRow,
      collectionCount = _ref2.collectionCount,
      filteredCount = _ref2.filteredCount;

  if (typeof filteredCount === "number" && endRow > filteredCount) {
    // Scrolled to last block, so return collectionCount to cap table at last row
    return filteredCount;
  } else if (endRow > collectionCount) {
    // Scrolled to last block, so return collectionCount to cap table at last row
    return collectionCount;
  }

  // Don't return collectionCount so scrolling is capped to loaded rows
  // If we returned a collectionCount here, you could scroll to end of collection without any of the data being loaded yet
  return null;
};

/***/ }),

/***/ 222:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return eui; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return number; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return uuid; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return uniqueEui; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return appKey; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return extractValidations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return operationMessage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return customUrlValidation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return euiHint; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return validationMessages; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_eui64__ = __webpack_require__(606);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_eui64___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_eui64__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
var _this = this;

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }




var eui = function eui(value) {
  return value === undefined || !!__WEBPACK_IMPORTED_MODULE_0_eui64___default()(value);
};
var number = function number(value) {
  return value === undefined || !isNaN(value);
};
var uuid = function uuid(value) {
  return (/[0-9|a-f]{32}/i.test(value.replace(/-/g, '')) && value.replace(/-|~[0-9|a-f]/gi, '').length === 32
  );
};

var uniqueEui = function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(value) {
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (value) {
              _context.next = 2;
              break;
            }

            return _context.abrupt('return', true);

          case 2:
            _context.prev = 2;
            _context.next = 5;
            return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('/euis/' + value + '/validate');

          case 5:
            return _context.abrupt('return', true);

          case 8:
            _context.prev = 8;
            _context.t0 = _context['catch'](2);
            return _context.abrupt('return', false);

          case 11:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, _this, [[2, 8]]);
  }));

  return function uniqueEui(_x) {
    return _ref.apply(this, arguments);
  };
}();

var appKey = function appKey(value) {
  if (!value) return true;
  // Check for any characters besides HEX, '-', or '.'
  if (value.match(/[^\da-f-.]/gi)) return false;
  // Strip everything but hex and verify length
  if (value.replace(/[^\da-f]/gi, '').length !== 32) return false;
  return true;
};

var extractValidations = function extractValidations(config) {
  var validations = {};
  config.filter(function (field) {
    return 'validations' in field;
  }).map(function (field) {
    validations[field.attribute] = field.validations;
  });
  return validations;
};

var operationMessage = function operationMessage(value) {
  if (!value) return true;
  if (!value.match(/^([a-f]|\d){0,484}$/i)) return false;
  // if (value.length < 1) return false
  if (value.length > 484) return false;
  if (value.length % 2 !== 0) return false;
  return true;
};

var customUrlValidation = function customUrlValidation(url) {
  var validURL = new RegExp(/^(|.+:\/\/.+$)/);
  return validURL.test(url);
};

// https://datatracker.ietf.org/doc/rfc7043/?include_text=1
// 4.2.  EUI64 RR Presentation Format
// The Address field MUST be represented as eight two-digit hexadecimal
// numbers separated by hyphens.  The hexadecimal digits "A" through "F"
// MAY be represented in either upper or lower case.

var euiHint = 'Eight two-digit hexadecimal numbers separated by hyphens';

var validationMessages = {
  required: 'Required',
  requiredIf: 'Required',
  url: 'Not a valid URL',
  customUrlValidation: 'Not a valid URL or IP address',
  minValue: 'Minimum value is {min}',
  maxValue: 'Maximum value is {max}',
  minLength: 'Must be at least {min} characters',
  maxLength: 'Must be no more than {max} characters',
  eui: 'Must contain eight two-digit hexadecimal numbers separated by hyphens',
  uniqueEui: 'This EUI is already taken',
  number: 'Must be a number',
  uuid: 'Must be a 128-bit hexadecimal string or UUID',
  appKey: "AppKeys must contain 16 octets, optionally separated by '.' or '-'",
  email: 'Not a valid email'
};

/***/ }),

/***/ 224:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export REPLACE_GATEWAYS */
/* unused harmony export ADD_GATEWAYS */
/* unused harmony export MODIFY_GATEWAY */
/* unused harmony export REMOVE_GATEWAY */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return SET_GATEWAYS_TOTAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return FETCH_GATEWAYS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return FETCH_APPLICATION_NETWORK_GATEWAYS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return FETCH_GATEWAY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CREATE_GATEWAY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return UPDATE_GATEWAY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DELETE_GATEWAY; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jsonapi_normalizer__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jsonapi_normalizer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jsonapi_normalizer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_object_path__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_object_path___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_object_path__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_query_string__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_query_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_is_present__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_is_present___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_is_present__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__session__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_api__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__notifications__ = __webpack_require__(13);
var _mutations, _actions;

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }













var REPLACE_GATEWAYS = 'REPLACE_GATEWAYS';
var ADD_GATEWAYS = 'ADD_GATEWAYS';
var MODIFY_GATEWAY = 'MODIFY_GATEWAY';
var REMOVE_GATEWAY = 'REMOVE_GATEWAY';
var SET_GATEWAYS_TOTAL = 'SET_GATEWAYS_TOTAL';

var FETCH_GATEWAYS = 'FETCH_GATEWAYS';
var FETCH_APPLICATION_NETWORK_GATEWAYS = 'FETCH_APPLICATION_NETWORK_GATEWAYS';
var FETCH_GATEWAY = 'FETCH_GATEWAY';
var CREATE_GATEWAY = 'CREATE_GATEWAY';
var UPDATE_GATEWAY = 'UPDATE_GATEWAY';
var DELETE_GATEWAY = 'DELETE_GATEWAY';

var initialState = function initialState() {
  return {
    entities: {},
    statistics: {
      total: null
    }
  };
};

/* harmony default export */ __webpack_exports__["h"] = ({
  state: initialState(),
  getters: {
    gatewayDefaults: function gatewayDefaults() {
      return {};
    },
    gateways: function gateways(_ref
    //$FlowFixMe
    ) {
      var _ref$entities = _ref.entities,
          entities = _ref$entities === undefined ? {} : _ref$entities;
      return Object.keys(entities).map(function (key) {
        return entities[key];
      });
    },
    gatewaysKeyedByEui: function gatewaysKeyedByEui(state, getters) {
      var gateways = {};
      getters.gateways.forEach(function (device) {
        gateways[device.eui] = device;
      });
      return gateways;
    },
    gatewayByEui: function gatewayByEui(state, getters) {
      return function (eui) {
        return getters.gateways.find(function (device) {
          return device.eui === eui;
        }) || {};
      };
    },
    gatewaysByAppEui: function gatewaysByAppEui(state, getters) {
      return function (appEui) {
        return getters.gateways.filter(function (device) {
          return Array.isArray(device.application_networks) && device.application_networks.includes(appEui);
        });
      };
    }
  },
  mutations: (_mutations = {
    RESET_STATE: function RESET_STATE(state) {
      Object.assign(state, initialState());
    }
  }, _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_6__session__["c" /* REMOVE_SESSION */], function (state) {
    state.entities = initialState().entities;
  }), _defineProperty(_mutations, REPLACE_GATEWAYS, function (state, _ref2) {
    var _ref2$entities = _ref2.entities,
        entities = _ref2$entities === undefined ? {} : _ref2$entities;

    state.entities = entities;
  }), _defineProperty(_mutations, ADD_GATEWAYS, function (state, payload) {
    state.entities = Object.assign({}, state.entities, payload.entities);
  }), _defineProperty(_mutations, MODIFY_GATEWAY, function (state, payload) {
    state.entities[payload.id] = Object.assign({}, state.entities[payload.id], payload);
  }), _defineProperty(_mutations, REMOVE_GATEWAY, function (state, payload) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].delete(state.entities, payload.id);
  }), _defineProperty(_mutations, SET_GATEWAYS_TOTAL, function (state, payload) {
    state.statistics.total = payload.total;
  }), _mutations),
  actions: (_actions = {}, _defineProperty(_actions, FETCH_GATEWAYS, function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(_ref3) {
      var commit = _ref3.commit,
          dispatch = _ref3.dispatch;
      var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var pathstring, _ref5, data, pagination;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              pathstring = '/gateways';

              if (payload.context && payload.context.orgId) {
                pathstring = '/organizations/' + payload.context.orgId + pathstring;
              }

              _context.next = 5;
              return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(pathstring, {
                params: Object(__WEBPACK_IMPORTED_MODULE_7__utils_api__["a" /* computePaginateSortFilterParams */])(payload)
              });

            case 5:
              _ref5 = _context.sent;
              data = _ref5.data;
              pagination = data.meta.pagination;

              commit(SET_GATEWAYS_TOTAL, { total: pagination.collection_count });
              commit(REPLACE_GATEWAYS, { entities: __WEBPACK_IMPORTED_MODULE_2_jsonapi_normalizer___default()(data).entities.gateways });

              return _context.abrupt('return', {
                success: true,
                // Return fetched data as flat array
                items: data.data.map(function (item) {
                  return item.attributes;
                }),
                collectionCount: Object(__WEBPACK_IMPORTED_MODULE_7__utils_api__["b" /* computedCollectionCount */])({
                  endRow: payload.endRow,
                  filteredCount: pagination.filtered_count,
                  collectionCount: pagination.collection_count
                })
              });

            case 13:
              _context.prev = 13;
              _context.t0 = _context['catch'](0);

              dispatch(__WEBPACK_IMPORTED_MODULE_8__notifications__["a" /* NEW_NOTIFICATION */], {
                text: 'Failed to load gateways ',
                detail: _context.t0.message,
                color: 'error'
              });

            case 16:
              return _context.abrupt('return', { success: false });

            case 17:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this, [[0, 13]]);
    }));

    return function (_x2) {
      return _ref4.apply(this, arguments);
    };
  }()), _defineProperty(_actions, FETCH_APPLICATION_NETWORK_GATEWAYS, function () {
    var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(_ref6, payload) {
      var commit = _ref6.commit,
          dispatch = _ref6.dispatch;

      var _ref8, data, gateways, pagination;

      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('/application_networks/' + payload.context.appEui + '/gateways', {
                params: Object(__WEBPACK_IMPORTED_MODULE_7__utils_api__["a" /* computePaginateSortFilterParams */])(payload)
              });

            case 3:
              _ref8 = _context2.sent;
              data = _ref8.data;
              gateways = __WEBPACK_IMPORTED_MODULE_2_jsonapi_normalizer___default()(data).entities.gateways;

              // ADD APPLICATION NETWORK EUI TO GW DATA

              if (__WEBPACK_IMPORTED_MODULE_5_is_present___default()(gateways)) {
                Object.keys(gateways).map(function (key) {
                  var gateway = gateways[key];
                  if (!__WEBPACK_IMPORTED_MODULE_5_is_present___default()(gateway.application_networks)) {
                    gateway.application_networks = [];
                  }
                  if (!gateway.application_networks.includes(payload.context.appEui)) {
                    gateway.application_networks.push(payload.context.appEui);
                  }
                });
              }

              commit(ADD_GATEWAYS, { entities: gateways });

              pagination = data.meta.pagination;
              return _context2.abrupt('return', {
                success: true,
                // Return fetched data as flat array
                items: data.data.map(function (item) {
                  return item.attributes;
                }),
                collectionCount: Object(__WEBPACK_IMPORTED_MODULE_7__utils_api__["b" /* computedCollectionCount */])({
                  endRow: payload.endRow,
                  filteredCount: pagination.filtered_count,
                  collectionCount: pagination.collection_count
                })
              });

            case 12:
              _context2.prev = 12;
              _context2.t0 = _context2['catch'](0);

              dispatch(__WEBPACK_IMPORTED_MODULE_8__notifications__["a" /* NEW_NOTIFICATION */], {
                text: 'Failed to load gateways ',
                detail: _context2.t0.message,
                color: 'error'
              });

            case 15:
              return _context2.abrupt('return', { success: false });

            case 16:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, this, [[0, 12]]);
    }));

    return function (_x3, _x4) {
      return _ref7.apply(this, arguments);
    };
  }()), _defineProperty(_actions, FETCH_GATEWAY, function () {
    var _ref10 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(_ref9, payload) {
      var commit = _ref9.commit,
          dispatch = _ref9.dispatch;

      var _ref11, data, _normalize, entities, status;

      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              _context3.next = 3;
              return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('/gateways/' + payload.id);

            case 3:
              _ref11 = _context3.sent;
              data = _ref11.data;
              _normalize = __WEBPACK_IMPORTED_MODULE_2_jsonapi_normalizer___default()(data), entities = _normalize.entities;

              commit(ADD_GATEWAYS, { entities: entities.gateways });
              if (data.data.attributes.api_error_status) {
                dispatch(__WEBPACK_IMPORTED_MODULE_8__notifications__["a" /* NEW_NOTIFICATION */], {
                  text: 'Machine API Error at ' + data.data.attributes.api_error_timestamp,
                  detail: data.data.attributes.api_error_message,
                  color: 'error'
                });
              }
              return _context3.abrupt('return', { success: true });

            case 11:
              _context3.prev = 11;
              _context3.t0 = _context3['catch'](0);
              status = __WEBPACK_IMPORTED_MODULE_3_object_path___default.a.get(_context3.t0, 'response.status');

              if (status !== 404) {
                dispatch(__WEBPACK_IMPORTED_MODULE_8__notifications__["a" /* NEW_NOTIFICATION */], {
                  text: 'Failed to load gateway ',
                  detail: _context3.t0.message,
                  color: 'error'
                });
              }
              return _context3.abrupt('return', { success: false, status: status });

            case 16:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, this, [[0, 11]]);
    }));

    return function (_x5, _x6) {
      return _ref10.apply(this, arguments);
    };
  }()), _defineProperty(_actions, CREATE_GATEWAY, function () {
    var _ref13 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(_ref12, payload) {
      var commit = _ref12.commit,
          dispatch = _ref12.dispatch;

      var _ref14, data, _normalize2, entities;

      return regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.prev = 0;
              _context4.next = 3;
              return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post('/gateways', {
                data: {
                  type: 'gateway',
                  attributes: payload.attributes,
                  relationships: payload.relationships
                }
              });

            case 3:
              _ref14 = _context4.sent;
              data = _ref14.data;
              _normalize2 = __WEBPACK_IMPORTED_MODULE_2_jsonapi_normalizer___default()(data), entities = _normalize2.entities;

              commit(ADD_GATEWAYS, { entities: entities.gateways });
              if (!payload.suppressNotifications) {
                dispatch(__WEBPACK_IMPORTED_MODULE_8__notifications__["a" /* NEW_NOTIFICATION */], {
                  text: 'Saved new gateway!',
                  color: 'success'
                });
              }
              return _context4.abrupt('return', data.data.attributes.eui);

            case 11:
              _context4.prev = 11;
              _context4.t0 = _context4['catch'](0);

              dispatch(__WEBPACK_IMPORTED_MODULE_8__notifications__["a" /* NEW_NOTIFICATION */], {
                text: 'Failed to save gateway ',
                detail: _context4.t0.message,
                color: 'error'
              });

            case 14:
              return _context4.abrupt('return', false);

            case 15:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, this, [[0, 11]]);
    }));

    return function (_x7, _x8) {
      return _ref13.apply(this, arguments);
    };
  }()), _defineProperty(_actions, UPDATE_GATEWAY, function () {
    var _ref16 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(_ref15, payload) {
      var commit = _ref15.commit,
          dispatch = _ref15.dispatch;

      var notificationId, _ref17, data, _normalize3, entities;

      return regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              notificationId = void 0;

              if (payload.suppressNotifications) {
                _context5.next = 5;
                break;
              }

              _context5.next = 4;
              return dispatch(__WEBPACK_IMPORTED_MODULE_8__notifications__["a" /* NEW_NOTIFICATION */], {
                text: 'Saving...',
                color: 'secondary',
                undoable: true
              });

            case 4:
              notificationId = _context5.sent;

            case 5:
              _context5.prev = 5;
              _context5.next = 8;
              return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.patch('/gateways/' + payload.id, {
                data: {
                  type: 'gateway',
                  attributes: payload.attributes,
                  relationships: payload.relationships
                }
              });

            case 8:
              _ref17 = _context5.sent;
              data = _ref17.data;
              _normalize3 = __WEBPACK_IMPORTED_MODULE_2_jsonapi_normalizer___default()(data), entities = _normalize3.entities;

              commit(MODIFY_GATEWAY, entities.gateways[payload.id]);
              if (!payload.suppressNotifications) {
                commit(__WEBPACK_IMPORTED_MODULE_8__notifications__["c" /* REPLACE_NOTIFICATION */], {
                  id: notificationId,
                  text: 'Saved!',
                  color: 'success',
                  undoable: true
                });
              }
              return _context5.abrupt('return', true);

            case 16:
              _context5.prev = 16;
              _context5.t0 = _context5['catch'](5);

              commit(__WEBPACK_IMPORTED_MODULE_8__notifications__["c" /* REPLACE_NOTIFICATION */], {
                id: notificationId,
                text: 'Failed to update gateway ',
                detail: _context5.t0.message,
                color: 'error'
              });

            case 19:
              return _context5.abrupt('return', false);

            case 20:
            case 'end':
              return _context5.stop();
          }
        }
      }, _callee5, this, [[5, 16]]);
    }));

    return function (_x9, _x10) {
      return _ref16.apply(this, arguments);
    };
  }()), _defineProperty(_actions, DELETE_GATEWAY, function () {
    var _ref19 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(_ref18, payload) {
      var commit = _ref18.commit,
          dispatch = _ref18.dispatch;
      var notificationId;
      return regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              notificationId = void 0;

              if (payload.suppressNotifications) {
                _context6.next = 5;
                break;
              }

              _context6.next = 4;
              return dispatch(__WEBPACK_IMPORTED_MODULE_8__notifications__["a" /* NEW_NOTIFICATION */], {
                text: 'Deleting gateway...',
                color: 'secondary'
              });

            case 4:
              notificationId = _context6.sent;

            case 5:
              _context6.prev = 5;
              _context6.next = 8;
              return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.delete('/gateways/' + payload.id + '?' + __WEBPACK_IMPORTED_MODULE_4_query_string___default.a.stringify(payload.options));

            case 8:
              commit(REMOVE_GATEWAY, payload);
              if (!payload.suppressNotifications) {
                commit(__WEBPACK_IMPORTED_MODULE_8__notifications__["c" /* REPLACE_NOTIFICATION */], {
                  id: notificationId,
                  text: 'Deleted gateway!',
                  color: 'success'
                });
              }
              return _context6.abrupt('return', true);

            case 13:
              _context6.prev = 13;
              _context6.t0 = _context6['catch'](5);

              commit(__WEBPACK_IMPORTED_MODULE_8__notifications__["c" /* REPLACE_NOTIFICATION */], {
                id: notificationId,
                text: 'Failed to delete gateway ',
                detail: _context6.t0.message,
                color: 'error'
              });

            case 16:
              return _context6.abrupt('return', false);

            case 17:
            case 'end':
              return _context6.stop();
          }
        }
      }, _callee6, this, [[5, 13]]);
    }));

    return function (_x11, _x12) {
      return _ref19.apply(this, arguments);
    };
  }()), _actions)
});

/***/ }),

/***/ 225:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export REPLACE_END_DEVICES */
/* unused harmony export ADD_END_DEVICES */
/* unused harmony export MODIFY_END_DEVICE */
/* unused harmony export REMOVE_END_DEVICE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return SET_END_DEVICES_TOTAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return FETCH_END_DEVICES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return FETCH_APPLICATION_NETWORK_END_DEVICES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return FETCH_DEVICE_GROUP_END_DEVICES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return FETCH_END_DEVICE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CREATE_END_DEVICE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return UPDATE_END_DEVICE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DELETE_END_DEVICE; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jsonapi_normalizer__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jsonapi_normalizer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jsonapi_normalizer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_object_path__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_object_path___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_object_path__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_query_string__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_query_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__session__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_api__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__notifications__ = __webpack_require__(13);
var _mutations, _actions;

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }












var REPLACE_END_DEVICES = 'REPLACE_END_DEVICES';
var ADD_END_DEVICES = 'ADD_END_DEVICES';
var MODIFY_END_DEVICE = 'MODIFY_END_DEVICE';
var REMOVE_END_DEVICE = 'REMOVE_END_DEVICE';
var SET_END_DEVICES_TOTAL = 'SET_END_DEVICES_TOTAL';

var FETCH_END_DEVICES = 'FETCH_END_DEVICES';
var FETCH_APPLICATION_NETWORK_END_DEVICES = 'FETCH_APPLICATION_NETWORK_END_DEVICES';
var FETCH_DEVICE_GROUP_END_DEVICES = 'FETCH_DEVICE_GROUP_END_DEVICES';
var FETCH_END_DEVICE = 'FETCH_END_DEVICE';
var CREATE_END_DEVICE = 'CREATE_END_DEVICE';
var UPDATE_END_DEVICE = 'UPDATE_END_DEVICE';
var DELETE_END_DEVICE = 'DELETE_END_DEVICE';

var initialState = function initialState() {
  return {
    entities: {},
    statistics: {
      total: null
    }
  };
};

/* harmony default export */ __webpack_exports__["i"] = ({
  state: initialState(),
  getters: {
    endDeviceDefaults: function endDeviceDefaults() {
      return {};
    },
    endDevices: function endDevices(_ref
    //$FlowFixMe
    ) {
      var _ref$entities = _ref.entities,
          entities = _ref$entities === undefined ? {} : _ref$entities;
      return Object.keys(entities).map(function (key) {
        return entities[key];
      });
    },
    // Returns an object with all end-devices, keyed by end-device EUI
    endDevicesKeyedByEui: function endDevicesKeyedByEui(state, getters) {
      var endDevices = {};
      getters.endDevices.forEach(function (device) {
        endDevices[device.eui] = device;
      });
      return endDevices;
    },
    endDeviceByEui: function endDeviceByEui(state, getters) {
      return function (eui) {
        return getters.endDevices.find(function (device) {
          return device.eui === eui;
        }) || {};
      };
    },
    endDevicesByAppEui: function endDevicesByAppEui(state, getters) {
      return function (appEui) {
        var targetAppNetId = getters.applicationNetworkByEui(appEui).id;
        return getters.endDevices.filter(function (device) {
          return device.application_network_id === targetAppNetId;
        });
      };
    }
  },
  mutations: (_mutations = {
    RESET_STATE: function RESET_STATE(state) {
      Object.assign(state, initialState());
    }
  }, _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_5__session__["c" /* REMOVE_SESSION */], function (state) {
    state.entities = initialState().entities;
  }), _defineProperty(_mutations, REPLACE_END_DEVICES, function (state, _ref2) {
    var _ref2$entities = _ref2.entities,
        entities = _ref2$entities === undefined ? {} : _ref2$entities;

    state.entities = entities;
  }), _defineProperty(_mutations, ADD_END_DEVICES, function (state, payload) {
    state.entities = Object.assign({}, state.entities, payload.entities);
  }), _defineProperty(_mutations, MODIFY_END_DEVICE, function (state, payload) {
    state.entities[payload.id] = Object.assign({}, state.entities[payload.id], payload);
  }), _defineProperty(_mutations, REMOVE_END_DEVICE, function (state, payload) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].delete(state.entities, payload.id);
  }), _defineProperty(_mutations, SET_END_DEVICES_TOTAL, function (state, payload) {
    state.statistics.total = payload.total;
  }), _mutations),
  actions: (_actions = {}, _defineProperty(_actions, FETCH_END_DEVICES, function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(_ref3) {
      var commit = _ref3.commit,
          dispatch = _ref3.dispatch;
      var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var pathstring, _ref5, data, pagination;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              pathstring = '/end_devices';

              if (payload.context && payload.context.orgId) {
                pathstring = '/organizations/' + payload.context.orgId + '/end_devices';
              }

              _context.next = 5;
              return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(pathstring, {
                params: Object.assign({}, Object(__WEBPACK_IMPORTED_MODULE_6__utils_api__["a" /* computePaginateSortFilterParams */])(payload), {
                  exclude_group: payload.excludeDeviceGroup ? payload.context.deviceGroupEui : null
                })
              });

            case 5:
              _ref5 = _context.sent;
              data = _ref5.data;
              pagination = data.meta.pagination;

              commit(SET_END_DEVICES_TOTAL, { total: pagination.collection_count });
              commit(REPLACE_END_DEVICES, {
                entities: __WEBPACK_IMPORTED_MODULE_2_jsonapi_normalizer___default()(data).entities.end_devices
              });

              return _context.abrupt('return', {
                success: true,
                // Return fetched data as flat array
                items: data.data.map(function (item) {
                  return item.attributes;
                }),
                collectionCount: Object(__WEBPACK_IMPORTED_MODULE_6__utils_api__["b" /* computedCollectionCount */])({
                  endRow: payload.endRow,
                  filteredCount: pagination.filtered_count,
                  collectionCount: pagination.collection_count
                })
              });

            case 13:
              _context.prev = 13;
              _context.t0 = _context['catch'](0);

              dispatch(__WEBPACK_IMPORTED_MODULE_7__notifications__["a" /* NEW_NOTIFICATION */], {
                text: 'Failed to load end-devices ',
                detail: _context.t0.message,
                color: 'error'
              });

            case 16:
              return _context.abrupt('return', { success: false });

            case 17:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this, [[0, 13]]);
    }));

    return function (_x2) {
      return _ref4.apply(this, arguments);
    };
  }()), _defineProperty(_actions, FETCH_APPLICATION_NETWORK_END_DEVICES, function () {
    var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(_ref6, payload) {
      var commit = _ref6.commit,
          dispatch = _ref6.dispatch;

      var _ref8, data, pagination;

      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('/application_networks/' + payload.context.appEui + '/end_devices', {
                params: Object(__WEBPACK_IMPORTED_MODULE_6__utils_api__["a" /* computePaginateSortFilterParams */])(payload)
              });

            case 3:
              _ref8 = _context2.sent;
              data = _ref8.data;


              commit(ADD_END_DEVICES, {
                entities: __WEBPACK_IMPORTED_MODULE_2_jsonapi_normalizer___default()(data).entities.end_devices
              });

              pagination = data.meta.pagination;
              return _context2.abrupt('return', {
                success: true,
                // Return fetched data as flat array
                items: data.data.map(function (item) {
                  return item.attributes;
                }),
                collectionCount: Object(__WEBPACK_IMPORTED_MODULE_6__utils_api__["b" /* computedCollectionCount */])({
                  endRow: payload.endRow,
                  filteredCount: pagination.filtered_count,
                  collectionCount: pagination.collection_count
                })
              });

            case 10:
              _context2.prev = 10;
              _context2.t0 = _context2['catch'](0);

              dispatch(__WEBPACK_IMPORTED_MODULE_7__notifications__["a" /* NEW_NOTIFICATION */], {
                text: 'Failed to load end-devices ',
                detail: _context2.t0.message,
                color: 'error'
              });

            case 13:
              return _context2.abrupt('return', { success: false });

            case 14:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, this, [[0, 10]]);
    }));

    return function (_x3, _x4) {
      return _ref7.apply(this, arguments);
    };
  }()), _defineProperty(_actions, FETCH_DEVICE_GROUP_END_DEVICES, function () {
    var _ref10 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(_ref9, payload) {
      var commit = _ref9.commit,
          dispatch = _ref9.dispatch;

      var _ref11, data, pagination;

      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              _context3.next = 3;
              return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('/device_groups/' + payload.context.deviceGroupEui + '/end_devices', {
                params: Object(__WEBPACK_IMPORTED_MODULE_6__utils_api__["a" /* computePaginateSortFilterParams */])(payload)
              });

            case 3:
              _ref11 = _context3.sent;
              data = _ref11.data;


              commit(ADD_END_DEVICES, {
                entities: __WEBPACK_IMPORTED_MODULE_2_jsonapi_normalizer___default()(data).entities.end_devices
              });

              pagination = data.meta.pagination;
              return _context3.abrupt('return', {
                success: true,
                // Return fetched data as flat array
                items: data.data.map(function (item) {
                  return item.attributes;
                }),
                collectionCount: Object(__WEBPACK_IMPORTED_MODULE_6__utils_api__["b" /* computedCollectionCount */])({
                  endRow: payload.endRow,
                  filteredCount: pagination.filtered_count,
                  collectionCount: pagination.collection_count
                })
              });

            case 10:
              _context3.prev = 10;
              _context3.t0 = _context3['catch'](0);

              dispatch(__WEBPACK_IMPORTED_MODULE_7__notifications__["a" /* NEW_NOTIFICATION */], {
                text: 'Failed to load end-devices ',
                detail: _context3.t0.message,
                color: 'error'
              });

            case 13:
              return _context3.abrupt('return', { success: false });

            case 14:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, this, [[0, 10]]);
    }));

    return function (_x5, _x6) {
      return _ref10.apply(this, arguments);
    };
  }()), _defineProperty(_actions, FETCH_END_DEVICE, function () {
    var _ref13 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(_ref12, payload) {
      var commit = _ref12.commit,
          dispatch = _ref12.dispatch;

      var _ref14, data, _normalize, entities, status;

      return regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.prev = 0;
              _context4.next = 3;
              return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('/end_devices/' + payload.id);

            case 3:
              _ref14 = _context4.sent;
              data = _ref14.data;
              _normalize = __WEBPACK_IMPORTED_MODULE_2_jsonapi_normalizer___default()(data), entities = _normalize.entities;

              commit(ADD_END_DEVICES, { entities: entities.end_devices });
              return _context4.abrupt('return', { success: true });

            case 10:
              _context4.prev = 10;
              _context4.t0 = _context4['catch'](0);
              status = __WEBPACK_IMPORTED_MODULE_3_object_path___default.a.get(_context4.t0, 'response.status');

              if (status !== 404) {
                dispatch(__WEBPACK_IMPORTED_MODULE_7__notifications__["a" /* NEW_NOTIFICATION */], {
                  text: 'Failed to load end-device ',
                  detail: _context4.t0.message,
                  color: 'error'
                });
              }
              return _context4.abrupt('return', { success: false, status: status });

            case 15:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, this, [[0, 10]]);
    }));

    return function (_x7, _x8) {
      return _ref13.apply(this, arguments);
    };
  }()), _defineProperty(_actions, CREATE_END_DEVICE, function () {
    var _ref16 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(_ref15, payload) {
      var commit = _ref15.commit,
          dispatch = _ref15.dispatch;

      var _ref17, data, _normalize2, entities;

      return regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.prev = 0;
              _context5.next = 3;
              return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post('/end_devices', {
                data: {
                  type: 'end_devices',
                  attributes: payload.attributes,
                  relationships: payload.relationships
                }
              });

            case 3:
              _ref17 = _context5.sent;
              data = _ref17.data;
              _normalize2 = __WEBPACK_IMPORTED_MODULE_2_jsonapi_normalizer___default()(data), entities = _normalize2.entities;

              commit(ADD_END_DEVICES, { entities: entities.end_devices });
              if (!payload.suppressNotifications) {
                dispatch(__WEBPACK_IMPORTED_MODULE_7__notifications__["a" /* NEW_NOTIFICATION */], {
                  text: 'Saved new end-device!',
                  color: 'success'
                });
              }
              return _context5.abrupt('return', data.data.attributes.eui);

            case 11:
              _context5.prev = 11;
              _context5.t0 = _context5['catch'](0);

              dispatch(__WEBPACK_IMPORTED_MODULE_7__notifications__["a" /* NEW_NOTIFICATION */], {
                text: 'Failed to save end-device ',
                detail: _context5.t0.message,
                color: 'error'
              });

            case 14:
              return _context5.abrupt('return', false);

            case 15:
            case 'end':
              return _context5.stop();
          }
        }
      }, _callee5, this, [[0, 11]]);
    }));

    return function (_x9, _x10) {
      return _ref16.apply(this, arguments);
    };
  }()), _defineProperty(_actions, UPDATE_END_DEVICE, function () {
    var _ref19 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(_ref18, payload) {
      var commit = _ref18.commit,
          dispatch = _ref18.dispatch;

      var notificationId, _ref20, data, _normalize3, entities;

      return regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              notificationId = void 0;

              if (payload.suppressNotifications) {
                _context6.next = 5;
                break;
              }

              _context6.next = 4;
              return dispatch(__WEBPACK_IMPORTED_MODULE_7__notifications__["a" /* NEW_NOTIFICATION */], {
                text: 'Saving...',
                color: 'secondary',
                undoable: true
              });

            case 4:
              notificationId = _context6.sent;

            case 5:
              Object(__WEBPACK_IMPORTED_MODULE_6__utils_api__["c" /* nullifyBlankStrings */])(payload.attributes);
              _context6.prev = 6;
              _context6.next = 9;
              return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.patch('/end_devices/' + payload.id, {
                data: {
                  type: 'end_devices',
                  attributes: payload.attributes,
                  relationships: payload.relationships
                }
              });

            case 9:
              _ref20 = _context6.sent;
              data = _ref20.data;
              _normalize3 = __WEBPACK_IMPORTED_MODULE_2_jsonapi_normalizer___default()(data), entities = _normalize3.entities;

              commit(MODIFY_END_DEVICE, entities.end_devices[payload.id]);
              if (!payload.suppressNotifications) {
                commit(__WEBPACK_IMPORTED_MODULE_7__notifications__["c" /* REPLACE_NOTIFICATION */], {
                  id: notificationId,
                  text: 'Saved!',
                  color: 'success',
                  undoable: true
                });
              }
              return _context6.abrupt('return', true);

            case 17:
              _context6.prev = 17;
              _context6.t0 = _context6['catch'](6);

              commit(__WEBPACK_IMPORTED_MODULE_7__notifications__["c" /* REPLACE_NOTIFICATION */], {
                id: notificationId,
                text: 'Failed to update end-device ',
                detail: _context6.t0.message,
                color: 'error'
              });

            case 20:
              return _context6.abrupt('return', false);

            case 21:
            case 'end':
              return _context6.stop();
          }
        }
      }, _callee6, this, [[6, 17]]);
    }));

    return function (_x11, _x12) {
      return _ref19.apply(this, arguments);
    };
  }()), _defineProperty(_actions, DELETE_END_DEVICE, function () {
    var _ref22 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(_ref21, payload) {
      var commit = _ref21.commit,
          dispatch = _ref21.dispatch;
      var notificationId;
      return regeneratorRuntime.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              notificationId = void 0;

              if (payload.suppressNotifications) {
                _context7.next = 5;
                break;
              }

              _context7.next = 4;
              return dispatch(__WEBPACK_IMPORTED_MODULE_7__notifications__["a" /* NEW_NOTIFICATION */], {
                text: 'Deleting end-device...',
                color: 'secondary'
              });

            case 4:
              notificationId = _context7.sent;

            case 5:
              _context7.prev = 5;
              _context7.next = 8;
              return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.delete('/end_devices/' + payload.id + '?' + __WEBPACK_IMPORTED_MODULE_4_query_string___default.a.stringify(payload.options));

            case 8:
              commit(REMOVE_END_DEVICE, payload);
              if (!payload.suppressNotifications) {
                commit(__WEBPACK_IMPORTED_MODULE_7__notifications__["c" /* REPLACE_NOTIFICATION */], {
                  id: notificationId,
                  text: 'Deleted end-device!',
                  color: 'success'
                });
              }
              return _context7.abrupt('return', true);

            case 13:
              _context7.prev = 13;
              _context7.t0 = _context7['catch'](5);

              commit(__WEBPACK_IMPORTED_MODULE_7__notifications__["c" /* REPLACE_NOTIFICATION */], {
                id: notificationId,
                text: 'Failed to delete end-device ',
                detail: _context7.t0.message,
                color: 'error'
              });

            case 16:
              return _context7.abrupt('return', false);

            case 17:
            case 'end':
              return _context7.stop();
          }
        }
      }, _callee7, this, [[5, 13]]);
    }));

    return function (_x13, _x14) {
      return _ref22.apply(this, arguments);
    };
  }()), _actions)
});

/***/ }),

/***/ 226:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SET_PACKETS_CHART_INTERVAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SET_JOIN_REQUESTS_CHART_INTERVAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SET_CRC_CHART_INTERVAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SET_MISSED_PACKETS_CHART_INTERVAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return SET_SIGNAL_CHART_INTERVAL; });
var _mutations;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var SET_PACKETS_CHART_INTERVAL = 'SET_PACKETS_CHART_INTERVAL';
var SET_JOIN_REQUESTS_CHART_INTERVAL = 'SET_JOIN_REQUESTS_CHART_INTERVAL';
var SET_CRC_CHART_INTERVAL = 'SET_CRC_CHART_INTERVAL';
var SET_MISSED_PACKETS_CHART_INTERVAL = 'SET_MISSED_PACKETS_CHART_INTERVAL';
var SET_SIGNAL_CHART_INTERVAL = 'SET_SIGNAL_CHART_INTERVAL';

var initialState = function initialState() {
  return {
    packetsChartInterval: 'daily',
    joinRequestsChartInterval: 'daily',
    crcChartInterval: 'hourly',
    missedPacketsChartInterval: 'daily',
    signalChartInterval: 'daily'
  };
};

/* harmony default export */ __webpack_exports__["f"] = ({
  state: initialState(),
  mutations: (_mutations = {}, _defineProperty(_mutations, SET_PACKETS_CHART_INTERVAL, function (state, payload) {
    state.packetsChartInterval = payload.interval;
  }), _defineProperty(_mutations, SET_JOIN_REQUESTS_CHART_INTERVAL, function (state, payload) {
    state.joinRequestsChartInterval = payload.interval;
  }), _defineProperty(_mutations, SET_CRC_CHART_INTERVAL, function (state, payload) {
    state.crcChartInterval = payload.interval;
  }), _defineProperty(_mutations, SET_MISSED_PACKETS_CHART_INTERVAL, function (state, payload) {
    state.missedPacketsChartInterval = payload.interval;
  }), _defineProperty(_mutations, SET_SIGNAL_CHART_INTERVAL, function (state, payload) {
    state.signalChartInterval = payload.interval;
  }), _mutations),
  actions: {}
});

/***/ }),

/***/ 228:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export REPLACE_ORGANIZATIONS */
/* unused harmony export ADD_ORGANIZATIONS */
/* unused harmony export MODIFY_ORGANIZATION */
/* unused harmony export DONE_ORGANIZATIONS_FETCHING */
/* unused harmony export ADD_TO_PERSISTED_ITEMS */
/* unused harmony export START_ORGANIZATIONS_FETCHING */
/* unused harmony export SET_ORGANIZATIONS_TOTAL */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return FETCH_ORGANIZATIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return FETCH_ORGANIZATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return UPDATE_ORGANIZATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CREATE_ORGANIZATION; });
/* unused harmony export REMOVE_ORGANIZATION */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DELETE_ORGANIZATION; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jsonapi_normalizer__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jsonapi_normalizer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jsonapi_normalizer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__session__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__notifications__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_api__ = __webpack_require__(18);
var _mutations, _actions;

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }









var REPLACE_ORGANIZATIONS = 'REPLACE_ORGANIZATIONS';
var ADD_ORGANIZATIONS = 'ADD_ORGANIZATIONS';
var MODIFY_ORGANIZATION = 'MODIFY_ORGANIZATION';
var DONE_ORGANIZATIONS_FETCHING = 'DONE_ORGANIZATIONS_FETCHING';
var ADD_TO_PERSISTED_ITEMS = 'ADD_TO_PERSISTED_ITEMS';

var START_ORGANIZATIONS_FETCHING = 'START_ORGANIZATIONS_FETCHING';
var SET_ORGANIZATIONS_TOTAL = 'SET_ORGANIZATIONS_TOTAL';
var FETCH_ORGANIZATIONS = 'FETCH_ORGANIZATIONS';
var FETCH_ORGANIZATION = 'FETCH_ORGANIZATION';
var UPDATE_ORGANIZATION = 'UPDATE_ORGANIZATION';
var CREATE_ORGANIZATION = 'CREATE_ORGANIZATION';
var REMOVE_ORGANIZATION = 'REMOVE_ORGANIZATION';
var DELETE_ORGANIZATION = 'DELETE_ORGANIZATION';

var initialState = function initialState() {
  return {
    entities: {},
    persistedItems: {},
    statistics: {
      total: null,
      collectionCount: null
    },
    fetch_status: {
      all: ''
    }
  };
};

/* harmony default export */ __webpack_exports__["f"] = ({
  state: initialState(),
  getters: {
    organizationDefaults: function organizationDefaults() {
      return {
        email: ''
      };
    },
    organizations: function organizations(_ref
    //$FlowFixMe
    ) {
      var _ref$entities = _ref.entities,
          entities = _ref$entities === undefined ? {} : _ref$entities;
      return Object.keys(entities).map(function (key) {
        return entities[key];
      });
    },
    organizationsDropDown: function organizationsDropDown(_ref2) {
      var _ref2$entities = _ref2.entities,
          entities = _ref2$entities === undefined ? {} : _ref2$entities;

      Object.keys(entities).map(function (key) {
        return entities[key];
      }).map(function (org) {
        return { text: org.name, value: org.id };
      });
    },
    organizationById: function organizationById(state) {
      return function (id) {
        return state.entities[id] || state.persistedItems[id] || {};
      };
    }
  },
  mutations: (_mutations = {
    RESET_STATE: function RESET_STATE(state) {
      Object.assign(state, initialState());
    }
  }, _defineProperty(_mutations, START_ORGANIZATIONS_FETCHING, function (state, payload) {
    state.fetch_status[payload.key] = 'loading';
  }), _defineProperty(_mutations, SET_ORGANIZATIONS_TOTAL, function (state, payload) {
    state.statistics = payload.meta.pagination;
    state.statistics.total = payload.meta.pagination.count;
  }), _defineProperty(_mutations, DONE_ORGANIZATIONS_FETCHING, function (state, payload) {
    state.fetch_status[payload.key] = 'loaded';
  }), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_3__session__["c" /* REMOVE_SESSION */], function (state) {
    state.entities = initialState().entities;
  }), _defineProperty(_mutations, REPLACE_ORGANIZATIONS, function (state, _ref3) {
    var _ref3$entities = _ref3.entities,
        entities = _ref3$entities === undefined ? {} : _ref3$entities;

    state.entities = entities;
  }), _defineProperty(_mutations, ADD_ORGANIZATIONS, function (state, payload) {
    state.entities = Object.assign({}, state.entities, payload.entities);
  }), _defineProperty(_mutations, MODIFY_ORGANIZATION, function (state, payload) {
    state.entities[payload.id] = Object.assign({}, state.entities[payload.id], payload);
  }), _defineProperty(_mutations, REMOVE_ORGANIZATION, function (state, payload) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].delete(state.entities, payload.id);
  }), _defineProperty(_mutations, ADD_TO_PERSISTED_ITEMS, function (state, payload) {
    if (payload.id) state.persistedItems[payload.id] = payload;
  }), _mutations),
  actions: (_actions = {}, _defineProperty(_actions, FETCH_ORGANIZATION, function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(_ref4, payload) {
      var commit = _ref4.commit,
          dispatch = _ref4.dispatch;

      var _ref6, data, links, _normalize, entities;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('/organizations/' + payload.id);

            case 3:
              _ref6 = _context.sent;
              data = _ref6.data;
              links = data.data.links;

              if (links) {
                data.data.attributes.device_management_login_url = links.device_management_login_url;
              }
              _normalize = __WEBPACK_IMPORTED_MODULE_2_jsonapi_normalizer___default()(data), entities = _normalize.entities;

              commit(ADD_ORGANIZATIONS, {
                entities: entities.organizations
              });
              commit(ADD_TO_PERSISTED_ITEMS, data.data.attributes);
              return _context.abrupt('return', { success: true, organization: data.data.attributes });

            case 13:
              _context.prev = 13;
              _context.t0 = _context['catch'](0);

              dispatch(__WEBPACK_IMPORTED_MODULE_4__notifications__["a" /* NEW_NOTIFICATION */], {
                text: 'Failed to load organization ',
                detail: _context.t0.message,
                color: 'error'
              });
              return _context.abrupt('return', { success: false });

            case 17:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this, [[0, 13]]);
    }));

    return function (_x, _x2) {
      return _ref5.apply(this, arguments);
    };
  }()), _defineProperty(_actions, FETCH_ORGANIZATIONS, function () {
    var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(_ref7, payload) {
      var commit = _ref7.commit,
          dispatch = _ref7.dispatch;

      var _ref9, data, pagination;

      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;

              commit(START_ORGANIZATIONS_FETCHING, { key: 'all' });
              _context2.next = 4;
              return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('/organizations', {
                params: Object(__WEBPACK_IMPORTED_MODULE_5__utils_api__["a" /* computePaginateSortFilterParams */])(payload)
              });

            case 4:
              _ref9 = _context2.sent;
              data = _ref9.data;
              pagination = data.meta.pagination;

              commit(SET_ORGANIZATIONS_TOTAL, { total: data.data.length, meta: data.meta });

              commit(REPLACE_ORGANIZATIONS, {
                entities: __WEBPACK_IMPORTED_MODULE_2_jsonapi_normalizer___default()(data).entities.organizations
              });
              if (!payload) {
                payload = {};
              }
              return _context2.abrupt('return', {
                success: true,
                items: data.data.map(function (item) {
                  item.attributes.device_management_login_url = item.links;
                  return item.attributes;
                }),
                collectionCount: Object(__WEBPACK_IMPORTED_MODULE_5__utils_api__["b" /* computedCollectionCount */])({
                  endRow: payload.endRow,
                  filteredCount: pagination.filtered_count,
                  collectionCount: pagination.collection_count
                })
              });

            case 13:
              _context2.prev = 13;
              _context2.t0 = _context2['catch'](0);

              dispatch(__WEBPACK_IMPORTED_MODULE_4__notifications__["a" /* NEW_NOTIFICATION */], {
                text: 'Failed to load organizations.',
                detail: _context2.t0.message,
                color: 'error'
              });
              return _context2.abrupt('return', { success: false });

            case 17:
              _context2.prev = 17;

              commit(DONE_ORGANIZATIONS_FETCHING, { key: 'all' });
              return _context2.finish(17);

            case 20:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, this, [[0, 13, 17, 20]]);
    }));

    return function (_x3, _x4) {
      return _ref8.apply(this, arguments);
    };
  }()), _defineProperty(_actions, UPDATE_ORGANIZATION, function () {
    var _ref11 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(_ref10, payload) {
      var commit = _ref10.commit,
          dispatch = _ref10.dispatch;

      var notificationId, _ref12, data, _normalize2, entities;

      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return dispatch(__WEBPACK_IMPORTED_MODULE_4__notifications__["a" /* NEW_NOTIFICATION */], {
                text: 'Saving...',
                undoable: true,
                color: 'secondary'
              });

            case 2:
              notificationId = _context3.sent;
              _context3.prev = 3;
              _context3.next = 6;
              return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.patch('/organizations/' + payload.id, {
                data: {
                  type: 'organizations',
                  attributes: payload.attributes,
                  relationships: payload.relationships
                }
              });

            case 6:
              _ref12 = _context3.sent;
              data = _ref12.data;
              _normalize2 = __WEBPACK_IMPORTED_MODULE_2_jsonapi_normalizer___default()(data), entities = _normalize2.entities;

              commit(MODIFY_ORGANIZATION, entities.organizations[payload.id]);
              commit(__WEBPACK_IMPORTED_MODULE_4__notifications__["c" /* REPLACE_NOTIFICATION */], {
                id: notificationId,
                text: 'Saved!',
                color: 'success',
                undoable: true
              });
              return _context3.abrupt('return', true);

            case 14:
              _context3.prev = 14;
              _context3.t0 = _context3['catch'](3);

              commit(__WEBPACK_IMPORTED_MODULE_4__notifications__["c" /* REPLACE_NOTIFICATION */], {
                id: notificationId,
                text: 'Failed to update organization ',
                detail: _context3.t0.message,
                color: 'error'
              });

            case 17:
              return _context3.abrupt('return', false);

            case 18:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, this, [[3, 14]]);
    }));

    return function (_x5, _x6) {
      return _ref11.apply(this, arguments);
    };
  }()), _defineProperty(_actions, CREATE_ORGANIZATION, function () {
    var _ref14 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(_ref13, payload) {
      var commit = _ref13.commit,
          dispatch = _ref13.dispatch;

      var notificationId, _ref15, data, _normalize3, entities;

      return regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return dispatch(__WEBPACK_IMPORTED_MODULE_4__notifications__["a" /* NEW_NOTIFICATION */], {
                text: 'Saving...',
                undoable: true,
                color: 'secondary'
              });

            case 2:
              notificationId = _context4.sent;
              _context4.prev = 3;
              _context4.next = 6;
              return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post('/organizations', {
                data: {
                  type: 'organizations',
                  attributes: payload.attributes,
                  relationships: payload.relationships
                }
              });

            case 6:
              _ref15 = _context4.sent;
              data = _ref15.data;
              _normalize3 = __WEBPACK_IMPORTED_MODULE_2_jsonapi_normalizer___default()(data), entities = _normalize3.entities;

              commit(ADD_ORGANIZATIONS, {
                entities: entities.organizations
              });
              commit(__WEBPACK_IMPORTED_MODULE_4__notifications__["c" /* REPLACE_NOTIFICATION */], {
                id: notificationId,
                text: 'Saved!',
                color: 'success',
                undoable: true
              });
              return _context4.abrupt('return', data.data.attributes.id);

            case 14:
              _context4.prev = 14;
              _context4.t0 = _context4['catch'](3);

              commit(__WEBPACK_IMPORTED_MODULE_4__notifications__["c" /* REPLACE_NOTIFICATION */], {
                id: notificationId,
                text: 'Failed to create organization.',
                detail: _context4.t0.message,
                color: 'error'
              });

            case 17:
              return _context4.abrupt('return', false);

            case 18:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, this, [[3, 14]]);
    }));

    return function (_x7, _x8) {
      return _ref14.apply(this, arguments);
    };
  }()), _defineProperty(_actions, DELETE_ORGANIZATION, function () {
    var _ref17 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(_ref16, payload) {
      var commit = _ref16.commit,
          dispatch = _ref16.dispatch;

      var notificationId, _ref18, data;

      return regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return dispatch(__WEBPACK_IMPORTED_MODULE_4__notifications__["a" /* NEW_NOTIFICATION */], {
                text: 'Removing...',
                undoable: true,
                color: 'secondary'
              });

            case 2:
              notificationId = _context5.sent;
              _context5.prev = 3;
              _context5.next = 6;
              return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.delete('/organizations/' + payload.id);

            case 6:
              _ref18 = _context5.sent;
              data = _ref18.data;

              commit(REMOVE_ORGANIZATION, payload);
              commit(__WEBPACK_IMPORTED_MODULE_4__notifications__["c" /* REPLACE_NOTIFICATION */], {
                id: notificationId,
                text: 'Organization has been successfully deleted!',
                color: 'success',
                undoable: true
              });
              return _context5.abrupt('return', data);

            case 13:
              _context5.prev = 13;
              _context5.t0 = _context5['catch'](3);

              commit(__WEBPACK_IMPORTED_MODULE_4__notifications__["c" /* REPLACE_NOTIFICATION */], {
                id: notificationId,
                text: 'Failed to remove organization.',
                detail: _context5.t0.message,
                color: 'error'
              });

            case 16:
              return _context5.abrupt('return', false);

            case 17:
            case 'end':
              return _context5.stop();
          }
        }
      }, _callee5, this, [[3, 13]]);
    }));

    return function (_x9, _x10) {
      return _ref17.apply(this, arguments);
    };
  }()), _actions)
});

/***/ }),

/***/ 230:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export REPLACE_DEVICE_GROUPS */
/* unused harmony export ADD_DEVICE_GROUPS */
/* unused harmony export MODIFY_DEVICE_GROUP */
/* unused harmony export REMOVE_DEVICE_GROUP */
/* unused harmony export START_DEVICE_GROUP_FETCHING */
/* unused harmony export DONE_DEVICE_GROUP_FETCHING */
/* unused harmony export SET_DEVICE_GROUPS_TOTAL */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return FETCH_DEVICE_GROUPS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return FETCH_DEVICE_GROUP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CREATE_DEVICE_GROUP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return UPDATE_DEVICE_GROUP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ADD_DEVICES_TO_DEVICE_GROUP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return REMOVE_DEVICES_FROM_DEVICE_GROUP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return DELETE_DEVICE_GROUP; });
/* unused harmony export RESET_STATE */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jsonapi_normalizer__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jsonapi_normalizer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jsonapi_normalizer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_object_path__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_object_path___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_object_path__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_query_string__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_query_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__session__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__notifications__ = __webpack_require__(13);
var _mutations, _actions;

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }











var REPLACE_DEVICE_GROUPS = 'REPLACE_DEVICE_GROUPS';
var ADD_DEVICE_GROUPS = 'ADD_DEVICE_GROUPS';
var MODIFY_DEVICE_GROUP = 'MODIFY_DEVICE_GROUP';
var REMOVE_DEVICE_GROUP = 'REMOVE_DEVICE_GROUP';
var START_DEVICE_GROUP_FETCHING = 'START_DEVICE_GROUP_FETCHING';
var DONE_DEVICE_GROUP_FETCHING = 'DONE_DEVICE_GROUP_FETCHING';
var SET_DEVICE_GROUPS_TOTAL = 'SET_DEVICE_GROUPS_TOTAL';

var FETCH_DEVICE_GROUPS = 'FETCH_DEVICE_GROUPS';
var FETCH_DEVICE_GROUP = 'FETCH_DEVICE_GROUP';
var CREATE_DEVICE_GROUP = 'CREATE_DEVICE_GROUP';
var UPDATE_DEVICE_GROUP = 'UPDATE_DEVICE_GROUP';
var ADD_DEVICES_TO_DEVICE_GROUP = 'ADD_DEVICES_TO_DEVICE_GROUP';
var REMOVE_DEVICES_FROM_DEVICE_GROUP = 'REMOVE_DEVICES_FROM_DEVICE_GROUP';
var DELETE_DEVICE_GROUP = 'DELETE_DEVICE_GROUP';
var RESET_STATE = 'RESET_STATE';

var initialState = function initialState() {
  return {
    entities: {},
    statistics: {
      total: null
    },
    fetch_status: {
      all: ''
    }
  };
};

/* harmony default export */ __webpack_exports__["h"] = ({
  state: initialState(),
  getters: {
    deviceGroupDefaults: function deviceGroupDefaults() {
      return {};
    },
    deviceGroups: function deviceGroups(_ref
    //$FlowFixMe
    ) {
      var _ref$entities = _ref.entities,
          entities = _ref$entities === undefined ? {} : _ref$entities;
      return Object.keys(entities).map(function (key) {
        return entities[key];
      });
    },
    deviceGroupsKeyedByEui: function deviceGroupsKeyedByEui(state, getters) {
      var deviceGroups = {};
      getters.deviceGroups.forEach(function (group) {
        deviceGroups[group.eui] = group;
      });
      return deviceGroups;
    },
    deviceGroupById: function deviceGroupById(state) {
      return function (id) {
        return state.entities[id] || {};
      };
    },
    deviceGroupByEui: function deviceGroupByEui(state, getters) {
      return function (eui) {
        return getters.deviceGroups.find(function (group) {
          return group.eui === eui;
        }) || {};
      };
    }
  },
  mutations: (_mutations = {}, _defineProperty(_mutations, RESET_STATE, function (state) {
    Object.assign(state, initialState());
    state.entities = initialState().entities;
  }), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_5__session__["c" /* REMOVE_SESSION */], function (state) {
    state.entities = initialState().entities;
  }), _defineProperty(_mutations, START_DEVICE_GROUP_FETCHING, function (state, payload) {
    state.fetch_status[payload.key] = 'loading';
  }), _defineProperty(_mutations, DONE_DEVICE_GROUP_FETCHING, function (state, payload) {
    state.fetch_status[payload.key] = 'loaded';
  }), _defineProperty(_mutations, REPLACE_DEVICE_GROUPS, function (state, _ref2) {
    var _ref2$entities = _ref2.entities,
        entities = _ref2$entities === undefined ? {} : _ref2$entities;

    state.entities = entities;
  }), _defineProperty(_mutations, ADD_DEVICE_GROUPS, function (state, payload) {
    state.entities = Object.assign({}, state.entities, payload.entities);
  }), _defineProperty(_mutations, MODIFY_DEVICE_GROUP, function (state, payload) {
    state.entities[payload.id] = Object.assign({}, state.entities[payload.id], payload);
  }), _defineProperty(_mutations, REMOVE_DEVICE_GROUP, function (state, payload) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].delete(state.entities, payload.id);
  }), _defineProperty(_mutations, SET_DEVICE_GROUPS_TOTAL, function (state, payload) {
    state.statistics.total = payload.total;
  }), _mutations),
  actions: (_actions = {}, _defineProperty(_actions, RESET_STATE, function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(state) {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              this.commit(RESET_STATE, state);

            case 1:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    return function (_x) {
      return _ref3.apply(this, arguments);
    };
  }()), _defineProperty(_actions, FETCH_DEVICE_GROUPS, function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(_ref4, payload) {
      var commit = _ref4.commit,
          dispatch = _ref4.dispatch;

      var pathstring, _ref6, data, entities;

      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;

              commit(START_DEVICE_GROUP_FETCHING, { key: 'all' });
              pathstring = '/device_groups';


              if (payload && payload.orgId) {
                pathstring = '/organizations/' + payload.orgId + '/device_groups';
              }

              pathstring += '?limit=1000';

              _context2.next = 7;
              return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(pathstring);

            case 7:
              _ref6 = _context2.sent;
              data = _ref6.data;


              commit(SET_DEVICE_GROUPS_TOTAL, {
                total: data.meta.pagination.collection_count
              });
              entities = {};

              data.data.map(function (group) {
                entities[group.id] = Object.assign({}, group.attributes, group.meta);
              });

              commit(REPLACE_DEVICE_GROUPS, {
                entities: entities
              });
              _context2.next = 18;
              break;

            case 15:
              _context2.prev = 15;
              _context2.t0 = _context2['catch'](0);

              dispatch(__WEBPACK_IMPORTED_MODULE_6__notifications__["a" /* NEW_NOTIFICATION */], {
                text: 'Failed to load operation groups.',
                detail: _context2.t0.message,
                color: 'error'
              });

            case 18:
              _context2.prev = 18;

              commit(DONE_DEVICE_GROUP_FETCHING, { key: 'all' });
              return _context2.finish(18);

            case 21:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, this, [[0, 15, 18, 21]]);
    }));

    return function (_x2, _x3) {
      return _ref5.apply(this, arguments);
    };
  }()), _defineProperty(_actions, FETCH_DEVICE_GROUP, function () {
    var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(_ref7, payload) {
      var commit = _ref7.commit,
          dispatch = _ref7.dispatch;

      var _ref9, data, status;

      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              _context3.next = 3;
              return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('/device_groups/' + payload.id);

            case 3:
              _ref9 = _context3.sent;
              data = _ref9.data.data;

              commit(ADD_DEVICE_GROUPS, {
                entities: _defineProperty({}, data.id, Object.assign({}, data.attributes, data.meta))
              });
              return _context3.abrupt('return', { success: true });

            case 9:
              _context3.prev = 9;
              _context3.t0 = _context3['catch'](0);
              status = __WEBPACK_IMPORTED_MODULE_3_object_path___default.a.get(_context3.t0, 'response.status');

              if (status !== 404) {
                dispatch(__WEBPACK_IMPORTED_MODULE_6__notifications__["a" /* NEW_NOTIFICATION */], {
                  text: 'Failed to load operation group.',
                  detail: _context3.t0.message,
                  color: 'error'
                });
              }
              return _context3.abrupt('return', { success: false, status: status });

            case 14:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, this, [[0, 9]]);
    }));

    return function (_x4, _x5) {
      return _ref8.apply(this, arguments);
    };
  }()), _defineProperty(_actions, CREATE_DEVICE_GROUP, function () {
    var _ref11 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(_ref10, payload) {
      var commit = _ref10.commit,
          dispatch = _ref10.dispatch;

      var _ref12, data, _normalize, entities;

      return regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.prev = 0;
              _context4.next = 3;
              return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post('/device_groups', {
                data: {
                  type: 'device_group',
                  attributes: payload.attributes,
                  relationships: payload.relationships
                }
              });

            case 3:
              _ref12 = _context4.sent;
              data = _ref12.data;
              _normalize = __WEBPACK_IMPORTED_MODULE_2_jsonapi_normalizer___default()(data), entities = _normalize.entities;

              if (!payload.suppressNotifications) {
                commit(ADD_DEVICE_GROUPS, {
                  entities: entities.device_groups
                });
              }
              dispatch(__WEBPACK_IMPORTED_MODULE_6__notifications__["a" /* NEW_NOTIFICATION */], {
                text: 'Saved new operation group!',
                color: 'success'
              });
              return _context4.abrupt('return', data.data.attributes.eui);

            case 11:
              _context4.prev = 11;
              _context4.t0 = _context4['catch'](0);

              dispatch(__WEBPACK_IMPORTED_MODULE_6__notifications__["a" /* NEW_NOTIFICATION */], {
                text: 'Failed to save operation group',
                detail: _context4.t0.message,
                color: 'error'
              });

            case 14:
              return _context4.abrupt('return', false);

            case 15:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, this, [[0, 11]]);
    }));

    return function (_x6, _x7) {
      return _ref11.apply(this, arguments);
    };
  }()), _defineProperty(_actions, UPDATE_DEVICE_GROUP, function () {
    var _ref14 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(_ref13, payload) {
      var commit = _ref13.commit,
          dispatch = _ref13.dispatch;

      var notificationId, _ref15, data, _normalize2, entities;

      return regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              notificationId = void 0;

              if (payload.suppressNotifications) {
                _context5.next = 5;
                break;
              }

              _context5.next = 4;
              return dispatch(__WEBPACK_IMPORTED_MODULE_6__notifications__["a" /* NEW_NOTIFICATION */], {
                text: 'Saving...',
                undoable: true,
                color: 'secondary'
              });

            case 4:
              notificationId = _context5.sent;

            case 5:
              _context5.prev = 5;
              _context5.next = 8;
              return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.patch('/device_groups/' + payload.id, {
                data: {
                  type: 'device_groups',
                  attributes: payload.attributes,
                  relationships: payload.relationships
                }
              });

            case 8:
              _ref15 = _context5.sent;
              data = _ref15.data;
              _normalize2 = __WEBPACK_IMPORTED_MODULE_2_jsonapi_normalizer___default()(data), entities = _normalize2.entities;

              commit(MODIFY_DEVICE_GROUP, entities.device_groups[payload.id]);
              if (!payload.suppressNotifications) {
                commit(__WEBPACK_IMPORTED_MODULE_6__notifications__["c" /* REPLACE_NOTIFICATION */], {
                  id: notificationId,
                  text: 'Saved!',
                  color: 'success',
                  undoable: true
                });
              }
              return _context5.abrupt('return', true);

            case 16:
              _context5.prev = 16;
              _context5.t0 = _context5['catch'](5);

              commit(__WEBPACK_IMPORTED_MODULE_6__notifications__["c" /* REPLACE_NOTIFICATION */], {
                id: notificationId,
                text: 'Failed to update operation group.',
                detail: _context5.t0.message,
                color: 'error'
              });

            case 19:
              return _context5.abrupt('return', false);

            case 20:
            case 'end':
              return _context5.stop();
          }
        }
      }, _callee5, this, [[5, 16]]);
    }));

    return function (_x8, _x9) {
      return _ref14.apply(this, arguments);
    };
  }()), _defineProperty(_actions, REMOVE_DEVICES_FROM_DEVICE_GROUP, function () {
    var _ref17 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(_ref16, payload) {
      var getters = _ref16.getters,
          dispatch = _ref16.dispatch;
      var euis;
      return regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              euis = [].concat(_toConsumableArray(getters.deviceGroupById(payload.id).device_euis));

              payload.device_euis.map(function (eui) {
                euis.splice(euis.indexOf(eui), 1);
              });

              _context6.next = 4;
              return dispatch(UPDATE_DEVICE_GROUP, {
                id: payload.id,
                attributes: {
                  device_euis: euis
                }
              });

            case 4:
            case 'end':
              return _context6.stop();
          }
        }
      }, _callee6, this);
    }));

    return function (_x10, _x11) {
      return _ref17.apply(this, arguments);
    };
  }()), _defineProperty(_actions, ADD_DEVICES_TO_DEVICE_GROUP, function () {
    var _ref19 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(_ref18, payload) {
      var getters = _ref18.getters,
          dispatch = _ref18.dispatch;
      return regeneratorRuntime.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              _context7.next = 2;
              return dispatch(UPDATE_DEVICE_GROUP, {
                id: payload.id,
                attributes: {
                  device_euis: [].concat(_toConsumableArray(getters.deviceGroupById(payload.id).device_euis), _toConsumableArray(payload.device_euis))
                }
              });

            case 2:
            case 'end':
              return _context7.stop();
          }
        }
      }, _callee7, this);
    }));

    return function (_x12, _x13) {
      return _ref19.apply(this, arguments);
    };
  }()), _defineProperty(_actions, DELETE_DEVICE_GROUP, function () {
    var _ref21 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(_ref20, payload) {
      var commit = _ref20.commit,
          dispatch = _ref20.dispatch;
      var notificationId;
      return regeneratorRuntime.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              notificationId = void 0;

              if (payload.suppressNotifications) {
                _context8.next = 5;
                break;
              }

              _context8.next = 4;
              return dispatch(__WEBPACK_IMPORTED_MODULE_6__notifications__["a" /* NEW_NOTIFICATION */], {
                text: 'Deleting operation group...',
                color: 'secondary'
              });

            case 4:
              notificationId = _context8.sent;

            case 5:
              _context8.prev = 5;
              _context8.next = 8;
              return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.delete('/device_groups/' + payload.id + '?' + __WEBPACK_IMPORTED_MODULE_4_query_string___default.a.stringify(payload.options));

            case 8:
              commit(REMOVE_DEVICE_GROUP, payload);
              if (!payload.suppressNotifications) {
                commit(__WEBPACK_IMPORTED_MODULE_6__notifications__["c" /* REPLACE_NOTIFICATION */], {
                  id: notificationId,
                  text: 'Deleted operation group!',
                  color: 'success'
                });
              }
              return _context8.abrupt('return', true);

            case 13:
              _context8.prev = 13;
              _context8.t0 = _context8['catch'](5);

              commit(__WEBPACK_IMPORTED_MODULE_6__notifications__["c" /* REPLACE_NOTIFICATION */], {
                id: notificationId,
                text: 'Failed to delete operation group.',
                detail: _context8.t0.message,
                color: 'error'
              });

            case 16:
              return _context8.abrupt('return', false);

            case 17:
            case 'end':
              return _context8.stop();
          }
        }
      }, _callee8, this, [[5, 13]]);
    }));

    return function (_x14, _x15) {
      return _ref21.apply(this, arguments);
    };
  }()), _actions)
});

/***/ }),

/***/ 231:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export REPLACE_APPLICATION_NETWORKS */
/* unused harmony export ADD_APPLICATION_NETWORKS */
/* unused harmony export MODIFY_APPLICATION_NETWORK */
/* unused harmony export REMOVE_APPLICATION_NETWORK */
/* unused harmony export START_APPLICATION_NETWORK_FETCHING */
/* unused harmony export DONE_APPLICATION_NETWORK_FETCHING */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return SET_APPLICATION_NETWORKS_TOTAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return FETCH_APPLICATION_NETWORKS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return FETCH_APPLICATION_NETWORK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CREATE_APPLICATION_NETWORK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return UPDATE_APPLICATION_NETWORK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DELETE_APPLICATION_NETWORK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return RESET_STATE; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jsonapi_normalizer__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jsonapi_normalizer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jsonapi_normalizer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_object_path__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_object_path___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_object_path__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_query_string__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_query_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__session__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__notifications__ = __webpack_require__(13);
var _mutations, _actions;

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }











var REPLACE_APPLICATION_NETWORKS = "REPLACE_APPLICATION_NETWORKS";
var ADD_APPLICATION_NETWORKS = "ADD_APPLICATION_NETWORKS";
var MODIFY_APPLICATION_NETWORK = "MODIFY_APPLICATION_NETWORK";
var REMOVE_APPLICATION_NETWORK = "REMOVE_APPLICATION_NETWORK";
var START_APPLICATION_NETWORK_FETCHING = "START_APPLICATION_NETWORK_FETCHING";
var DONE_APPLICATION_NETWORK_FETCHING = "DONE_APPLICATION_NETWORK_FETCHING";
var SET_APPLICATION_NETWORKS_TOTAL = "SET_APPLICATION_NETWORKS_TOTAL";

var FETCH_APPLICATION_NETWORKS = "FETCH_APPLICATION_NETWORKS";
var FETCH_APPLICATION_NETWORK = "FETCH_APPLICATION_NETWORK";
var CREATE_APPLICATION_NETWORK = "CREATE_APPLICATION_NETWORK";
var UPDATE_APPLICATION_NETWORK = "UPDATE_APPLICATION_NETWORK";
var DELETE_APPLICATION_NETWORK = "DELETE_APPLICATION_NETWORK";
var RESET_STATE = "RESET_STATE";

var initialState = function initialState() {
  return {
    entities: {},
    statistics: {
      total: null
    },
    fetch_status: {
      all: ""
    }
  };
};

/* harmony default export */ __webpack_exports__["h"] = ({
  state: initialState(),
  getters: {
    applicationNetworkDefaults: function applicationNetworkDefaults() {
      return {};
    },
    applicationNetworks: function applicationNetworks(_ref
    //$FlowFixMe
    ) {
      var _ref$entities = _ref.entities,
          entities = _ref$entities === undefined ? {} : _ref$entities;
      return Object.keys(entities).map(function (key) {
        return entities[key];
      });
    },
    applicationNetworksKeyedByEui: function applicationNetworksKeyedByEui(state, getters) {
      var applicationNetworks = {};
      getters.applicationNetworks.forEach(function (appNet) {
        applicationNetworks[appNet.eui] = appNet;
      });
      return applicationNetworks;
    },
    applicationNetworkById: function applicationNetworkById(state) {
      return function (id) {
        return state.entities[id] || {};
      };
    },
    applicationNetworkByEui: function applicationNetworkByEui(state, getters) {
      return function (eui) {
        return getters.applicationNetworks.find(function (appNet) {
          return appNet.eui === eui;
        }) || {};
      };
    },
    applicationNetworkByOrgId: function applicationNetworkByOrgId(state, getters) {
      return function (organization_id) {
        var appNetsForRequestedOrg = [];
        getters.applicationNetworks.forEach(function (appNet) {
          if (appNet.organization_id === organization_id) {
            appNetsForRequestedOrg.push(appNet);
          }
        });
        return appNetsForRequestedOrg;
      };
    }
  },
  mutations: (_mutations = {}, _defineProperty(_mutations, RESET_STATE, function (state) {
    Object.assign(state, initialState());
    state.entities = initialState().entities;
  }), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_5__session__["c" /* REMOVE_SESSION */], function (state) {
    state.entities = initialState().entities;
  }), _defineProperty(_mutations, START_APPLICATION_NETWORK_FETCHING, function (state, payload) {
    state.fetch_status[payload.key] = "loading";
  }), _defineProperty(_mutations, DONE_APPLICATION_NETWORK_FETCHING, function (state, payload) {
    state.fetch_status[payload.key] = "loaded";
  }), _defineProperty(_mutations, REPLACE_APPLICATION_NETWORKS, function (state, _ref2) {
    var _ref2$entities = _ref2.entities,
        entities = _ref2$entities === undefined ? {} : _ref2$entities;

    state.entities = entities;
  }), _defineProperty(_mutations, ADD_APPLICATION_NETWORKS, function (state, payload) {
    state.entities = Object.assign({}, state.entities, payload.entities);
    state.statistics.total++;
  }), _defineProperty(_mutations, MODIFY_APPLICATION_NETWORK, function (state, payload) {
    state.entities[payload.id] = Object.assign({}, state.entities[payload.id], payload);
  }), _defineProperty(_mutations, REMOVE_APPLICATION_NETWORK, function (state, payload) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].delete(state.entities, payload.id);
    state.statistics.total--;
  }), _defineProperty(_mutations, SET_APPLICATION_NETWORKS_TOTAL, function (state, payload) {
    state.statistics.total = payload.total;
  }), _mutations),
  actions: (_actions = {}, _defineProperty(_actions, RESET_STATE, function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(state) {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              this.commit(RESET_STATE, state);

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    return function (_x) {
      return _ref3.apply(this, arguments);
    };
  }()), _defineProperty(_actions, FETCH_APPLICATION_NETWORKS, function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(_ref4, payload) {
      var commit = _ref4.commit,
          dispatch = _ref4.dispatch;

      var pathstring, _ref6, data, entities;

      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;

              commit(START_APPLICATION_NETWORK_FETCHING, { key: "all" });
              pathstring = "/application_networks?limit=200";


              if (!!payload && payload.orgId) {
                pathstring = "/organizations/" + payload.orgId + "/application_networks";
              }

              _context2.next = 6;
              return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(pathstring);

            case 6:
              _ref6 = _context2.sent;
              data = _ref6.data;


              commit(SET_APPLICATION_NETWORKS_TOTAL, {
                total: data.meta.pagination.collection_count
              });
              entities = {};

              data.data.map(function (appNet) {
                entities[appNet.id] = Object.assign({}, appNet.attributes, appNet.meta);
              });

              commit(REPLACE_APPLICATION_NETWORKS, {
                entities: entities
              });
              _context2.next = 17;
              break;

            case 14:
              _context2.prev = 14;
              _context2.t0 = _context2["catch"](0);

              dispatch(__WEBPACK_IMPORTED_MODULE_6__notifications__["a" /* NEW_NOTIFICATION */], {
                text: "Failed to load application networks.",
                detail: _context2.t0.message,
                color: "error"
              });

            case 17:
              _context2.prev = 17;

              commit(DONE_APPLICATION_NETWORK_FETCHING, { key: "all" });
              return _context2.finish(17);

            case 20:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, this, [[0, 14, 17, 20]]);
    }));

    return function (_x2, _x3) {
      return _ref5.apply(this, arguments);
    };
  }()), _defineProperty(_actions, FETCH_APPLICATION_NETWORK, function () {
    var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(_ref7, payload) {
      var commit = _ref7.commit,
          dispatch = _ref7.dispatch;

      var _ref9, data, status;

      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              _context3.next = 3;
              return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("/application_networks/" + payload.id);

            case 3:
              _ref9 = _context3.sent;
              data = _ref9.data.data;

              commit(ADD_APPLICATION_NETWORKS, {
                entities: _defineProperty({}, data.id, Object.assign({}, data.attributes, data.meta))
              });
              return _context3.abrupt("return", { success: true });

            case 9:
              _context3.prev = 9;
              _context3.t0 = _context3["catch"](0);
              status = __WEBPACK_IMPORTED_MODULE_3_object_path___default.a.get(_context3.t0, "response.status");

              if (status !== 404) {
                dispatch(__WEBPACK_IMPORTED_MODULE_6__notifications__["a" /* NEW_NOTIFICATION */], {
                  text: "Failed to load application network.",
                  detail: _context3.t0.message,
                  color: "error"
                });
              }
              return _context3.abrupt("return", { success: false, status: status });

            case 14:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, this, [[0, 9]]);
    }));

    return function (_x4, _x5) {
      return _ref8.apply(this, arguments);
    };
  }()), _defineProperty(_actions, CREATE_APPLICATION_NETWORK, function () {
    var _ref11 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(_ref10, payload) {
      var commit = _ref10.commit,
          dispatch = _ref10.dispatch;

      var _ref12, data, _normalize, entities;

      return regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.prev = 0;
              _context4.next = 3;
              return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post("/application_networks", {
                data: {
                  type: "application_network",
                  attributes: payload.attributes,
                  relationships: payload.relationships
                }
              });

            case 3:
              _ref12 = _context4.sent;
              data = _ref12.data;
              _normalize = __WEBPACK_IMPORTED_MODULE_2_jsonapi_normalizer___default()(data), entities = _normalize.entities;

              if (!payload.suppressNotifications) {
                commit(ADD_APPLICATION_NETWORKS, {
                  entities: entities.application_networks
                });
              }
              dispatch(__WEBPACK_IMPORTED_MODULE_6__notifications__["a" /* NEW_NOTIFICATION */], {
                text: "Saved new application network!",
                color: "success"
              });
              return _context4.abrupt("return", data.data.attributes.eui);

            case 11:
              _context4.prev = 11;
              _context4.t0 = _context4["catch"](0);

              dispatch(__WEBPACK_IMPORTED_MODULE_6__notifications__["a" /* NEW_NOTIFICATION */], {
                text: "Failed to save application network",
                detail: _context4.t0.message,
                color: "error"
              });

            case 14:
              return _context4.abrupt("return", false);

            case 15:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, this, [[0, 11]]);
    }));

    return function (_x6, _x7) {
      return _ref11.apply(this, arguments);
    };
  }()), _defineProperty(_actions, UPDATE_APPLICATION_NETWORK, function () {
    var _ref14 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(_ref13, payload) {
      var commit = _ref13.commit,
          dispatch = _ref13.dispatch;

      var notificationId, _ref15, data, _normalize2, entities;

      return regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              notificationId = void 0;

              if (payload.suppressNotifications) {
                _context5.next = 5;
                break;
              }

              _context5.next = 4;
              return dispatch(__WEBPACK_IMPORTED_MODULE_6__notifications__["a" /* NEW_NOTIFICATION */], {
                text: "Saving...",
                undoable: true,
                color: "secondary"
              });

            case 4:
              notificationId = _context5.sent;

            case 5:
              _context5.prev = 5;
              _context5.next = 8;
              return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.patch("/application_networks/" + payload.id, {
                data: {
                  type: "application_network",
                  attributes: payload.attributes,
                  relationships: payload.relationships
                }
              });

            case 8:
              _ref15 = _context5.sent;
              data = _ref15.data;
              _normalize2 = __WEBPACK_IMPORTED_MODULE_2_jsonapi_normalizer___default()(data), entities = _normalize2.entities;

              commit(MODIFY_APPLICATION_NETWORK, entities.application_networks[payload.id]);
              if (!payload.suppressNotifications) {
                commit(__WEBPACK_IMPORTED_MODULE_6__notifications__["c" /* REPLACE_NOTIFICATION */], {
                  id: notificationId,
                  text: "Saved!",
                  color: "success",
                  undoable: true
                });
              }
              return _context5.abrupt("return", true);

            case 16:
              _context5.prev = 16;
              _context5.t0 = _context5["catch"](5);

              commit(__WEBPACK_IMPORTED_MODULE_6__notifications__["c" /* REPLACE_NOTIFICATION */], {
                id: notificationId,
                text: "Failed to update application network ",
                detail: _context5.t0.message,
                color: "error"
              });

            case 19:
              return _context5.abrupt("return", false);

            case 20:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, this, [[5, 16]]);
    }));

    return function (_x8, _x9) {
      return _ref14.apply(this, arguments);
    };
  }()), _defineProperty(_actions, DELETE_APPLICATION_NETWORK, function () {
    var _ref17 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(_ref16, payload) {
      var commit = _ref16.commit,
          dispatch = _ref16.dispatch;
      var notificationId;
      return regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              notificationId = void 0;

              if (payload.suppressNotifications) {
                _context6.next = 5;
                break;
              }

              _context6.next = 4;
              return dispatch(__WEBPACK_IMPORTED_MODULE_6__notifications__["a" /* NEW_NOTIFICATION */], {
                text: "Deleting application network...",
                color: "secondary"
              });

            case 4:
              notificationId = _context6.sent;

            case 5:
              _context6.prev = 5;
              _context6.next = 8;
              return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.delete("/application_networks/" + payload.id + "?" + __WEBPACK_IMPORTED_MODULE_4_query_string___default.a.stringify(payload.options));

            case 8:
              commit(REMOVE_APPLICATION_NETWORK, payload);
              if (!payload.suppressNotifications) {
                commit(__WEBPACK_IMPORTED_MODULE_6__notifications__["c" /* REPLACE_NOTIFICATION */], {
                  id: notificationId,
                  text: "Deleted application network!",
                  color: "success"
                });
              }
              return _context6.abrupt("return", true);

            case 13:
              _context6.prev = 13;
              _context6.t0 = _context6["catch"](5);

              commit(__WEBPACK_IMPORTED_MODULE_6__notifications__["c" /* REPLACE_NOTIFICATION */], {
                id: notificationId,
                text: "Failed to delete application network ",
                detail: _context6.t0.message,
                color: "error"
              });

            case 16:
              return _context6.abrupt("return", false);

            case 17:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6, this, [[5, 13]]);
    }));

    return function (_x10, _x11) {
      return _ref17.apply(this, arguments);
    };
  }()), _actions)
});

/***/ }),

/***/ 232:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export REPLACE_NETWORK_PROFILES */
/* unused harmony export ADD_NETWORK_PROFILES */
/* unused harmony export MODIFY_NETWORK_PROFILE */
/* unused harmony export REMOVE_NETWORK_PROFILE */
/* unused harmony export SET_NETWORK_PROFILES_TOTAL */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return FETCH_NETWORK_PROFILES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return FETCH_NETWORK_PROFILE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CREATE_NETWORK_PROFILE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return UPDATE_NETWORK_PROFILE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DELETE_NETWORK_PROFILE; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jsonapi_normalizer__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jsonapi_normalizer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jsonapi_normalizer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_object_path__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_object_path___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_object_path__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__session__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_api__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__notifications__ = __webpack_require__(13);
var _mutations, _actions;

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }











var REPLACE_NETWORK_PROFILES = 'REPLACE_NETWORK_PROFILES';
var ADD_NETWORK_PROFILES = 'ADD_NETWORK_PROFILES';
var MODIFY_NETWORK_PROFILE = 'MODIFY_NETWORK_PROFILE';
var REMOVE_NETWORK_PROFILE = 'REMOVE_NETWORK_PROFILE';
var SET_NETWORK_PROFILES_TOTAL = 'SET_NETWORK_PROFILES_TOTAL';

var FETCH_NETWORK_PROFILES = 'FETCH_NETWORK_PROFILES';
var FETCH_NETWORK_PROFILE = 'FETCH_NETWORK_PROFILE';
var CREATE_NETWORK_PROFILE = 'CREATE_NETWORK_PROFILE';
var UPDATE_NETWORK_PROFILE = 'UPDATE_NETWORK_PROFILE';
var DELETE_NETWORK_PROFILE = 'DELETE_NETWORK_PROFILE';

var initialState = function initialState() {
  return {
    entities: {},
    statistics: {
      total: null
    }
  };
};

/* harmony default export */ __webpack_exports__["f"] = ({
  state: initialState(),
  getters: {
    networkProfileDefaults: function networkProfileDefaults() {
      return {
        network_profile_id: 'newNetworkProfileID'
      };
    },
    networkProfiles: function networkProfiles(_ref
    //$FlowFixMe
    ) {
      var _ref$entities = _ref.entities,
          entities = _ref$entities === undefined ? {} : _ref$entities;
      return Object.keys(entities).map(function (key) {
        return entities[key];
      });
    },
    // Returns an object with all network-profiles, keyed by network-profile EUI
    networkProfilesKeyedById: function networkProfilesKeyedById(state, getters) {
      var networkProfiles = {};
      getters.networkProfiles.forEach(function (dp) {
        networkProfiles[dp.id] = dp;
      });
      return networkProfiles;
    },
    networkProfilesById: function networkProfilesById(state) {
      return function (id) {
        return state.entities[id] || {};
      };
    }
  },
  mutations: (_mutations = {
    RESET_STATE: function RESET_STATE(state) {
      Object.assign(state, initialState());
    }
  }, _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_4__session__["c" /* REMOVE_SESSION */], function (state) {
    state.entities = initialState().entities;
  }), _defineProperty(_mutations, REPLACE_NETWORK_PROFILES, function (state, _ref2) {
    var _ref2$entities = _ref2.entities,
        entities = _ref2$entities === undefined ? {} : _ref2$entities;

    state.entities = entities;
  }), _defineProperty(_mutations, ADD_NETWORK_PROFILES, function (state, payload) {
    state.entities = Object.assign({}, state.entities, payload.entities);
  }), _defineProperty(_mutations, MODIFY_NETWORK_PROFILE, function (state, payload) {
    state.entities[payload.id] = Object.assign({}, state.entities[payload.id], payload);
  }), _defineProperty(_mutations, REMOVE_NETWORK_PROFILE, function (state, payload) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].delete(state.entities, payload.id);
  }), _defineProperty(_mutations, SET_NETWORK_PROFILES_TOTAL, function (state, payload) {
    state.statistics.total = payload.total;
  }), _mutations),
  actions: (_actions = {}, _defineProperty(_actions, FETCH_NETWORK_PROFILES, function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(_ref3, payload) {
      var commit = _ref3.commit,
          dispatch = _ref3.dispatch;

      var pathstring, _ref5, data, pagination;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              pathstring = '/network_profiles';

              if (payload && payload.context && payload.context.orgId) {
                pathstring = '/organizations/' + payload.context.orgId + pathstring;
              }

              _context.next = 5;
              return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(pathstring, {
                params: Object(__WEBPACK_IMPORTED_MODULE_5__utils_api__["a" /* computePaginateSortFilterParams */])(payload)
              });

            case 5:
              _ref5 = _context.sent;
              data = _ref5.data;
              pagination = data.meta.pagination;

              commit(SET_NETWORK_PROFILES_TOTAL, { total: pagination.collection_count });
              commit(REPLACE_NETWORK_PROFILES, {
                entities: __WEBPACK_IMPORTED_MODULE_2_jsonapi_normalizer___default()(data).entities.network_profiles
              });

              return _context.abrupt('return', {
                success: true,
                // Return fetched data as flat array
                items: data.data.map(function (item) {
                  return item.attributes;
                }),
                collectionCount: Object(__WEBPACK_IMPORTED_MODULE_5__utils_api__["b" /* computedCollectionCount */])({
                  endRow: payload ? payload.endRow : 0,
                  filteredCount: pagination.filtered_count,
                  collectionCount: pagination.collection_count
                })
              });

            case 13:
              _context.prev = 13;
              _context.t0 = _context['catch'](0);

              dispatch(__WEBPACK_IMPORTED_MODULE_6__notifications__["a" /* NEW_NOTIFICATION */], {
                text: 'Failed to load network profiles ',
                detail: _context.t0.message,
                color: 'error'
              });

            case 16:
              return _context.abrupt('return', { success: false });

            case 17:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this, [[0, 13]]);
    }));

    return function (_x, _x2) {
      return _ref4.apply(this, arguments);
    };
  }()), _defineProperty(_actions, FETCH_NETWORK_PROFILE, function () {
    var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(_ref6, payload) {
      var commit = _ref6.commit,
          dispatch = _ref6.dispatch;

      var _ref8, data, _normalize, entities, status;

      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('/network_profiles/' + payload.id);

            case 3:
              _ref8 = _context2.sent;
              data = _ref8.data;
              _normalize = __WEBPACK_IMPORTED_MODULE_2_jsonapi_normalizer___default()(data), entities = _normalize.entities;

              commit(ADD_NETWORK_PROFILES, { entities: entities.network_profiles });
              return _context2.abrupt('return', { success: true });

            case 10:
              _context2.prev = 10;
              _context2.t0 = _context2['catch'](0);
              status = __WEBPACK_IMPORTED_MODULE_3_object_path___default.a.get(_context2.t0, 'response.status');

              if (status !== 404) {
                dispatch(__WEBPACK_IMPORTED_MODULE_6__notifications__["a" /* NEW_NOTIFICATION */], {
                  text: 'Failed to load network-profile ',
                  detail: _context2.t0.message,
                  color: 'error'
                });
              }
              return _context2.abrupt('return', { success: false, status: status });

            case 15:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, this, [[0, 10]]);
    }));

    return function (_x3, _x4) {
      return _ref7.apply(this, arguments);
    };
  }()), _defineProperty(_actions, CREATE_NETWORK_PROFILE, function () {
    var _ref10 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(_ref9, payload) {
      var commit = _ref9.commit,
          dispatch = _ref9.dispatch;

      var _ref11, data, _normalize2, entities;

      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              _context3.next = 3;
              return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post('/network_profiles', {
                data: {
                  type: 'network_profiles',
                  attributes: payload.attributes,
                  relationships: payload.relationships
                }
              });

            case 3:
              _ref11 = _context3.sent;
              data = _ref11.data;
              _normalize2 = __WEBPACK_IMPORTED_MODULE_2_jsonapi_normalizer___default()(data), entities = _normalize2.entities;

              commit(ADD_NETWORK_PROFILES, { entities: entities.network_profiles });
              dispatch(__WEBPACK_IMPORTED_MODULE_6__notifications__["a" /* NEW_NOTIFICATION */], {
                text: 'Saved new network-profile!',
                color: 'success'
              });
              return _context3.abrupt('return', data.data.attributes.id);

            case 11:
              _context3.prev = 11;
              _context3.t0 = _context3['catch'](0);

              dispatch(__WEBPACK_IMPORTED_MODULE_6__notifications__["a" /* NEW_NOTIFICATION */], {
                text: 'Failed to save network-profile ',
                detail: _context3.t0.message,
                color: 'error'
              });

            case 14:
              return _context3.abrupt('return', false);

            case 15:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, this, [[0, 11]]);
    }));

    return function (_x5, _x6) {
      return _ref10.apply(this, arguments);
    };
  }()), _defineProperty(_actions, UPDATE_NETWORK_PROFILE, function () {
    var _ref13 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(_ref12, payload) {
      var commit = _ref12.commit,
          dispatch = _ref12.dispatch;

      var notificationId, _ref14, data, _normalize3, entities;

      return regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return dispatch(__WEBPACK_IMPORTED_MODULE_6__notifications__["a" /* NEW_NOTIFICATION */], {
                text: 'Saving...',
                color: 'secondary',
                undoable: true
              });

            case 2:
              notificationId = _context4.sent;
              _context4.prev = 3;

              console.log(payload.attributes);
              _context4.next = 7;
              return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.patch('/network_profiles/' + payload.id, {
                data: {
                  type: 'network_profiles',
                  attributes: payload.attributes,
                  relationships: payload.relationships
                }
              });

            case 7:
              _ref14 = _context4.sent;
              data = _ref14.data;
              _normalize3 = __WEBPACK_IMPORTED_MODULE_2_jsonapi_normalizer___default()(data), entities = _normalize3.entities;

              commit(MODIFY_NETWORK_PROFILE, entities.network_profiles[payload.id]);
              commit(__WEBPACK_IMPORTED_MODULE_6__notifications__["c" /* REPLACE_NOTIFICATION */], {
                id: notificationId,
                text: 'Saved!',
                color: 'success',
                undoable: true
              });
              return _context4.abrupt('return', true);

            case 15:
              _context4.prev = 15;
              _context4.t0 = _context4['catch'](3);

              commit(__WEBPACK_IMPORTED_MODULE_6__notifications__["c" /* REPLACE_NOTIFICATION */], {
                id: notificationId,
                text: 'Failed to update network-profile ',
                detail: _context4.t0.message,
                color: 'error'
              });

            case 18:
              return _context4.abrupt('return', false);

            case 19:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, this, [[3, 15]]);
    }));

    return function (_x7, _x8) {
      return _ref13.apply(this, arguments);
    };
  }()), _defineProperty(_actions, DELETE_NETWORK_PROFILE, function () {
    var _ref16 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(_ref15, payload) {
      var commit = _ref15.commit,
          dispatch = _ref15.dispatch;
      var notificationId;
      return regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return dispatch(__WEBPACK_IMPORTED_MODULE_6__notifications__["a" /* NEW_NOTIFICATION */], {
                text: 'Deleting network-profile...',
                color: 'secondary'
              });

            case 2:
              notificationId = _context5.sent;
              _context5.prev = 3;
              _context5.next = 6;
              return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.delete('/network_profiles/' + payload.id);

            case 6:
              commit(REMOVE_NETWORK_PROFILE, payload);
              commit(__WEBPACK_IMPORTED_MODULE_6__notifications__["c" /* REPLACE_NOTIFICATION */], {
                id: notificationId,
                text: 'Deleted network-profile!',
                color: 'success'
              });
              return _context5.abrupt('return', true);

            case 11:
              _context5.prev = 11;
              _context5.t0 = _context5['catch'](3);

              commit(__WEBPACK_IMPORTED_MODULE_6__notifications__["c" /* REPLACE_NOTIFICATION */], {
                id: notificationId,
                text: 'Failed to delete network-profile ',
                detail: _context5.t0.message,
                color: 'error'
              });

            case 14:
              return _context5.abrupt('return', false);

            case 15:
            case 'end':
              return _context5.stop();
          }
        }
      }, _callee5, this, [[3, 11]]);
    }));

    return function (_x9, _x10) {
      return _ref16.apply(this, arguments);
    };
  }()), _actions)
});

/***/ }),

/***/ 233:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export REPLACE_USERS */
/* unused harmony export RESET_STATE */
/* unused harmony export RESET_USERS */
/* unused harmony export ADD_USERS */
/* unused harmony export MODIFY_USER */
/* unused harmony export REMOVE_USER */
/* unused harmony export START_USER_FETCHING */
/* unused harmony export DONE_USER_FETCHING */
/* unused harmony export SET_USERS_TOTAL */
/* unused harmony export UPDATE_PAGINATION */
/* unused harmony export FETCH_USERS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return FETCH_USER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return FETCH_CURRENT_USER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CREATE_USER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return UPDATE_USER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DELETE_USER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return USER_FORGOT_PASSWORD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return USER_RESET_PASSWORD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return VERIFY_NEW_USER; });
/* unused harmony export RESET_USER_CREDENTIALS */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jsonapi_normalizer__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jsonapi_normalizer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jsonapi_normalizer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_object_path__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_object_path___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_object_path__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__session__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__notifications__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_api__ = __webpack_require__(18);
var _mutations, _actions;

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }













var REPLACE_USERS = "REPLACE_USERS";
var RESET_STATE = "RESET_STATE";
var RESET_USERS = "RESET_USERS";
var ADD_USERS = "ADD_USERS";
var MODIFY_USER = "MODIFY_USER";
var REMOVE_USER = "REMOVE_USER";
var START_USER_FETCHING = "START_USER_FETCHING";
var DONE_USER_FETCHING = "DONE_USER_FETCHING";
var SET_USERS_TOTAL = "SET_USERS_TOTAL";
var UPDATE_PAGINATION = "UPDATE_PAGINATION";

var FETCH_USERS = "FETCH_USERS";
var FETCH_USER = "FETCH_USER";
var FETCH_CURRENT_USER = "FETCH_CURRENT_USER";
var CREATE_USER = "CREATE_USER";
var UPDATE_USER = "UPDATE_USER";
var DELETE_USER = "DELETE_USER";
var USER_FORGOT_PASSWORD = "USER_FORGOT_PASSWORD";
var USER_RESET_PASSWORD = "USER_RESET_PASSWORD";
var VERIFY_NEW_USER = "VERIFY_NEW_USER";
var RESET_USER_CREDENTIALS = "RESET_USER_CREDENTIALS";

var initialState = function initialState() {
  return {
    entities: {},
    statistics: {
      total: null
    },
    pagParams: {
      pagination: {},
      startRow: 0,
      endRow: 100,
      sortModel: [],
      filterModel: {}
    },
    fetch_status: {
      all: ""
    }
  };
};

/* harmony default export */ __webpack_exports__["i"] = ({
  state: initialState(),
  getters: {
    userDefaults: function userDefaults() {
      return {
        first_name: "",
        last_name: "",
        email: "",
        new_password: "",
        session_timeout_seconds: __WEBPACK_IMPORTED_MODULE_6__utils_api__["i" /* sessionExpirationOptions */].find(function (f) {
          return f.text === "1 hour";
        }).value,
        password_lifetime_seconds: __WEBPACK_IMPORTED_MODULE_6__utils_api__["f" /* passwordExpirationOptions */].find(function (f) {
          return f.text === "3 months";
        }).value
      };
    },
    //$FlowFixMe
    users: function users(_ref) {
      var _ref$entities = _ref.entities,
          entities = _ref$entities === undefined ? {} : _ref$entities;
      return Object.keys(entities).map(function (key) {
        return entities[key];
      });
    },
    userById: function userById(state) {
      return function (id) {
        return state.entities[id] || {};
      };
    },
    userByEmail: function userByEmail(state, getters) {
      return function (email) {
        return getters.users.find(function (user) {
          return user.email === email;
        }) || {};
      };
    }
  },
  mutations: (_mutations = {}, _defineProperty(_mutations, RESET_STATE, function (state) {
    Object.assign(state, initialState());
  }), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_4__session__["c" /* REMOVE_SESSION */], function (state) {
    state.entities = initialState().entities;
  }), _defineProperty(_mutations, START_USER_FETCHING, function (state, payload) {
    state.fetch_status[payload.key] = "loading";
  }), _defineProperty(_mutations, DONE_USER_FETCHING, function (state, payload) {
    state.fetch_status[payload.key] = "loaded";
  }), _defineProperty(_mutations, REPLACE_USERS, function (state, _ref2) {
    var _ref2$entities = _ref2.entities,
        entities = _ref2$entities === undefined ? {} : _ref2$entities;

    state.entities = entities;
    var iss = initialState();
    state.pagParams = iss.pagParams;
  }), _defineProperty(_mutations, ADD_USERS, function (state, payload) {
    state.entities = Object.assign({}, state.entities, payload.entities);
    state.statistics.total = Object.keys(state.entities).length;
  }), _defineProperty(_mutations, MODIFY_USER, function (state, payload) {
    state.entities[payload.id] = Object.assign({}, state.entities[payload.id], payload);
  }), _defineProperty(_mutations, REMOVE_USER, function (state, payload) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].delete(state.entities, payload.id);
  }), _defineProperty(_mutations, SET_USERS_TOTAL, function (state, payload) {
    state.statistics.total = payload.total;
  }), _defineProperty(_mutations, UPDATE_PAGINATION, function (state, payload) {
    state.pagParams.lastFetchCount = payload.count;
    state.pagParams.lastSkip = payload.skip;
    state.pagParams.startRow += 100;
    state.pagParams.endRow += 100;
  }), _mutations),
  actions: (_actions = {}, _defineProperty(_actions, RESET_USERS, function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(_ref3) {
      var commit = _ref3.commit;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              commit(REPLACE_USERS, {});

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    return function (_x) {
      return _ref4.apply(this, arguments);
    };
  }()), _defineProperty(_actions, FETCH_USERS, function () {
    var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(_ref5, payload) {
      var state = _ref5.state,
          commit = _ref5.commit,
          dispatch = _ref5.dispatch;

      var pathstring, spsfpParms, sendToServerParams, _ref7, data, pagination, _normalize, entities;

      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;

              if (!(state.pagParams.lastFetchCount === 0)) {
                _context2.next = 3;
                break;
              }

              return _context2.abrupt("return", true);

            case 3:

              commit(START_USER_FETCHING, { key: "all" });
              pathstring = "/users";

              if (payload.orgId) {
                pathstring = "/organizations/" + payload.orgId + "/users";
              }

              spsfpParms = {
                sortModel: [],
                filterModel: {},
                startRow: state.pagParams.startRow,
                endRow: state.pagParams.endRow
              };
              sendToServerParams = Object(__WEBPACK_IMPORTED_MODULE_6__utils_api__["a" /* computePaginateSortFilterParams */])(spsfpParms);
              _context2.next = 10;
              return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(pathstring, {
                params: sendToServerParams
              });

            case 10:
              _ref7 = _context2.sent;
              data = _ref7.data;
              pagination = data.meta.pagination;
              _normalize = __WEBPACK_IMPORTED_MODULE_2_jsonapi_normalizer___default()(data), entities = _normalize.entities;


              commit(ADD_USERS, {
                entities: entities.users
              });
              commit(UPDATE_PAGINATION, pagination);
              if (pagination.count > 0) {
                commit(ADD_USERS, {
                  entities: __WEBPACK_IMPORTED_MODULE_2_jsonapi_normalizer___default()(data).entities.users
                });
              }
              commit(SET_USERS_TOTAL, { total: pagination.collection_count });
              _context2.next = 23;
              break;

            case 20:
              _context2.prev = 20;
              _context2.t0 = _context2["catch"](0);

              dispatch(__WEBPACK_IMPORTED_MODULE_5__notifications__["a" /* NEW_NOTIFICATION */], {
                text: "Failed to load people ",
                detail: _context2.t0.message,
                color: "error"
              });

            case 23:
              _context2.prev = 23;

              commit(DONE_USER_FETCHING, { key: "all" });
              return _context2.finish(23);

            case 26:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, this, [[0, 20, 23, 26]]);
    }));

    return function (_x2, _x3) {
      return _ref6.apply(this, arguments);
    };
  }()), _defineProperty(_actions, FETCH_USER, function () {
    var _ref9 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(_ref8, payload) {
      var commit = _ref8.commit,
          dispatch = _ref8.dispatch;

      var _ref10, data, _normalize2, entities;

      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              _context3.next = 3;
              return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("/users/" + payload.id);

            case 3:
              _ref10 = _context3.sent;
              data = _ref10.data;
              _normalize2 = __WEBPACK_IMPORTED_MODULE_2_jsonapi_normalizer___default()(data), entities = _normalize2.entities;

              commit(ADD_USERS, {
                entities: entities.users
              });
              return _context3.abrupt("return", { success: true });

            case 10:
              _context3.prev = 10;
              _context3.t0 = _context3["catch"](0);

              dispatch(__WEBPACK_IMPORTED_MODULE_5__notifications__["a" /* NEW_NOTIFICATION */], {
                text: "Failed to load person ",
                detail: _context3.t0.message,
                color: "error"
              });
              return _context3.abrupt("return", { success: false });

            case 14:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, this, [[0, 10]]);
    }));

    return function (_x4, _x5) {
      return _ref9.apply(this, arguments);
    };
  }()), _defineProperty(_actions, FETCH_CURRENT_USER, function () {
    var _ref12 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(_ref11) {
      var rootState = _ref11.rootState,
          commit = _ref11.commit,
          dispatch = _ref11.dispatch;

      var currentUserId, _ref13, data, _normalize3, entities;

      return regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.prev = 0;
              currentUserId = rootState.session.user.id;

              if (currentUserId) {
                _context4.next = 4;
                break;
              }

              throw new Error("No current user id found");

            case 4:
              _context4.next = 6;
              return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("/users/" + currentUserId + "?include=organization");

            case 6:
              _ref13 = _context4.sent;
              data = _ref13.data;
              _normalize3 = __WEBPACK_IMPORTED_MODULE_2_jsonapi_normalizer___default()(data), entities = _normalize3.entities;


              commit(__WEBPACK_IMPORTED_MODULE_4__session__["d" /* UPDATE_SESSION */], {
                user: entities.users[currentUserId],
                organization: Object.values(entities.organizations)[0]
              });
              _context4.next = 15;
              break;

            case 12:
              _context4.prev = 12;
              _context4.t0 = _context4["catch"](0);

              dispatch(__WEBPACK_IMPORTED_MODULE_5__notifications__["a" /* NEW_NOTIFICATION */], {
                text: "Failed to load your user information ",
                detail: _context4.t0.message,
                color: "error"
              });

            case 15:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, this, [[0, 12]]);
    }));

    return function (_x6) {
      return _ref12.apply(this, arguments);
    };
  }()), _defineProperty(_actions, CREATE_USER, function () {
    var _ref15 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(_ref14, payload) {
      var commit = _ref14.commit,
          dispatch = _ref14.dispatch;

      var notificationId, _ref16, data, _normalize4, entities;

      return regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              notificationId = void 0;

              if (payload.suppressNotifications) {
                _context5.next = 5;
                break;
              }

              _context5.next = 4;
              return dispatch(__WEBPACK_IMPORTED_MODULE_5__notifications__["a" /* NEW_NOTIFICATION */], {
                text: "Inviting " + (__WEBPACK_IMPORTED_MODULE_3_object_path___default.a.get(payload, "attributes.first_name") || "person") + "...",
                color: "secondary"
              });

            case 4:
              notificationId = _context5.sent;

            case 5:
              _context5.prev = 5;
              _context5.next = 8;
              return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post("/users", {
                data: {
                  type: "users",
                  attributes: payload.attributes,
                  relationships: payload.relationships
                }
              });

            case 8:
              _ref16 = _context5.sent;
              data = _ref16.data;
              _normalize4 = __WEBPACK_IMPORTED_MODULE_2_jsonapi_normalizer___default()(data), entities = _normalize4.entities;

              commit(ADD_USERS, {
                entities: entities.users
              });
              dispatch("lens_org_states/addUser", {
                id: data.data.attributes.id,
                type: "users",
                attributes: data.data.attributes
              });
              if (!payload.suppressNotifications) {
                commit(__WEBPACK_IMPORTED_MODULE_5__notifications__["c" /* REPLACE_NOTIFICATION */], {
                  id: notificationId,
                  text: (__WEBPACK_IMPORTED_MODULE_3_object_path___default.a.get(payload, "attributes.first_name") || "Person") + " has been invited!",
                  color: "success",
                  undoable: true
                });
              }
              return _context5.abrupt("return", data.data.attributes.id);

            case 17:
              _context5.prev = 17;
              _context5.t0 = _context5["catch"](5);

              commit(__WEBPACK_IMPORTED_MODULE_5__notifications__["c" /* REPLACE_NOTIFICATION */], {
                id: notificationId,
                text: "Failed to invite " + (__WEBPACK_IMPORTED_MODULE_3_object_path___default.a.get(payload, "attributes.first_name") || "person") + " ",
                detail: _context5.t0.message,
                color: "error"
              });

            case 20:
              return _context5.abrupt("return", false);

            case 21:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, this, [[5, 17]]);
    }));

    return function (_x7, _x8) {
      return _ref15.apply(this, arguments);
    };
  }()), _defineProperty(_actions, UPDATE_USER, function () {
    var _ref18 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(_ref17, payload) {
      var commit = _ref17.commit,
          dispatch = _ref17.dispatch;

      var notificationId, _ref19, data, _normalize5, entities, message, errorDetail;

      return regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              notificationId = void 0;

              if (payload.suppressNotifications) {
                _context6.next = 5;
                break;
              }

              _context6.next = 4;
              return dispatch(__WEBPACK_IMPORTED_MODULE_5__notifications__["a" /* NEW_NOTIFICATION */], {
                text: "Saving...",
                undoable: true,
                color: "secondary"
              });

            case 4:
              notificationId = _context6.sent;

            case 5:
              _context6.prev = 5;
              _context6.next = 8;
              return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.patch("/users/" + payload.id, {
                data: {
                  type: "users",
                  attributes: payload.attributes,
                  relationships: payload.relationships
                }
              });

            case 8:
              _ref19 = _context6.sent;
              data = _ref19.data;
              _normalize5 = __WEBPACK_IMPORTED_MODULE_2_jsonapi_normalizer___default()(data), entities = _normalize5.entities;

              commit(MODIFY_USER, entities.users[payload.id]);
              if (!payload.suppressNotifications) {
                commit(__WEBPACK_IMPORTED_MODULE_5__notifications__["c" /* REPLACE_NOTIFICATION */], {
                  id: notificationId,
                  text: "Saved!",
                  color: "success",
                  undoable: true
                });
              }
              return _context6.abrupt("return", true);

            case 16:
              _context6.prev = 16;
              _context6.t0 = _context6["catch"](5);
              message = void 0;
              errorDetail = __WEBPACK_IMPORTED_MODULE_3_object_path___default.a.get(_context6.t0, "response.data.errors.0.detail");

              if (errorDetail.includes("current_password did not match")) {
                message = "Your current password is incorrect";
              } else {
                message = _context6.t0.message;
              }
              commit(__WEBPACK_IMPORTED_MODULE_5__notifications__["c" /* REPLACE_NOTIFICATION */], {
                id: notificationId,
                text: "Failed to update user ",
                detail: message,
                color: "error"
              });

            case 22:
              return _context6.abrupt("return", false);

            case 23:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6, this, [[5, 16]]);
    }));

    return function (_x9, _x10) {
      return _ref18.apply(this, arguments);
    };
  }()), _defineProperty(_actions, DELETE_USER, function () {
    var _ref21 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(_ref20, payload) {
      var state = _ref20.state,
          commit = _ref20.commit,
          dispatch = _ref20.dispatch;
      var firstName, notificationId;
      return regeneratorRuntime.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              firstName = __WEBPACK_IMPORTED_MODULE_3_object_path___default.a.get(state.entities[payload.id], "first_name") || "person";
              notificationId = void 0;

              if (payload.suppressNotifications) {
                _context7.next = 6;
                break;
              }

              _context7.next = 5;
              return dispatch(__WEBPACK_IMPORTED_MODULE_5__notifications__["a" /* NEW_NOTIFICATION */], {
                text: "Removing " + firstName + " from this organization...",
                color: "secondary"
              });

            case 5:
              notificationId = _context7.sent;

            case 6:
              _context7.prev = 6;
              _context7.next = 9;
              return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.delete("/users/" + payload.id);

            case 9:
              commit(REMOVE_USER, payload);
              if (!payload.suppressNotifications) {
                commit(__WEBPACK_IMPORTED_MODULE_5__notifications__["c" /* REPLACE_NOTIFICATION */], {
                  id: notificationId,
                  text: firstName + " has been removed!",
                  color: "success"
                });
              }
              return _context7.abrupt("return", true);

            case 14:
              _context7.prev = 14;
              _context7.t0 = _context7["catch"](6);

              commit(__WEBPACK_IMPORTED_MODULE_5__notifications__["c" /* REPLACE_NOTIFICATION */], {
                id: notificationId,
                text: "Failed to remove " + firstName + " ",
                detail: _context7.t0.message,
                color: "error"
              });

            case 17:
              return _context7.abrupt("return", false);

            case 18:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7, this, [[6, 14]]);
    }));

    return function (_x11, _x12) {
      return _ref21.apply(this, arguments);
    };
  }()), _defineProperty(_actions, USER_FORGOT_PASSWORD, function () {
    var _ref23 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(_ref22, payload) {
      var commit = _ref22.commit,
          dispatch = _ref22.dispatch;
      var notificationId;
      return regeneratorRuntime.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              _context8.next = 2;
              return dispatch(__WEBPACK_IMPORTED_MODULE_5__notifications__["a" /* NEW_NOTIFICATION */], {
                text: "Sending password reset email...",
                color: "secondary"
              });

            case 2:
              notificationId = _context8.sent;
              _context8.prev = 3;
              _context8.next = 6;
              return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post("/users/forgot_password?email=" + payload.email);

            case 6:
              commit(__WEBPACK_IMPORTED_MODULE_5__notifications__["c" /* REPLACE_NOTIFICATION */], {
                id: notificationId,
                text: "Reset email sent!",
                color: "success"
              });
              return _context8.abrupt("return", { success: true });

            case 10:
              _context8.prev = 10;
              _context8.t0 = _context8["catch"](3);

              commit(__WEBPACK_IMPORTED_MODULE_5__notifications__["c" /* REPLACE_NOTIFICATION */], {
                id: notificationId,
                text: "Failed to send password reset email ",
                detail: _context8.t0.message,
                color: "error"
              });
              return _context8.abrupt("return", {
                error: "Failed to send password reset email: '" + _context8.t0.message + "'"
              });

            case 14:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8, this, [[3, 10]]);
    }));

    return function (_x13, _x14) {
      return _ref23.apply(this, arguments);
    };
  }()), _defineProperty(_actions, USER_RESET_PASSWORD, function () {
    var _ref24 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9(_, payload) {
      var _ref25, meta;

      return regeneratorRuntime.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              _context9.prev = 0;
              _context9.next = 3;
              return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post("/users/reset_password", {
                meta: payload
              });

            case 3:
              _ref25 = _context9.sent;
              meta = _ref25.data.meta;
              return _context9.abrupt("return", { success: true, meta: meta });

            case 8:
              _context9.prev = 8;
              _context9.t0 = _context9["catch"](0);
              return _context9.abrupt("return", {
                error: "Failed to set password: '" + _context9.t0.message + "'"
              });

            case 11:
            case "end":
              return _context9.stop();
          }
        }
      }, _callee9, this, [[0, 8]]);
    }));

    return function (_x15, _x16) {
      return _ref24.apply(this, arguments);
    };
  }()), _defineProperty(_actions, VERIFY_NEW_USER, function () {
    var _ref26 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10(_, payload) {
      var _ref27, meta;

      return regeneratorRuntime.wrap(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              _context10.prev = 0;
              _context10.next = 3;
              return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post("/users/verify_new_user", {
                data: {
                  type: "users",
                  attributes: payload
                }
              });

            case 3:
              _ref27 = _context10.sent;
              meta = _ref27.data.meta;
              return _context10.abrupt("return", { success: true, meta: meta });

            case 8:
              _context10.prev = 8;
              _context10.t0 = _context10["catch"](0);
              return _context10.abrupt("return", {
                error: "Failed to set new user password: '" + _context10.t0.message + "'"
              });

            case 11:
            case "end":
              return _context10.stop();
          }
        }
      }, _callee10, this, [[0, 8]]);
    }));

    return function (_x17, _x18) {
      return _ref26.apply(this, arguments);
    };
  }()), _actions)
});

/***/ }),

/***/ 234:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export REPLACE_SERVICE_API_KEYS */
/* unused harmony export ADD_SERVICE_API_KEYS */
/* unused harmony export MODIFY_SERVICE_API_KEY */
/* unused harmony export REMOVE_SERVICE_API_KEY */
/* unused harmony export SET_SERVICE_API_KEYS_TOTAL */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return FETCH_SERVICE_API_KEYS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return FETCH_SERVICE_API_KEY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CREATE_SERVICE_API_KEY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return UPDATE_SERVICE_API_KEY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DELETE_SERVICE_API_KEY; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jsonapi_normalizer__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jsonapi_normalizer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jsonapi_normalizer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_object_path__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_object_path___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_object_path__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_query_string__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_query_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__session__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_api__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__notifications__ = __webpack_require__(13);
var _mutations, _actions;

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }












var REPLACE_SERVICE_API_KEYS = 'REPLACE_SERVICE_API_KEYS';
var ADD_SERVICE_API_KEYS = 'ADD_SERVICE_API_KEYS';
var MODIFY_SERVICE_API_KEY = 'MODIFY_SERVICE_API_KEY';
var REMOVE_SERVICE_API_KEY = 'REMOVE_SERVICE_API_KEY';
var SET_SERVICE_API_KEYS_TOTAL = 'SET_SERVICE_API_KEYS_TOTAL';

var FETCH_SERVICE_API_KEYS = 'FETCH_SERVICE_API_KEYS';
var FETCH_SERVICE_API_KEY = 'FETCH_SERVICE_API_KEY';
var CREATE_SERVICE_API_KEY = 'CREATE_SERVICE_API_KEY';
var UPDATE_SERVICE_API_KEY = 'UPDATE_SERVICE_API_KEY';
var DELETE_SERVICE_API_KEY = 'DELETE_SERVICE_API_KEY';

var initialState = function initialState() {
  return {
    entities: {},
    statistics: {
      total: null
    }
  };
};

/* harmony default export */ __webpack_exports__["f"] = ({
  state: initialState(),
  getters: {
    service_api_keys: function service_api_keys(_ref) {
      var _ref$entities = _ref.entities,
          entities = _ref$entities === undefined ? {} : _ref$entities;
      return entities;
    },
    service_api_key: function service_api_key(state, getters) {
      return function (id) {
        return getters.service_api_keys[id];
      };
    }
  },
  mutations: (_mutations = {
    RESET_STATE: function RESET_STATE(state) {
      Object.assign(state, initialState());
    }
  }, _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_5__session__["c" /* REMOVE_SESSION */], function (state) {
    state.entities = initialState().entities;
  }), _defineProperty(_mutations, REPLACE_SERVICE_API_KEYS, function (state, _ref2) {
    var _ref2$entities = _ref2.entities,
        entities = _ref2$entities === undefined ? {} : _ref2$entities;

    state.entities = entities;
  }), _defineProperty(_mutations, ADD_SERVICE_API_KEYS, function (state, payload) {
    state.entities = Object.assign({}, state.entities, payload.entities);
  }), _defineProperty(_mutations, MODIFY_SERVICE_API_KEY, function (state, payload) {
    state.entities[payload.id] = Object.assign({}, state.entities[payload.id], payload);
  }), _defineProperty(_mutations, REMOVE_SERVICE_API_KEY, function (state, payload) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].delete(state.entities, payload.id);
  }), _defineProperty(_mutations, SET_SERVICE_API_KEYS_TOTAL, function (state, payload) {
    state.statistics.total = payload.total;
  }), _mutations),
  actions: (_actions = {}, _defineProperty(_actions, FETCH_SERVICE_API_KEYS, function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(_ref3) {
      var commit = _ref3.commit,
          dispatch = _ref3.dispatch;
      var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var pathstring, _ref5, data, pagination, _normalize, entities;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              pathstring = '/service_api_keys';
              _context.next = 4;
              return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(pathstring, {
                params: Object.assign({}, Object(__WEBPACK_IMPORTED_MODULE_6__utils_api__["a" /* computePaginateSortFilterParams */])(payload))
              });

            case 4:
              _ref5 = _context.sent;
              data = _ref5.data;
              pagination = data.meta.pagination;
              _normalize = __WEBPACK_IMPORTED_MODULE_2_jsonapi_normalizer___default()(data), entities = _normalize.entities;


              if (entities == null) entities = { service_api_keys: {} };
              if (entities.service_api_keys == null) entities.service_api_keys = {};
              commit(SET_SERVICE_API_KEYS_TOTAL, { total: pagination.collection_count });
              commit(REPLACE_SERVICE_API_KEYS, {
                entities: entities.service_api_keys
              });

              return _context.abrupt('return', {
                success: true,
                // Return fetched data as flat array
                // items: data.data.map(item => item.attributes),
                items: Object.values(entities.service_api_keys),
                collectionCount: Object(__WEBPACK_IMPORTED_MODULE_6__utils_api__["b" /* computedCollectionCount */])({
                  endRow: payload.endRow,
                  filteredCount: pagination.filtered_count,
                  collectionCount: pagination.collection_count
                })
              });

            case 15:
              _context.prev = 15;
              _context.t0 = _context['catch'](0);

              dispatch(__WEBPACK_IMPORTED_MODULE_7__notifications__["a" /* NEW_NOTIFICATION */], {
                text: 'Failed to load service-api-keys ',
                detail: _context.t0.message,
                color: 'error'
              });

            case 18:
              return _context.abrupt('return', { success: false });

            case 19:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this, [[0, 15]]);
    }));

    return function (_x2) {
      return _ref4.apply(this, arguments);
    };
  }()), _defineProperty(_actions, FETCH_SERVICE_API_KEY, function () {
    var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(_ref6, payload) {
      var commit = _ref6.commit,
          dispatch = _ref6.dispatch;

      var _ref8, data, _normalize2, entities, status;

      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (!(payload.id == null)) {
                _context2.next = 2;
                break;
              }

              return _context2.abrupt('return', { success: false, status: 404 });

            case 2:
              _context2.prev = 2;
              _context2.next = 5;
              return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('/service_api_keys/' + payload.id);

            case 5:
              _ref8 = _context2.sent;
              data = _ref8.data;
              _normalize2 = __WEBPACK_IMPORTED_MODULE_2_jsonapi_normalizer___default()(data), entities = _normalize2.entities;

              commit(ADD_SERVICE_API_KEYS, { entities: entities.service_api_keys });
              return _context2.abrupt('return', { success: true, status: 200 });

            case 12:
              _context2.prev = 12;
              _context2.t0 = _context2['catch'](2);
              status = __WEBPACK_IMPORTED_MODULE_3_object_path___default.a.get(_context2.t0, 'response.status');

              if (!(status !== 404)) {
                _context2.next = 18;
                break;
              }

              _context2.next = 18;
              return dispatch(__WEBPACK_IMPORTED_MODULE_7__notifications__["a" /* NEW_NOTIFICATION */], {
                text: 'Failed to load service-api-key ',
                detail: _context2.t0.message,
                color: 'error'
              });

            case 18:
              return _context2.abrupt('return', { success: false, status: status });

            case 19:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, this, [[2, 12]]);
    }));

    return function (_x3, _x4) {
      return _ref7.apply(this, arguments);
    };
  }()), _defineProperty(_actions, CREATE_SERVICE_API_KEY, function () {
    var _ref10 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(_ref9, payload) {
      var commit = _ref9.commit,
          dispatch = _ref9.dispatch;

      var _ref11, data, _normalize3, entities;

      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;

              if (payload.attributes.enabled == null) payload.attributes.enabled = false;
              _context3.next = 4;
              return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post('/service_api_keys', {
                data: {
                  type: 'service_api_keys',
                  attributes: payload.attributes,
                  relationships: payload.relationships
                }
              });

            case 4:
              _ref11 = _context3.sent;
              data = _ref11.data;
              _normalize3 = __WEBPACK_IMPORTED_MODULE_2_jsonapi_normalizer___default()(data), entities = _normalize3.entities;


              commit(ADD_SERVICE_API_KEYS, { entities: entities.service_api_keys });

              if (payload.suppressNotifications) {
                _context3.next = 11;
                break;
              }

              _context3.next = 11;
              return dispatch(__WEBPACK_IMPORTED_MODULE_7__notifications__["a" /* NEW_NOTIFICATION */], {
                text: 'Saved new service api key!',
                color: 'success'
              });

            case 11:
              return _context3.abrupt('return', data.data.attributes);

            case 14:
              _context3.prev = 14;
              _context3.t0 = _context3['catch'](0);
              _context3.next = 18;
              return dispatch(__WEBPACK_IMPORTED_MODULE_7__notifications__["a" /* NEW_NOTIFICATION */], {
                text: 'Failed to save service-api-key ',
                detail: _context3.t0.message,
                color: 'error'
              });

            case 18:
              return _context3.abrupt('return', false);

            case 19:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, this, [[0, 14]]);
    }));

    return function (_x5, _x6) {
      return _ref10.apply(this, arguments);
    };
  }()), _defineProperty(_actions, UPDATE_SERVICE_API_KEY, function () {
    var _ref13 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(_ref12, payload) {
      var commit = _ref12.commit,
          dispatch = _ref12.dispatch;

      var notificationId, _ref14, data, _normalize4, entities;

      return regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              notificationId = void 0;

              if (payload.suppressNotifications) {
                _context4.next = 5;
                break;
              }

              _context4.next = 4;
              return dispatch(__WEBPACK_IMPORTED_MODULE_7__notifications__["a" /* NEW_NOTIFICATION */], {
                text: 'Saving...',
                color: 'secondary',
                undoable: true
              });

            case 4:
              notificationId = _context4.sent;

            case 5:
              Object(__WEBPACK_IMPORTED_MODULE_6__utils_api__["c" /* nullifyBlankStrings */])(payload.attributes);
              _context4.prev = 6;
              _context4.next = 9;
              return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.patch('/service_api_keys/' + payload.id, {
                data: {
                  type: 'service_api_keys',
                  attributes: payload.attributes,
                  relationships: payload.relationships
                }
              });

            case 9:
              _ref14 = _context4.sent;
              data = _ref14.data;
              _normalize4 = __WEBPACK_IMPORTED_MODULE_2_jsonapi_normalizer___default()(data), entities = _normalize4.entities;

              commit(MODIFY_SERVICE_API_KEY, entities.service_api_keys[payload.id]);
              if (!payload.suppressNotifications) {
                commit(__WEBPACK_IMPORTED_MODULE_7__notifications__["c" /* REPLACE_NOTIFICATION */], {
                  id: notificationId,
                  text: 'Saved!',
                  color: 'success',
                  undoable: true
                });
              }
              return _context4.abrupt('return', true);

            case 17:
              _context4.prev = 17;
              _context4.t0 = _context4['catch'](6);

              commit(__WEBPACK_IMPORTED_MODULE_7__notifications__["c" /* REPLACE_NOTIFICATION */], {
                id: notificationId,
                text: 'Failed to update service-api-key ',
                detail: _context4.t0.message,
                color: 'error'
              });

            case 20:
              return _context4.abrupt('return', false);

            case 21:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, this, [[6, 17]]);
    }));

    return function (_x7, _x8) {
      return _ref13.apply(this, arguments);
    };
  }()), _defineProperty(_actions, DELETE_SERVICE_API_KEY, function () {
    var _ref16 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(_ref15, payload) {
      var commit = _ref15.commit,
          dispatch = _ref15.dispatch;
      var notificationId;
      return regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              notificationId = void 0;

              if (payload.suppressNotifications) {
                _context5.next = 5;
                break;
              }

              _context5.next = 4;
              return dispatch(__WEBPACK_IMPORTED_MODULE_7__notifications__["a" /* NEW_NOTIFICATION */], {
                text: 'Deleting service-api-key...',
                color: 'secondary'
              });

            case 4:
              notificationId = _context5.sent;

            case 5:
              _context5.prev = 5;
              _context5.next = 8;
              return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.delete('/service_api_keys/' + payload.id + '?' + __WEBPACK_IMPORTED_MODULE_4_query_string___default.a.stringify(payload.options));

            case 8:
              commit(REMOVE_SERVICE_API_KEY, payload);
              if (!payload.suppressNotifications) {
                commit(__WEBPACK_IMPORTED_MODULE_7__notifications__["c" /* REPLACE_NOTIFICATION */], {
                  id: notificationId,
                  text: 'Deleted service-api-key!',
                  color: 'success'
                });
              }
              return _context5.abrupt('return', true);

            case 13:
              _context5.prev = 13;
              _context5.t0 = _context5['catch'](5);

              commit(__WEBPACK_IMPORTED_MODULE_7__notifications__["c" /* REPLACE_NOTIFICATION */], {
                id: notificationId,
                text: 'Failed to delete service-api-key ',
                detail: _context5.t0.message,
                color: 'error'
              });

            case 16:
              return _context5.abrupt('return', false);

            case 17:
            case 'end':
              return _context5.stop();
          }
        }
      }, _callee5, this, [[5, 13]]);
    }));

    return function (_x9, _x10) {
      return _ref16.apply(this, arguments);
    };
  }()), _actions)
});

/***/ }),

/***/ 236:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export REPLACE_DEVICE_PROFILES */
/* unused harmony export ADD_DEVICE_PROFILES */
/* unused harmony export MODIFY_DEVICE_PROFILE */
/* unused harmony export REMOVE_DEVICE_PROFILE */
/* unused harmony export START_DEVICE_PROFILE_FETCHING */
/* unused harmony export DONE_DEVICE_PROFILE_FETCHING */
/* unused harmony export SET_DEVICE_PROFILES_TOTAL */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return FETCH_DEVICE_PROFILES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return FETCH_DEVICE_PROFILE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CREATE_DEVICE_PROFILE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return UPDATE_DEVICE_PROFILE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DELETE_DEVICE_PROFILE; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jsonapi_normalizer__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jsonapi_normalizer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jsonapi_normalizer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_object_path__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_object_path___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_object_path__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__session__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__notifications__ = __webpack_require__(13);
var _mutations, _actions;

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }










var REPLACE_DEVICE_PROFILES = 'REPLACE_DEVICE_PROFILES';
var ADD_DEVICE_PROFILES = 'ADD_DEVICE_PROFILES';
var MODIFY_DEVICE_PROFILE = 'MODIFY_DEVICE_PROFILE';
var REMOVE_DEVICE_PROFILE = 'REMOVE_DEVICE_PROFILE';
var START_DEVICE_PROFILE_FETCHING = 'START_DEVICE_PROFILE_FETCHING';
var DONE_DEVICE_PROFILE_FETCHING = 'DONE_DEVICE_PROFILE_FETCHING';
var SET_DEVICE_PROFILES_TOTAL = 'SET_DEVICE_PROFILES_TOTAL';

var FETCH_DEVICE_PROFILES = 'FETCH_DEVICE_PROFILES';
var FETCH_DEVICE_PROFILE = 'FETCH_DEVICE_PROFILE';
var CREATE_DEVICE_PROFILE = 'CREATE_DEVICE_PROFILE';
var UPDATE_DEVICE_PROFILE = 'UPDATE_DEVICE_PROFILE';
var DELETE_DEVICE_PROFILE = 'DELETE_DEVICE_PROFILE';

var initialState = function initialState() {
  return {
    entities: {},
    statistics: {
      total: null
    },
    fetch_status: {
      all: ''
    }
  };
};

/* harmony default export */ __webpack_exports__["f"] = ({
  state: initialState(),
  getters: {
    deviceProfileDefaults: function deviceProfileDefaults() {
      return {
        device_profile_id: '',
        supports_class_b: false,
        supports_class_c: false,
        mac_version: '1.0.2',
        reg_params_revision: 'B',
        max_eirp: 10,
        supports_join: true,
        rf_region: 'US915',
        supports_32bit_f_cnt: true
      };
    },
    deviceProfiles: function deviceProfiles(_ref
    //$FlowFixMe
    ) {
      var _ref$entities = _ref.entities,
          entities = _ref$entities === undefined ? {} : _ref$entities;
      return Object.keys(entities).map(function (key) {
        return entities[key];
      });
    },
    // Returns an object with all device-profiles, keyed by device-profile EUI
    deviceProfilesKeyedById: function deviceProfilesKeyedById(state, getters) {
      var deviceProfiles = {};
      getters.deviceProfiles.forEach(function (dp) {
        deviceProfiles[dp.id] = dp;
      });
      return deviceProfiles;
    },
    deviceProfilesById: function deviceProfilesById(state) {
      return function (id) {
        return state.entities[id] || {};
      };
    }
  },
  mutations: (_mutations = {
    RESET_STATE: function RESET_STATE(state) {
      Object.assign(state, initialState());
    }
  }, _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_4__session__["c" /* REMOVE_SESSION */], function (state) {
    state.entities = initialState().entities;
  }), _defineProperty(_mutations, START_DEVICE_PROFILE_FETCHING, function (state, payload) {
    state.fetch_status[payload.key] = 'loading';
  }), _defineProperty(_mutations, DONE_DEVICE_PROFILE_FETCHING, function (state, payload) {
    state.fetch_status[payload.key] = 'loaded';
  }), _defineProperty(_mutations, REPLACE_DEVICE_PROFILES, function (state, _ref2) {
    var _ref2$entities = _ref2.entities,
        entities = _ref2$entities === undefined ? {} : _ref2$entities;

    state.entities = entities;
  }), _defineProperty(_mutations, ADD_DEVICE_PROFILES, function (state, payload) {
    state.entities = Object.assign({}, state.entities, payload.entities);
  }), _defineProperty(_mutations, MODIFY_DEVICE_PROFILE, function (state, payload) {
    state.entities[payload.id] = Object.assign({}, state.entities[payload.id], payload);
  }), _defineProperty(_mutations, REMOVE_DEVICE_PROFILE, function (state, payload) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].delete(state.entities, payload.id);
  }), _defineProperty(_mutations, SET_DEVICE_PROFILES_TOTAL, function (state, payload) {
    state.statistics.total = payload.total;
  }), _mutations),
  actions: (_actions = {}, _defineProperty(_actions, FETCH_DEVICE_PROFILES, function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(_ref3, payload) {
      var commit = _ref3.commit,
          dispatch = _ref3.dispatch;

      var s1, _ref5, data, entities;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              s1 = null;
              _context.prev = 1;

              commit(START_DEVICE_PROFILE_FETCHING, { key: 'all' });
              if (payload && payload.organization_id) {
                s1 = '/organizations/' + payload.organization_id + '/device_profiles';
              } else {
                s1 = '/device_profiles';
              }

              _context.next = 6;
              return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(s1, payload);

            case 6:
              _ref5 = _context.sent;
              data = _ref5.data;

              commit(SET_DEVICE_PROFILES_TOTAL, { total: data.meta.pagination.collection_count });

              entities = {};

              data.data.map(function (dp) {
                entities[dp.id] = Object.assign({}, dp.attributes, dp.meta);
              });

              commit(REPLACE_DEVICE_PROFILES, {
                entities: __WEBPACK_IMPORTED_MODULE_2_jsonapi_normalizer___default()(data).entities.device_profiles
              });

              return _context.abrupt('return', {
                success: true
                // Return fetched data as flat array
              });

            case 15:
              _context.prev = 15;
              _context.t0 = _context['catch'](1);

              dispatch(__WEBPACK_IMPORTED_MODULE_5__notifications__["a" /* NEW_NOTIFICATION */], {
                text: 'Failed to load device-profiles ',
                detail: _context.t0.message,
                color: 'error'
              });

            case 18:
              _context.prev = 18;

              commit(DONE_DEVICE_PROFILE_FETCHING, { key: 'all' });
              return _context.finish(18);

            case 21:
              return _context.abrupt('return', { success: false });

            case 22:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this, [[1, 15, 18, 21]]);
    }));

    return function (_x, _x2) {
      return _ref4.apply(this, arguments);
    };
  }()), _defineProperty(_actions, FETCH_DEVICE_PROFILE, function () {
    var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(_ref6, payload) {
      var commit = _ref6.commit,
          dispatch = _ref6.dispatch;

      var _ref8, data, _normalize, entities, status;

      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('/device_profiles/' + payload.id);

            case 3:
              _ref8 = _context2.sent;
              data = _ref8.data;
              _normalize = __WEBPACK_IMPORTED_MODULE_2_jsonapi_normalizer___default()(data), entities = _normalize.entities;

              commit(ADD_DEVICE_PROFILES, { entities: entities.device_profiles });
              return _context2.abrupt('return', { success: true });

            case 10:
              _context2.prev = 10;
              _context2.t0 = _context2['catch'](0);
              status = __WEBPACK_IMPORTED_MODULE_3_object_path___default.a.get(_context2.t0, 'response.status');

              if (status !== 404) {
                dispatch(__WEBPACK_IMPORTED_MODULE_5__notifications__["a" /* NEW_NOTIFICATION */], {
                  text: 'Failed to load device-profile ',
                  detail: _context2.t0.message,
                  color: 'error'
                });
              }
              return _context2.abrupt('return', { success: false, status: status });

            case 15:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, this, [[0, 10]]);
    }));

    return function (_x3, _x4) {
      return _ref7.apply(this, arguments);
    };
  }()), _defineProperty(_actions, CREATE_DEVICE_PROFILE, function () {
    var _ref10 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(_ref9, payload) {
      var commit = _ref9.commit,
          dispatch = _ref9.dispatch;

      var _ref11, data, _normalize2, entities;

      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              _context3.next = 3;
              return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post('/device_profiles', {
                data: {
                  type: 'device_profiles',
                  attributes: payload.attributes,
                  relationships: payload.relationships
                }
              });

            case 3:
              _ref11 = _context3.sent;
              data = _ref11.data;
              _normalize2 = __WEBPACK_IMPORTED_MODULE_2_jsonapi_normalizer___default()(data), entities = _normalize2.entities;

              commit(ADD_DEVICE_PROFILES, { entities: entities.device_profiles });
              dispatch(__WEBPACK_IMPORTED_MODULE_5__notifications__["a" /* NEW_NOTIFICATION */], {
                text: 'Saved new device-profile!',
                color: 'success'
              });
              return _context3.abrupt('return', data.data.attributes.id);

            case 11:
              _context3.prev = 11;
              _context3.t0 = _context3['catch'](0);

              dispatch(__WEBPACK_IMPORTED_MODULE_5__notifications__["a" /* NEW_NOTIFICATION */], {
                text: 'Failed to save device-profile ',
                detail: _context3.t0.message,
                color: 'error'
              });

            case 14:
              return _context3.abrupt('return', false);

            case 15:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, this, [[0, 11]]);
    }));

    return function (_x5, _x6) {
      return _ref10.apply(this, arguments);
    };
  }()), _defineProperty(_actions, UPDATE_DEVICE_PROFILE, function () {
    var _ref13 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(_ref12, payload) {
      var commit = _ref12.commit,
          dispatch = _ref12.dispatch;

      var notificationId, _ref14, data, _normalize3, entities;

      return regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return dispatch(__WEBPACK_IMPORTED_MODULE_5__notifications__["a" /* NEW_NOTIFICATION */], {
                text: 'Saving...',
                color: 'secondary',
                undoable: true
              });

            case 2:
              notificationId = _context4.sent;
              _context4.prev = 3;
              _context4.next = 6;
              return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.patch('/device_profiles/' + payload.id, {
                data: {
                  type: 'device_profiles',
                  attributes: payload.attributes,
                  relationships: payload.relationships
                }
              });

            case 6:
              _ref14 = _context4.sent;
              data = _ref14.data;
              _normalize3 = __WEBPACK_IMPORTED_MODULE_2_jsonapi_normalizer___default()(data), entities = _normalize3.entities;

              commit(MODIFY_DEVICE_PROFILE, entities.device_profiles[payload.id]);
              commit(__WEBPACK_IMPORTED_MODULE_5__notifications__["c" /* REPLACE_NOTIFICATION */], {
                id: notificationId,
                text: 'Saved!',
                color: 'success',
                undoable: true
              });
              return _context4.abrupt('return', true);

            case 14:
              _context4.prev = 14;
              _context4.t0 = _context4['catch'](3);

              commit(__WEBPACK_IMPORTED_MODULE_5__notifications__["c" /* REPLACE_NOTIFICATION */], {
                id: notificationId,
                text: 'Failed to update device-profile ',
                detail: _context4.t0.message,
                color: 'error'
              });

            case 17:
              return _context4.abrupt('return', false);

            case 18:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, this, [[3, 14]]);
    }));

    return function (_x7, _x8) {
      return _ref13.apply(this, arguments);
    };
  }()), _defineProperty(_actions, DELETE_DEVICE_PROFILE, function () {
    var _ref16 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(_ref15, payload) {
      var commit = _ref15.commit,
          dispatch = _ref15.dispatch;
      var notificationId;
      return regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return dispatch(__WEBPACK_IMPORTED_MODULE_5__notifications__["a" /* NEW_NOTIFICATION */], {
                text: 'Deleting device-profile...',
                color: 'secondary'
              });

            case 2:
              notificationId = _context5.sent;
              _context5.prev = 3;
              _context5.next = 6;
              return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.delete('/device_profiles/' + payload.id);

            case 6:
              commit(REMOVE_DEVICE_PROFILE, payload);
              commit(__WEBPACK_IMPORTED_MODULE_5__notifications__["c" /* REPLACE_NOTIFICATION */], {
                id: notificationId,
                text: 'Deleted device-profile!',
                color: 'success'
              });
              return _context5.abrupt('return', true);

            case 11:
              _context5.prev = 11;
              _context5.t0 = _context5['catch'](3);

              commit(__WEBPACK_IMPORTED_MODULE_5__notifications__["c" /* REPLACE_NOTIFICATION */], {
                id: notificationId,
                text: 'Failed to delete device-profile ',
                detail: _context5.t0.message,
                color: 'error'
              });

            case 14:
              return _context5.abrupt('return', false);

            case 15:
            case 'end':
              return _context5.stop();
          }
        }
      }, _callee5, this, [[3, 11]]);
    }));

    return function (_x9, _x10) {
      return _ref16.apply(this, arguments);
    };
  }()), _actions)
});

/***/ }),

/***/ 238:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export REPLACE_POLICIES */
/* unused harmony export ADD_POLICIES */
/* unused harmony export MODIFY_POLICY */
/* unused harmony export REMOVE_POLICY */
/* unused harmony export START_POLICY_FETCHING */
/* unused harmony export DONE_POLICY_FETCHING */
/* unused harmony export SET_POLICIES_TOTAL */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return FETCH_POLICIES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return FETCH_POLICY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CREATE_POLICY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return UPDATE_POLICY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DELETE_POLICY; });
/* unused harmony export RESET_STATE */
/* unused harmony export PUSH_EUI */
/* unused harmony export REMOVE_EUI */
/* unused harmony export MODIFY_EUI */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jsonapi_normalizer__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jsonapi_normalizer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jsonapi_normalizer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_object_path__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_object_path___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_object_path__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_query_string__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_query_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__session__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__notifications__ = __webpack_require__(13);
var _mutations, _actions;

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }









// import type {JsonApiEntity} from '@/store'

var REPLACE_POLICIES = 'REPLACE_POLICIES';
var ADD_POLICIES = 'ADD_POLICIES';
var MODIFY_POLICY = 'MODIFY_POLICY';
var REMOVE_POLICY = 'REMOVE_POLICY';
var START_POLICY_FETCHING = 'START_POLICY_FETCHING';
var DONE_POLICY_FETCHING = 'DONE_POLICY_FETCHING';
var SET_POLICIES_TOTAL = 'SET_POLICIES_TOTAL';

var FETCH_POLICIES = 'FETCH_POLICIES';
var FETCH_POLICY = 'FETCH_POLICY';
var CREATE_POLICY = 'CREATE_POLICY';
var UPDATE_POLICY = 'UPDATE_POLICY';
var DELETE_POLICY = 'DELETE_POLICY';
var RESET_STATE = 'RESET_STATE';
var PUSH_EUI = 'PUSH_EUI';
var REMOVE_EUI = 'REMOVE_EUI';
var MODIFY_EUI = 'MODIFY_EUI';

var initialState = function initialState() {
  return {
    entities: {},
    statistics: {
      total: null
    },
    fetch_status: {
      all: ''
    }
  };
};

/* harmony default export */ __webpack_exports__["f"] = ({
  state: initialState(),
  getters: {
    policyDefaults: function policyDefaults() {
      return { end_device_euis_from_eui_filters: [] };
    },
    policies: function policies(_ref
    //$FlowFixMe
    ) {
      var _ref$entities = _ref.entities,
          entities = _ref$entities === undefined ? {} : _ref$entities;
      return Object.keys(entities).map(function (key) {
        return entities[key];
      });
    },
    policiesKeyedByEui: function policiesKeyedByEui(state, getters) {
      var policies = {};
      getters.policies.forEach(function (policy) {
        policies[policy.eui] = policy;
      });
      return policies;
    },
    policyById: function policyById(state) {
      return function (id) {
        return state.entities[id] || {};
      };
    },
    policyByEui: function policyByEui(state, getters) {
      return function (eui) {
        return getters.policies.find(function (policy) {
          return policy.eui === eui;
        }) || {};
      };
    }
  },
  mutations: (_mutations = {}, _defineProperty(_mutations, PUSH_EUI, function (state, payload) {
    state.entities[payload.id].end_device_euis_from_eui_filters.push(payload.entity);
  }), _defineProperty(_mutations, REMOVE_EUI, function (state, payload) {
    state.entities[payload.id].end_device_euis_from_eui_filters.splice(payload.index, 1);
  }), _defineProperty(_mutations, MODIFY_EUI, function (state, payload) {
    state.entities[payload.id].end_device_euis_from_eui_filters[payload.index].min_eui = payload.entity;
  }), _defineProperty(_mutations, RESET_STATE, function (state) {
    Object.assign(state, initialState());
    state.entities = initialState().entities;
  }), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_5__session__["c" /* REMOVE_SESSION */], function (state) {
    state.entities = initialState().entities;
  }), _defineProperty(_mutations, START_POLICY_FETCHING, function (state, payload) {
    state.fetch_status[payload.key] = 'loading';
  }), _defineProperty(_mutations, DONE_POLICY_FETCHING, function (state, payload) {
    state.fetch_status[payload.key] = 'loaded';
  }), _defineProperty(_mutations, REPLACE_POLICIES, function (state, _ref2) {
    var _ref2$entities = _ref2.entities,
        entities = _ref2$entities === undefined ? {} : _ref2$entities;

    state.entities = entities;
  }), _defineProperty(_mutations, ADD_POLICIES, function (state, payload) {
    state.entities = Object.assign({}, state.entities, payload.entities);
  }), _defineProperty(_mutations, MODIFY_POLICY, function (state, payload) {
    state.entities[payload.id] = Object.assign({}, state.entities[payload.id], payload);
  }), _defineProperty(_mutations, REMOVE_POLICY, function (state, payload) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].delete(state.entities, payload.id);
  }), _defineProperty(_mutations, SET_POLICIES_TOTAL, function (state, payload) {
    state.statistics.total = payload.total;
  }), _mutations),
  actions: (_actions = {}, _defineProperty(_actions, RESET_STATE, function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(state) {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              this.commit(RESET_STATE, state);

            case 1:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    return function (_x) {
      return _ref3.apply(this, arguments);
    };
  }()), _defineProperty(_actions, FETCH_POLICIES, function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(_ref4, payload) {
      var commit = _ref4.commit,
          dispatch = _ref4.dispatch;

      var pathstring, _ref6, data, entities;

      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;

              commit(START_POLICY_FETCHING, { key: 'all' });
              pathstring = '/policies?limit=200';


              if (!!payload && payload.orgId) {
                pathstring = '/organizations/' + payload.orgId + '/policies';
              }

              _context2.next = 6;
              return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(pathstring);

            case 6:
              _ref6 = _context2.sent;
              data = _ref6.data;


              commit(SET_POLICIES_TOTAL, {
                total: data.meta.pagination.collection_count
              });
              entities = {};

              data.data.map(function (policy) {
                entities[policy.id] = Object.assign({}, policy.attributes, policy.meta);
              });

              commit(REPLACE_POLICIES, {
                entities: entities
              });
              _context2.next = 17;
              break;

            case 14:
              _context2.prev = 14;
              _context2.t0 = _context2['catch'](0);

              dispatch(__WEBPACK_IMPORTED_MODULE_6__notifications__["a" /* NEW_NOTIFICATION */], {
                text: 'Failed to load policies.',
                detail: _context2.t0.message,
                color: 'error'
              });

            case 17:
              _context2.prev = 17;

              commit(DONE_POLICY_FETCHING, { key: 'all' });
              return _context2.finish(17);

            case 20:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, this, [[0, 14, 17, 20]]);
    }));

    return function (_x2, _x3) {
      return _ref5.apply(this, arguments);
    };
  }()), _defineProperty(_actions, FETCH_POLICY, function () {
    var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(_ref7, payload) {
      var commit = _ref7.commit,
          dispatch = _ref7.dispatch;

      var _ref9, data, status;

      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              _context3.next = 3;
              return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('/policies/' + payload.id);

            case 3:
              _ref9 = _context3.sent;
              data = _ref9.data.data;


              // gateways_from
              if (!data.relationships['gateways_from_gateways']) data.relationships['gateways_from_gateways'] = [];
              data.relationships.gateways_from.data.gateways.forEach(function (elem) {
                return data.relationships['gateways_from_gateways'].push({
                  type: 'gateway',
                  id: elem['id']
                });
              });

              if (!data.relationships['gateways_from_application_networks']) data.relationships['gateways_from_application_networks'] = [];
              data.relationships.gateways_from.data.application_networks.forEach(function (elem) {
                return data.relationships['gateways_from_application_networks'].push({
                  type: 'application_network',
                  id: elem['id']
                });
              });

              delete data.relationships.gateways_from;

              //end_device_euis_from_application_networks
              if (!data.relationships['end_device_euis_from_application_networks']) data.relationships['end_device_euis_from_application_networks'] = [];
              data.relationships.end_device_euis_from.data.application_networks.forEach(function (elem) {
                return data.relationships['end_device_euis_from_application_networks'].push({
                  type: 'application_network',
                  id: elem['id']
                });
              });

              if (!data.relationships['end_device_euis_from_device_groups']) data.relationships['end_device_euis_from_device_groups'] = [];
              data.relationships['end_device_euis_from_device_groups'] = data.relationships.end_device_euis_from.data.device_groups;

              if (!data.relationships['end_device_euis_from_eui_filters']) data.relationships['end_device_euis_from_eui_filters'] = [];
              data.relationships.end_device_euis_from_eui_filters = data.relationships.end_device_euis_from.data.eui_filters;
              data.relationships.end_device_euis_from_eui_filters.forEach(function (elem) {
                if (!(elem.max_eui === elem.min_eui)) {
                  elem.filter_type = elem.filter_type.concat('-range');
                }
              });
              delete data.relationships.end_device_euis_from;

              commit(ADD_POLICIES, {
                entities: _defineProperty({}, data.id, Object.assign({}, data.attributes, data.relationships, data.meta))
              });
              return _context3.abrupt('return', { success: true });

            case 22:
              _context3.prev = 22;
              _context3.t0 = _context3['catch'](0);
              status = __WEBPACK_IMPORTED_MODULE_3_object_path___default.a.get(_context3.t0, 'response.status');

              if (status !== 404) {
                dispatch(__WEBPACK_IMPORTED_MODULE_6__notifications__["a" /* NEW_NOTIFICATION */], {
                  text: 'Failed to load policy.',
                  detail: _context3.t0.message,
                  color: 'error'
                });
              }
              return _context3.abrupt('return', { success: false, status: status });

            case 27:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, this, [[0, 22]]);
    }));

    return function (_x4, _x5) {
      return _ref8.apply(this, arguments);
    };
  }()), _defineProperty(_actions, CREATE_POLICY, function () {
    var _ref11 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(_ref10, payload) {
      var commit = _ref10.commit,
          dispatch = _ref10.dispatch;

      var relationships, gatewaysFrom, _ref12, data, _normalize, entities;

      return regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              // massage data to make api happy
              relationships = {};
              // handle the "Applies To" section:

              gatewaysFrom = {
                application_network_ids: payload.relationships.gateways_from_application_networks ? payload.relationships.gateways_from_application_networks.data : [],
                gateway_ids: payload.relationships.gateways_from_gateways ? payload.relationships.gateways_from_gateways.data : []
              };

              gatewaysFrom.gateway_ids = gatewaysFrom.gateway_ids.filter(function (i) {
                return i && i['id'];
              }).map(function (i) {
                return i['id'];
              });
              gatewaysFrom.application_network_ids = gatewaysFrom.application_network_ids.filter(function (i) {
                return i && i['id'];
              }).map(function (i) {
                return i['id'];
              });
              relationships.gateways_from = gatewaysFrom;
              delete payload.relationships['gateways_from_application_networks'];
              delete payload.relationships['gateways_from_gateways'];

              // Handle the "Filters" section here:

              // Handle dev euis
              if (!relationships.end_device_euis_from) relationships.end_device_euis_from = {};
              if (!relationships.end_device_euis_from.eui_filters) relationships.end_device_euis_from.eui_filters = payload.relationships.end_device_euis_from_eui_filters.data;

              if (!relationships.end_device_euis_from.application_networks) relationships.end_device_euis_from.application_networks = [];

              // handle application networks
              if (payload.relationships['end_device_euis_from_application_networks']) {
                payload.relationships.end_device_euis_from_application_networks.data.forEach(function (elem) {
                  return relationships.end_device_euis_from['application_networks'].push({
                    id: elem['id']
                  });
                });
                delete payload.relationships['end_device_euis_from_application_networks'];
              }
              // handle device groups
              if (!relationships.end_device_euis_from.device_groups) relationships.end_device_euis_from.device_groups = [];
              if (payload.relationships['end_device_euis_from_device_groups']) {
                payload.relationships['end_device_euis_from_device_groups'].data.forEach(function (elem) {
                  return relationships.end_device_euis_from['device_groups'].push({
                    id: elem
                  });
                });

                delete payload.relationships['end_device_euis_from_device_groups'];
              }

              payload.relationships = relationships;

              _context4.prev = 14;
              _context4.next = 17;
              return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post('/policies', {
                data: {
                  type: 'policies',
                  attributes: payload.attributes,
                  relationships: payload.relationships
                }
              });

            case 17:
              _ref12 = _context4.sent;
              data = _ref12.data;
              _normalize = __WEBPACK_IMPORTED_MODULE_2_jsonapi_normalizer___default()(data), entities = _normalize.entities;

              commit(ADD_POLICIES, { entities: entities.policies });
              if (!payload.suppressNotifications) {
                dispatch(__WEBPACK_IMPORTED_MODULE_6__notifications__["a" /* NEW_NOTIFICATION */], {
                  text: 'Saved new policy!',
                  color: 'success'
                });
              }
              return _context4.abrupt('return', data.data.attributes.id);

            case 25:
              _context4.prev = 25;
              _context4.t0 = _context4['catch'](14);

              dispatch(__WEBPACK_IMPORTED_MODULE_6__notifications__["a" /* NEW_NOTIFICATION */], {
                text: 'Failed to save policy',
                detail: _context4.t0.message,
                color: 'error'
              });

            case 28:
              return _context4.abrupt('return', false);

            case 29:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, this, [[14, 25]]);
    }));

    return function (_x6, _x7) {
      return _ref11.apply(this, arguments);
    };
  }()), _defineProperty(_actions, UPDATE_POLICY, function () {
    var _ref14 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(_ref13, payload) {
      var commit = _ref13.commit,
          dispatch = _ref13.dispatch;

      var notificationId, relationships, gatewaysFrom, _ref15, data, _normalize2, entities;

      return regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              notificationId = void 0;

              if (payload.suppressNotifications) {
                _context5.next = 5;
                break;
              }

              _context5.next = 4;
              return dispatch(__WEBPACK_IMPORTED_MODULE_6__notifications__["a" /* NEW_NOTIFICATION */], {
                text: 'Saving...',
                undoable: true,
                color: 'secondary'
              });

            case 4:
              notificationId = _context5.sent;

            case 5:
              // massage data to make api happy
              relationships = {};
              // handle the "Applies To" section:

              gatewaysFrom = {
                application_network_ids: payload.relationships['gateways_from_application_networks'] ? payload.relationships['gateways_from_application_networks'].data : [],
                gateway_ids: payload.relationships['gateways_from_gateways'] ? payload.relationships['gateways_from_gateways'].data : []
              };

              gatewaysFrom.gateway_ids = gatewaysFrom.gateway_ids.filter(function (i) {
                return i && i['id'];
              }).map(function (i) {
                return i['id'];
              });
              gatewaysFrom.application_network_ids = gatewaysFrom.application_network_ids.filter(function (i) {
                return i && i['id'];
              }).map(function (i) {
                return i['id'];
              });
              relationships.gateways_from = gatewaysFrom;
              delete payload.relationships['gateways_from_application_networks'];
              delete payload.relationships['gateways_from_gateways'];

              // Handle the "Filters" section here:

              // Handle dev euis
              if (!relationships.end_device_euis_from) relationships.end_device_euis_from = {};
              if (!relationships.end_device_euis_from.eui_filters) relationships.end_device_euis_from.eui_filters = payload.relationships.end_device_euis_from_eui_filters.data;

              if (!relationships.end_device_euis_from.application_networks) relationships.end_device_euis_from.application_networks = [];

              // handle application networks
              if (payload.relationships.end_device_euis_from_application_networks) {
                payload.relationships.end_device_euis_from_application_networks.data.forEach(function (elem) {
                  return relationships.end_device_euis_from['application_networks'].push({
                    id: elem['id']
                  });
                });
                delete payload.relationships['end_device_euis_from_application_networks'];
              }
              // handle device groups
              if (!relationships.end_device_euis_from.device_groups) relationships.end_device_euis_from.device_groups = [];
              if (payload.relationships.end_device_euis_from_device_groups && payload.relationships.end_device_euis_from_device_groups.data) {
                /*eslint-disable */
                payload.relationships.end_device_euis_from_device_groups.data.forEach(function (elem) {
                  // console.log(elem)
                  // # this bug fix is bit unclean.. the elem should always be a string, but what happens
                  // is that when the user chooses items in the selector, elem is a string with the id 
                  // of the device_group. But if they just click update on a form where they had not
                  // updated this input selector, elem is for some reason an object 
                  if (typeof elem === "string") {
                    return relationships.end_device_euis_from.device_groups.push({
                      id: elem
                    });
                  } else {
                    return relationships.end_device_euis_from.device_groups.push({
                      id: elem["id"]
                    });
                  }
                });
                /*eslint-enable */
                delete payload.relationships['end_device_euis_from_device_groups'];
              }

              payload.relationships = relationships;
              // xhr call
              _context5.prev = 19;
              _context5.next = 22;
              return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.patch('/policies/' + payload.id, {
                data: {
                  type: 'policies',
                  attributes: payload.attributes,
                  relationships: payload.relationships
                }
              });

            case 22:
              _ref15 = _context5.sent;
              data = _ref15.data;
              _normalize2 = __WEBPACK_IMPORTED_MODULE_2_jsonapi_normalizer___default()(data), entities = _normalize2.entities;

              commit(MODIFY_POLICY, entities.policies[payload.id]);
              if (!payload.suppressNotifications) {
                commit(__WEBPACK_IMPORTED_MODULE_6__notifications__["c" /* REPLACE_NOTIFICATION */], {
                  id: notificationId,
                  text: 'Saved!',
                  color: 'success',
                  undoable: true
                });
              }
              return _context5.abrupt('return', true);

            case 30:
              _context5.prev = 30;
              _context5.t0 = _context5['catch'](19);

              commit(__WEBPACK_IMPORTED_MODULE_6__notifications__["c" /* REPLACE_NOTIFICATION */], {
                id: notificationId,
                text: 'Failed to update policy ',
                detail: _context5.t0.message,
                color: 'error'
              });

            case 33:
              return _context5.abrupt('return', false);

            case 34:
            case 'end':
              return _context5.stop();
          }
        }
      }, _callee5, this, [[19, 30]]);
    }));

    return function (_x8, _x9) {
      return _ref14.apply(this, arguments);
    };
  }()), _defineProperty(_actions, DELETE_POLICY, function () {
    var _ref17 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(_ref16, payload) {
      var commit = _ref16.commit,
          dispatch = _ref16.dispatch;
      var notificationId;
      return regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              notificationId = void 0;

              if (payload.suppressNotifications) {
                _context6.next = 5;
                break;
              }

              _context6.next = 4;
              return dispatch(__WEBPACK_IMPORTED_MODULE_6__notifications__["a" /* NEW_NOTIFICATION */], {
                text: 'Deleting policy...',
                color: 'secondary'
              });

            case 4:
              notificationId = _context6.sent;

            case 5:
              _context6.prev = 5;
              _context6.next = 8;
              return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.delete('/policies/' + payload.id + '?' + __WEBPACK_IMPORTED_MODULE_4_query_string___default.a.stringify(payload.options));

            case 8:
              commit(REMOVE_POLICY, payload);
              if (!payload.suppressNotifications) {
                commit(__WEBPACK_IMPORTED_MODULE_6__notifications__["c" /* REPLACE_NOTIFICATION */], {
                  id: notificationId,
                  text: 'Deleted policy!',
                  color: 'success'
                });
              }
              return _context6.abrupt('return', true);

            case 13:
              _context6.prev = 13;
              _context6.t0 = _context6['catch'](5);

              commit(__WEBPACK_IMPORTED_MODULE_6__notifications__["c" /* REPLACE_NOTIFICATION */], {
                id: notificationId,
                text: 'Failed to delete policy ',
                detail: _context6.t0.message,
                color: 'error'
              });

            case 16:
              return _context6.abrupt('return', false);

            case 17:
            case 'end':
              return _context6.stop();
          }
        }
      }, _callee6, this, [[5, 13]]);
    }));

    return function (_x10, _x11) {
      return _ref17.apply(this, arguments);
    };
  }()), _actions)
});

/***/ }),

/***/ 240:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return FETCH_END_DEVICE_PACKETS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return FETCH_GATEWAY_PACKETS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FETCH_APPLICATION_NETWORK_PACKETS; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_object_path__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_object_path___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_object_path__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_api__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__notifications__ = __webpack_require__(13);
var _actions;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }







var FETCH_END_DEVICE_PACKETS = 'FETCH_END_DEVICE_PACKETS';
var FETCH_GATEWAY_PACKETS = 'FETCH_GATEWAY_PACKETS';
var FETCH_APPLICATION_NETWORK_PACKETS = 'FETCH_APPLICATION_NETWORK_PACKETS';

/* harmony default export */ __webpack_exports__["d"] = ({
  state: {},
  getters: {},
  mutations: {},
  actions: (_actions = {}, _defineProperty(_actions, FETCH_END_DEVICE_PACKETS, function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(_ref, payload) {
      var dispatch = _ref.dispatch;

      var _ref3, data, pagination;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/end_devices/' + payload.context.endDeviceEui + '/packets', {
                params: Object(__WEBPACK_IMPORTED_MODULE_2__utils_api__["a" /* computePaginateSortFilterParams */])(payload)
              });

            case 3:
              _ref3 = _context.sent;
              data = _ref3.data;
              pagination = data.meta.pagination;
              return _context.abrupt('return', {
                success: true,
                // Return fetched data as flat array
                items: data.data.map(function (item) {
                  return item.attributes;
                }),
                collectionCount: Object(__WEBPACK_IMPORTED_MODULE_2__utils_api__["b" /* computedCollectionCount */])({
                  endRow: payload.endRow,
                  filteredCount: pagination.filtered_count,
                  collectionCount: pagination.collection_count
                })
              });

            case 9:
              _context.prev = 9;
              _context.t0 = _context['catch'](0);

              if (__WEBPACK_IMPORTED_MODULE_1_object_path___default.a.get(_context.t0, 'response.status') !== 404) {
                dispatch(__WEBPACK_IMPORTED_MODULE_3__notifications__["a" /* NEW_NOTIFICATION */], {
                  text: 'Failed to load packets ',
                  detail: _context.t0.message,
                  color: 'error'
                });
              }

            case 12:
              return _context.abrupt('return', { success: false });

            case 13:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this, [[0, 9]]);
    }));

    return function (_x, _x2) {
      return _ref2.apply(this, arguments);
    };
  }()), _defineProperty(_actions, FETCH_GATEWAY_PACKETS, function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(_ref4, payload) {
      var dispatch = _ref4.dispatch;

      var _ref6, data, pagination;

      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/gateways/' + payload.context.gatewayEui + '/packets', {
                params: Object(__WEBPACK_IMPORTED_MODULE_2__utils_api__["a" /* computePaginateSortFilterParams */])(payload)
              });

            case 3:
              _ref6 = _context2.sent;
              data = _ref6.data;
              pagination = data.meta.pagination;
              return _context2.abrupt('return', {
                success: true,
                // Return fetched data as flat array
                items: data.data.map(function (item) {
                  return item.attributes;
                }),
                collectionCount: Object(__WEBPACK_IMPORTED_MODULE_2__utils_api__["b" /* computedCollectionCount */])({
                  endRow: payload.endRow,
                  filteredCount: pagination.filtered_count,
                  collectionCount: pagination.collection_count
                })
              });

            case 9:
              _context2.prev = 9;
              _context2.t0 = _context2['catch'](0);

              if (__WEBPACK_IMPORTED_MODULE_1_object_path___default.a.get(_context2.t0, 'response.status') !== 404) {
                dispatch(__WEBPACK_IMPORTED_MODULE_3__notifications__["a" /* NEW_NOTIFICATION */], {
                  text: 'Failed to load packets ',
                  detail: _context2.t0.message,
                  color: 'error'
                });
              }

            case 12:
              return _context2.abrupt('return', { success: false });

            case 13:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, this, [[0, 9]]);
    }));

    return function (_x3, _x4) {
      return _ref5.apply(this, arguments);
    };
  }()), _defineProperty(_actions, FETCH_APPLICATION_NETWORK_PACKETS, function () {
    var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(_ref7, payload) {
      var dispatch = _ref7.dispatch;

      var _ref9, data, pagination;

      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              _context3.next = 3;
              return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/application_networks/' + payload.context.appEui + '/packets', {
                params: Object(__WEBPACK_IMPORTED_MODULE_2__utils_api__["a" /* computePaginateSortFilterParams */])(payload)
              });

            case 3:
              _ref9 = _context3.sent;
              data = _ref9.data;
              pagination = data.meta.pagination;
              return _context3.abrupt('return', {
                success: true,
                // Return fetched data as flat array
                items: data.data.map(function (item) {
                  return item.attributes;
                }),
                collectionCount: Object(__WEBPACK_IMPORTED_MODULE_2__utils_api__["b" /* computedCollectionCount */])({
                  endRow: payload.endRow,
                  filteredCount: pagination.filtered_count,
                  collectionCount: pagination.collection_count
                })
              });

            case 9:
              _context3.prev = 9;
              _context3.t0 = _context3['catch'](0);

              if (__WEBPACK_IMPORTED_MODULE_1_object_path___default.a.get(_context3.t0, 'response.status') !== 404) {
                dispatch(__WEBPACK_IMPORTED_MODULE_3__notifications__["a" /* NEW_NOTIFICATION */], {
                  text: 'Failed to load packets ',
                  detail: _context3.t0.message,
                  color: 'error'
                });
              }

            case 12:
              return _context3.abrupt('return', { success: false });

            case 13:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, this, [[0, 9]]);
    }));

    return function (_x5, _x6) {
      return _ref8.apply(this, arguments);
    };
  }()), _actions)
});

/***/ }),

/***/ 241:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return FETCH_END_DEVICE_JOIN_REQS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return FETCH_GATEWAY_JOIN_REQS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FETCH_APPLICATION_NETWORK_JOIN_REQS; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_object_path__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_object_path___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_object_path__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_api__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__notifications__ = __webpack_require__(13);
var _actions;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }







var FETCH_END_DEVICE_JOIN_REQS = 'FETCH_END_DEVICE_JOIN_REQS';
var FETCH_GATEWAY_JOIN_REQS = 'FETCH_GATEWAY_JOIN_REQS';
var FETCH_APPLICATION_NETWORK_JOIN_REQS = 'FETCH_APPLICATION_NETWORK_JOIN_REQS';

/* harmony default export */ __webpack_exports__["d"] = ({
  state: {},
  getters: {},
  mutations: {},
  actions: (_actions = {}, _defineProperty(_actions, FETCH_END_DEVICE_JOIN_REQS, function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(_ref, payload) {
      var dispatch = _ref.dispatch;

      var _ref3, data, pagination;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/end_devices/' + payload.context.endDeviceEui + '/join_requests', {
                params: Object(__WEBPACK_IMPORTED_MODULE_2__utils_api__["a" /* computePaginateSortFilterParams */])(payload)
              });

            case 3:
              _ref3 = _context.sent;
              data = _ref3.data;
              pagination = data.meta.pagination;
              return _context.abrupt('return', {
                success: true,
                // Return fetched data as flat array
                items: data.data.map(function (item) {
                  return item.attributes;
                }),
                collectionCount: Object(__WEBPACK_IMPORTED_MODULE_2__utils_api__["b" /* computedCollectionCount */])({
                  endRow: payload.endRow,
                  filteredCount: pagination.filtered_count,
                  collectionCount: pagination.collection_count
                })
              });

            case 9:
              _context.prev = 9;
              _context.t0 = _context['catch'](0);

              if (__WEBPACK_IMPORTED_MODULE_1_object_path___default.a.get(_context.t0, 'response.status') !== 404) {
                dispatch(__WEBPACK_IMPORTED_MODULE_3__notifications__["a" /* NEW_NOTIFICATION */], {
                  text: 'Failed to load join requests ',
                  detail: _context.t0.message,
                  color: 'error'
                });
              }

            case 12:
              return _context.abrupt('return', { success: false });

            case 13:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this, [[0, 9]]);
    }));

    return function (_x, _x2) {
      return _ref2.apply(this, arguments);
    };
  }()), _defineProperty(_actions, FETCH_GATEWAY_JOIN_REQS, function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(_ref4, payload) {
      var dispatch = _ref4.dispatch;

      var _ref6, data, pagination;

      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/gateways/' + payload.context.gatewayEui + '/join_requests', {
                params: Object(__WEBPACK_IMPORTED_MODULE_2__utils_api__["a" /* computePaginateSortFilterParams */])(payload)
              });

            case 3:
              _ref6 = _context2.sent;
              data = _ref6.data;
              pagination = data.meta.pagination;
              return _context2.abrupt('return', {
                success: true,
                // Return fetched data as flat array
                items: data.data.map(function (item) {
                  return item.attributes;
                }),
                collectionCount: Object(__WEBPACK_IMPORTED_MODULE_2__utils_api__["b" /* computedCollectionCount */])({
                  endRow: payload.endRow,
                  filteredCount: pagination.filtered_count,
                  collectionCount: pagination.collection_count
                })
              });

            case 9:
              _context2.prev = 9;
              _context2.t0 = _context2['catch'](0);

              if (__WEBPACK_IMPORTED_MODULE_1_object_path___default.a.get(_context2.t0, 'response.status') !== 404) {
                dispatch(__WEBPACK_IMPORTED_MODULE_3__notifications__["a" /* NEW_NOTIFICATION */], {
                  text: 'Failed to load join requests ',
                  detail: _context2.t0.message,
                  color: 'error'
                });
              }

            case 12:
              return _context2.abrupt('return', { success: false });

            case 13:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, this, [[0, 9]]);
    }));

    return function (_x3, _x4) {
      return _ref5.apply(this, arguments);
    };
  }()), _defineProperty(_actions, FETCH_APPLICATION_NETWORK_JOIN_REQS, function () {
    var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(_ref7, payload) {
      var dispatch = _ref7.dispatch;

      var _ref9, data, pagination;

      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              _context3.next = 3;
              return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/application_networks/' + payload.context.appEui + '/join_requests', {
                params: Object(__WEBPACK_IMPORTED_MODULE_2__utils_api__["a" /* computePaginateSortFilterParams */])(payload)
              });

            case 3:
              _ref9 = _context3.sent;
              data = _ref9.data;
              pagination = data.meta.pagination;
              return _context3.abrupt('return', {
                success: true,
                // Return fetched data as flat array
                items: data.data.map(function (item) {
                  return item.attributes;
                }),
                collectionCount: Object(__WEBPACK_IMPORTED_MODULE_2__utils_api__["b" /* computedCollectionCount */])({
                  endRow: payload.endRow,
                  filteredCount: pagination.filtered_count,
                  collectionCount: pagination.collection_count
                })
              });

            case 9:
              _context3.prev = 9;
              _context3.t0 = _context3['catch'](0);

              if (__WEBPACK_IMPORTED_MODULE_1_object_path___default.a.get(_context3.t0, 'response.status') !== 404) {
                dispatch(__WEBPACK_IMPORTED_MODULE_3__notifications__["a" /* NEW_NOTIFICATION */], {
                  text: 'Failed to load join requests ',
                  detail: _context3.t0.message,
                  color: 'error'
                });
              }

            case 12:
              return _context3.abrupt('return', { success: false });

            case 13:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, this, [[0, 9]]);
    }));

    return function (_x5, _x6) {
      return _ref8.apply(this, arguments);
    };
  }()), _actions)
});

/***/ }),

/***/ 242:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FETCH_GATEWAY_STATISTICS; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_object_path__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_object_path___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_object_path__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_api__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__notifications__ = __webpack_require__(13);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }







var FETCH_GATEWAY_STATISTICS = 'FETCH_GATEWAY_STATISTICS';

/* harmony default export */ __webpack_exports__["b"] = ({
  state: {},
  getters: {},
  mutations: {},
  actions: _defineProperty({}, FETCH_GATEWAY_STATISTICS, function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(_ref, payload) {
      var dispatch = _ref.dispatch;

      var _ref3, data, pagination;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/gateways/' + payload.context.eui + '/gateway_statistics', {
                params: Object(__WEBPACK_IMPORTED_MODULE_2__utils_api__["a" /* computePaginateSortFilterParams */])(payload)
              });

            case 3:
              _ref3 = _context.sent;
              data = _ref3.data;
              pagination = data.meta.pagination;
              return _context.abrupt('return', {
                success: true,
                // Return fetched data as flat array
                items: data.data.map(function (item) {
                  return item.attributes;
                }),
                collectionCount: Object(__WEBPACK_IMPORTED_MODULE_2__utils_api__["b" /* computedCollectionCount */])({
                  endRow: payload.endRow,
                  filteredCount: pagination.filtered_count,
                  collectionCount: pagination.collection_count
                })
              });

            case 9:
              _context.prev = 9;
              _context.t0 = _context['catch'](0);

              if (__WEBPACK_IMPORTED_MODULE_1_object_path___default.a.get(_context.t0, 'response.status') !== 404) {
                dispatch(__WEBPACK_IMPORTED_MODULE_3__notifications__["a" /* NEW_NOTIFICATION */], {
                  text: 'Failed to load gateway statistics ',
                  detail: _context.t0.message,
                  color: 'error'
                });
              }

            case 12:
              return _context.abrupt('return', { success: false });

            case 13:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this, [[0, 9]]);
    }));

    return function (_x, _x2) {
      return _ref2.apply(this, arguments);
    };
  }())
});

/***/ }),

/***/ 243:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FETCH_NETWORK_STATISTICS; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_object_path__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_object_path___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_object_path__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_api__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__notifications__ = __webpack_require__(13);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }







var FETCH_NETWORK_STATISTICS = 'FETCH_NETWORK_STATISTICS';

/* harmony default export */ __webpack_exports__["b"] = ({
  state: {},
  getters: {},
  mutations: {},
  actions: _defineProperty({}, FETCH_NETWORK_STATISTICS, function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(_ref, payload) {
      var dispatch = _ref.dispatch;

      var _ref3, data, pagination;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/gateways/' + payload.context.eui + '/network_statistics', {
                params: Object(__WEBPACK_IMPORTED_MODULE_2__utils_api__["a" /* computePaginateSortFilterParams */])(payload)
              });

            case 3:
              _ref3 = _context.sent;
              data = _ref3.data;
              pagination = data.meta.pagination;
              return _context.abrupt('return', {
                success: true,
                // Return fetched data as flat array
                items: data.data.map(function (item) {
                  return item.attributes;
                }),
                collectionCount: Object(__WEBPACK_IMPORTED_MODULE_2__utils_api__["b" /* computedCollectionCount */])({
                  endRow: payload.endRow,
                  filteredCount: pagination.filtered_count,
                  collectionCount: pagination.collection_count
                })
              });

            case 9:
              _context.prev = 9;
              _context.t0 = _context['catch'](0);

              if (__WEBPACK_IMPORTED_MODULE_1_object_path___default.a.get(_context.t0, 'response.status') !== 404) {
                dispatch(__WEBPACK_IMPORTED_MODULE_3__notifications__["a" /* NEW_NOTIFICATION */], {
                  text: 'Failed to load network statistics ',
                  detail: _context.t0.message,
                  color: 'error'
                });
              }

            case 12:
              return _context.abrupt('return', { success: false });

            case 13:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this, [[0, 9]]);
    }));

    return function (_x, _x2) {
      return _ref2.apply(this, arguments);
    };
  }())
});

/***/ }),

/***/ 244:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SET_SYSTEM_THRESHOLDS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FETCH_SYSTEM_THRESHOLDS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return UPDATE_SYSTEM_THRESHOLDS; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__notifications__ = __webpack_require__(13);
var _actions;

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




// Commits
var SET_SYSTEM_THRESHOLDS = 'SET_SYSTEM_THRESHOLDS';

// Dispatches 
var FETCH_SYSTEM_THRESHOLDS = 'FETCH_SYSTEM_THRESHOLDS';
var UPDATE_SYSTEM_THRESHOLDS = 'UPDATE_SYSTEM_THRESHOLDS';

/* harmony default export */ __webpack_exports__["c"] = ({
  state: {
    join_failure_threshold: '',
    join_record_threshold: '',
    join_expiration_threshold: '',
    packet_record_threshold: '',
    packet_expiration_threshold: '',
    statistics_record_threshold: '',
    statistics_expiration_threshold: '',
    gw_statistics_record_threshold: '',
    gw_statistics_expiration_threshold: '',
    scan_run_record_threshold: '',
    scan_run_expiration_threshold: '',
    scan_result_record_threshold: '',
    scan_result_expiration_threshold: ''
  },
  getters: {
    getJoinFailureThreshold: function getJoinFailureThreshold(state) {
      return state.join_failure_threshold;
    },
    getJoinRecordThreshold: function getJoinRecordThreshold(state) {
      return state.join_record_threshold;
    },
    getJoinExpirationThreshold: function getJoinExpirationThreshold(state) {
      return state.join_expiration_threshold;
    },
    getPacketRecordThreshold: function getPacketRecordThreshold(state) {
      return state.packet_record_threshold;
    },
    getPacketExpirationThreshold: function getPacketExpirationThreshold(state) {
      return state.packet_expiration_threshold;
    },
    getStatisticsRecordThreshold: function getStatisticsRecordThreshold(state) {
      return state.statistics_record_threshold;
    },
    getStatisticsExpirationThreshold: function getStatisticsExpirationThreshold(state) {
      return state.statistics_expiration_threshold;
    },
    getGwStatisticsRecordThreshold: function getGwStatisticsRecordThreshold(state) {
      return state.gw_statistics_record_threshold;
    },
    getGwStatisticsExpirationThreshold: function getGwStatisticsExpirationThreshold(state) {
      return state.gw_statistics_expiration_threshold;
    },
    getScanRunRecordThreshold: function getScanRunRecordThreshold(state) {
      return state.scan_run_record_threshold;
    },
    getScanRunExpirationThreshold: function getScanRunExpirationThreshold(state) {
      return state.scan_run_expiration_threshold;
    },
    getScanResultRecordThreshold: function getScanResultRecordThreshold(state) {
      return state.scan_result_record_threshold;
    },
    getScanResultExpirationThreshold: function getScanResultExpirationThreshold(state) {
      return state.scan_result_expiration_threshold;
    }
  },
  mutations: _defineProperty({}, SET_SYSTEM_THRESHOLDS, function (state, entity) {
    state.join_failure_threshold = entity.join_failure_threshold;
    state.join_record_threshold = entity.join_record_threshold;
    state.join_expiration_threshold = entity.join_expiration_threshold;
    state.packet_record_threshold = entity.packet_record_threshold;
    state.packet_expiration_threshold = entity.packet_expiration_threshold;
    state.statistics_record_threshold = entity.statistics_record_threshold;
    state.statistics_expiration_threshold = entity.gw_statistics_expiration_threshold;
    state.gw_statistics_record_threshold = entity.gw_statistics_record_threshold;
    state.gw_statistics_expiration_threshold = entity.statistics_expiration_threshold;
    state.scan_run_record_threshold = entity.scan_run_record_threshold;
    state.scan_run_expiration_threshold = entity.scan_run_expiration_threshold;
    state.scan_result_record_threshold = entity.scan_result_record_threshold;
    state.scan_result_expiration_threshold = entity.scan_result_expiration_threshold;
  }),
  actions: (_actions = {}, _defineProperty(_actions, FETCH_SYSTEM_THRESHOLDS, function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(_ref) {
      var commit = _ref.commit,
          dispatch = _ref.dispatch;

      var _ref3, data, _status;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('/system_thresholds/');

            case 3:
              _ref3 = _context.sent;
              data = _ref3.data;

              commit(SET_SYSTEM_THRESHOLDS, data.attributes);
              return _context.abrupt('return', { success: true });

            case 9:
              _context.prev = 9;
              _context.t0 = _context['catch'](0);

              if (_context.t0.response) {
                _status = _context.t0.response.status;

                if (_status !== 404) {
                  dispatch(__WEBPACK_IMPORTED_MODULE_1__notifications__["a" /* NEW_NOTIFICATION */], {
                    text: 'Failed to load system thresholds ',
                    detail: _context.t0.message,
                    color: 'error'
                  });
                }
              } else {
                dispatch(__WEBPACK_IMPORTED_MODULE_1__notifications__["a" /* NEW_NOTIFICATION */], {
                  text: 'Invalid response to load system thresholds ',
                  detail: _context.t0.message ? _context.t0.message : 'no message returned',
                  color: 'error'
                });
              }
              return _context.abrupt('return', { success: false, status: status });

            case 13:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this, [[0, 9]]);
    }));

    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }()), _defineProperty(_actions, UPDATE_SYSTEM_THRESHOLDS, function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(_ref4, payload) {
      var commit = _ref4.commit,
          dispatch = _ref4.dispatch;

      var notificationId, _ref6, data;

      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return dispatch(__WEBPACK_IMPORTED_MODULE_1__notifications__["a" /* NEW_NOTIFICATION */], {
                text: 'Saving...',
                color: 'secondary',
                undoable: true
              });

            case 2:
              notificationId = _context2.sent;
              _context2.prev = 3;
              _context2.next = 6;
              return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put('/system_thresholds/', {
                data: {
                  type: 'system_thresholds',
                  attributes: payload
                }
              });

            case 6:
              _ref6 = _context2.sent;
              data = _ref6.data;

              commit(SET_SYSTEM_THRESHOLDS, payload);
              commit(__WEBPACK_IMPORTED_MODULE_1__notifications__["c" /* REPLACE_NOTIFICATION */], {
                id: notificationId,
                text: 'Saved!',
                color: 'success',
                undoable: true
              });
              return _context2.abrupt('return', true);

            case 13:
              _context2.prev = 13;
              _context2.t0 = _context2['catch'](3);

              commit(__WEBPACK_IMPORTED_MODULE_1__notifications__["c" /* REPLACE_NOTIFICATION */], {
                id: notificationId,
                text: 'Failed to update system thresholds ',
                detail: _context2.t0.message,
                color: 'error'
              });

            case 16:
              return _context2.abrupt('return', false);

            case 17:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, this, [[3, 13]]);
    }));

    return function (_x2, _x3) {
      return _ref5.apply(this, arguments);
    };
  }()), _actions)
});

/***/ }),

/***/ 246:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(247);
module.exports = __webpack_require__(992);


/***/ }),

/***/ 451:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 453:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 456:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 463:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 465:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 467:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_13bfbbee_hasScoped_false_optionsId_0_buble_transforms_vue_loader_lib_selector_type_template_index_0_placeInput_vue__ = __webpack_require__(468);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_runtime_component_normalizer__ = __webpack_require__(14);
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js___default.a,
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_13bfbbee_hasScoped_false_optionsId_0_buble_transforms_vue_loader_lib_selector_type_template_index_0_placeInput_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_13bfbbee_hasScoped_false_optionsId_0_buble_transforms_vue_loader_lib_selector_type_template_index_0_placeInput_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 468:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_c('span',{domProps:{"textContent":_vm._s(_vm.label)}}),_vm._v(" "),_c('input',{ref:"input",class:_vm.className,attrs:{"type":"text","placeholder":_vm.placeholder}})])}
var staticRenderFns = []


/***/ }),

/***/ 93:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__(12);

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__(221);

// EXTERNAL MODULE: ./node_modules/vuex-persistedstate/dist/vuex-persistedstate.es.js
var vuex_persistedstate_es = __webpack_require__(472);

// EXTERNAL MODULE: ./src/store/application_networks.js
var application_networks = __webpack_require__(231);

// EXTERNAL MODULE: ./src/store/gateways.js
var gateways = __webpack_require__(224);

// EXTERNAL MODULE: ./src/store/end_devices.js
var end_devices = __webpack_require__(225);

// EXTERNAL MODULE: ./src/store/device_profiles.js
var device_profiles = __webpack_require__(236);

// EXTERNAL MODULE: ./src/store/network_profiles.js
var network_profiles = __webpack_require__(232);

// EXTERNAL MODULE: ./src/store/packets.js
var packets = __webpack_require__(240);

// EXTERNAL MODULE: ./src/store/join_requests.js
var join_requests = __webpack_require__(241);

// EXTERNAL MODULE: ./src/store/gateway_statistics.js
var gateway_statistics = __webpack_require__(242);

// EXTERNAL MODULE: ./src/store/network_statistics.js
var network_statistics = __webpack_require__(243);

// EXTERNAL MODULE: ./src/store/users.js
var users = __webpack_require__(233);

// EXTERNAL MODULE: ./src/store/organizations.js
var organizations = __webpack_require__(228);

// EXTERNAL MODULE: ./src/store/device_groups.js
var device_groups = __webpack_require__(230);

// EXTERNAL MODULE: ./src/store/policies.js
var policies = __webpack_require__(238);

// EXTERNAL MODULE: ./src/store/system_thresholds.js
var system_thresholds = __webpack_require__(244);

// CONCATENATED MODULE: ./src/store/entities.js















/* harmony default export */ var store_entities = ({
  modules: {
    application_networks: application_networks["h" /* default */],
    gateways: gateways["h" /* default */],
    end_devices: end_devices["i" /* default */],
    device_profiles: device_profiles["f" /* default */],
    network_profiles: network_profiles["f" /* default */],
    packets: packets["d" /* default */],
    join_requests: join_requests["d" /* default */],
    gateway_statistics: gateway_statistics["b" /* default */],
    network_statistics: network_statistics["b" /* default */],
    users: users["i" /* default */],
    organizations: organizations["f" /* default */],
    device_groups: device_groups["h" /* default */],
    policies: policies["f" /* default */],
    system_thresholds: system_thresholds["c" /* default */]
  }
});
// EXTERNAL MODULE: ./src/store/notifications.js
var notifications = __webpack_require__(13);

// EXTERNAL MODULE: ./src/store/session.js
var session = __webpack_require__(17);

// EXTERNAL MODULE: ./src/store/ui.js
var ui = __webpack_require__(226);

// EXTERNAL MODULE: ./node_modules/axios/index.js
var node_modules_axios = __webpack_require__(7);
var axios_default = /*#__PURE__*/__webpack_require__.n(node_modules_axios);

// CONCATENATED MODULE: ./src/devicehq/api/index.js


// DeviceHQ Content-Type header must be set to either application/vnd.api+json or application/json
var TEST_CORS = axios_default.a.create({
  baseURL: 'https://jsonplaceholder.typicode.com/',
  headers: {
    'Content-type': 'application/json; charset=UTF-8'
  }
});

var DEVICEHQ_MAKE_SESSION = axios_default.a.create({
  baseURL: 'http://localhost:3010',
  headers: {
    'Content-Type': 'application/vnd.api+json'
  }
});

var DEVICEHQ = axios_default.a.create({
  baseURL: 'http://localhost:3010',
  headers: {
    'Content-Type': 'application/vnd.api+json',
    'X-AUTH-TOKEN': 'dummyxauthtoken'
  }
});


// CONCATENATED MODULE: ./src/devicehq/store/modules/session/actions.js

// import {DEVICEHQ, TEST_CORS} from '@/devicehq/api'

var actions_getSession = function getSession(context, payload) {
  // console.log(payload)

  // TEST_CORS.post('posts', {
  //   body: JSON.stringify({
  //     title: 'foo',
  //     body: 'bar',
  //     userId: 1,
  //   }),
  // })
  // .then(response => console.log(response))
  // .catch(err => console.log(err))

  // DEVICEHQ.get('/api/v2/info', {
  //   data: {}
  // })
  // .then(response => console.log(response))
  // .catch(err => console.log(err))

  DEVICEHQ_MAKE_SESSION.post('/api/v2/session?api_key=' + payload.api_key, {
    data: {}
  }).then(function (response) {
    console.log(response);
    DEVICEHQ.defaults.headers['X-AUTH-TOKEN'] = response.data.meta.token;
    context.commit('SESSION_UPDATED', response.data);
  }).catch(function (error) {
    // eslint-disable-next-line
    console.error(error);
  });
};

/* harmony default export */ var actions = ({
  getSession: actions_getSession
});
// CONCATENATED MODULE: ./src/devicehq/store/modules/session/getters.js
var getters_session = function session(state) {
  return state.session;
};

/* harmony default export */ var getters = ({
  session: getters_session
});
// CONCATENATED MODULE: ./src/devicehq/store/modules/session/mutations.js
var SESSION_UPDATED = function SESSION_UPDATED(state, session) {
  state.session = session;
};

/* harmony default export */ var mutations = ({
  SESSION_UPDATED: SESSION_UPDATED
});
// CONCATENATED MODULE: ./src/devicehq/store/modules/session/index.js




var state = {
  session: {}
};

/* harmony default export */ var modules_session = ({
  namespaced: true,
  state: state,
  actions: actions,
  getters: getters,
  mutations: mutations
});
// CONCATENATED MODULE: ./src/devicehq/store/modules/account/actions.js
// import {fetchAccount} from '@/devicehq/api/account'


var actions_getAccount = function getAccount(context) {
  // fetchAccount
  DEVICEHQ.get('/api/v2/account', {
    data: {}
  }).then(function (response) {
    context.commit('ACCOUNT_UPDATED', response.data);
  }).catch(function (error) {
    // eslint-disable-next-line
    console.error(error);
  });
};

/* harmony default export */ var account_actions = ({
  getAccount: actions_getAccount
});
// CONCATENATED MODULE: ./src/devicehq/store/modules/account/getters.js
var account = function account(state) {
  return state.account;
};

/* harmony default export */ var account_getters = ({
  account: account
});
// CONCATENATED MODULE: ./src/devicehq/store/modules/account/mutations.js
var ACCOUNT_UPDATED = function ACCOUNT_UPDATED(state, account) {
  state.account = account;
};

/* harmony default export */ var account_mutations = ({
  ACCOUNT_UPDATED: ACCOUNT_UPDATED
});
// CONCATENATED MODULE: ./src/devicehq/store/modules/account/index.js




var account_state = {
  account: {}
};

/* harmony default export */ var modules_account = ({
  namespaced: true,
  state: account_state,
  actions: account_actions,
  getters: account_getters,
  mutations: account_mutations
});
// CONCATENATED MODULE: ./src/devicehq/api/deviceId.js
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var fetchDeviceId = new Promise(function (resolve) {
  setTimeout(function () {
    var _attributes;

    resolve({
      result: 'ok',
      token: 'i9eTvNmbinALex',
      data: {
        id: 'MTS-JP-003',
        type: 'devices',
        attributes: (_attributes = {
          product: 'MTR-H5',
          group: 'Group 00X',
          serial: 'MTS-JP-003',
          provider: 'AT&T',
          description: 'East wing of library building',
          location_description: [-27.6234, 93.2],
          software_version: '3.0.9',
          hardware_version: '1.2b',
          last_checkin: '2015-12-15T20:30:13.107+00:00',
          enabled: true
        }, _defineProperty(_attributes, 'hardware_version', 'REV C'), _defineProperty(_attributes, 'lora_network', {}), _defineProperty(_attributes, 'active_apps', [{
          status: 'READY',
          info: 'aaaa',
          name: ' Hello World',
          version: '1.0.1',
          type: 'app',
          id: '57ee3aa4ed3e892698000057'
        }, {
          status: 'READY',
          info: null,
          name: 'APPTEST',
          version: '22.22',
          type: 'app',
          id: '581cb7dbed3e89c60100004c'
        }]), _defineProperty(_attributes, 'dhcp', {
          enabled: true,
          range_start: '192.168.2.100',
          range_end: '192.168.2.254',
          lease_time: 86400,
          netmask: '255.255.255.0',
          gateway: '192.168.2.1',
          dns: '192.168.2.1'
        }), _defineProperty(_attributes, 'ethernet', {
          name: 'eth0',
          link_type: 'LINK_TYPE_ETHER',
          mtu: 1500,
          mac: 'F7:F8:86:0D:68:91',
          gateway: '0.0.0.0',
          name_servers: [],
          flags: {
            up: true,
            lower_up: true,
            loopback: false,
            broadcast: true,
            pointtopoint: false,
            multicast: false,
            dynamic: false,
            noarp: false,
            allmulti: false,
            promisc: false
          },
          link_statistics: {
            rx_bytes: 74498,
            rx_packets: 586,
            rx_errors: 58,
            rx_dropped: 1,
            rx_overrun: 8,
            rx_multicast: 0,
            tx_bytes: 73870,
            tx_packets: 581,
            tx_errors: 77,
            tx_dropped: 1,
            tx_carrier: 5,
            tx_collisions: 0
          }
        }), _defineProperty(_attributes, 'cell_radio', {
          firmware: '12.00.024',
          phone_number: '1914591206',
          provider: 'AT&T',
          rssi: -103,
          imsi: null,
          up_time: null
        }), _defineProperty(_attributes, 'wifi', {
          name: 'wlan0',
          link_type: 'LINK_TYPE_ETHER',
          mtu: 1500,
          ip_addr: '192.168.211.211',
          netmask: '255.255.255.0',
          gateway: '192.168.211.1',
          name_servers: [],
          flags: {
            up: true,
            lower_up: true,
            loopback: false,
            broadcast: true,
            pointtopoint: false,
            multicast: false,
            dynamic: false,
            noarp: false,
            allmulti: false,
            promisc: false
          },
          link_statistics: {
            rx_bytes: 123939,
            rx_packets: 975,
            rx_errors: 50,
            rx_dropped: 6,
            rx_overrun: 8,
            rx_multicast: 0,
            tx_bytes: 287959,
            tx_packets: 2267,
            tx_errors: 75,
            tx_dropped: 6,
            tx_carrier: 4,
            tx_collisions: 0
          },
          wifi: {
            mode: 'client',
            client: {
              mode: 'WAN',
              security_mode: 'WPA2-PSK',
              ssid: 'mts-test',
              rssi: -75
            }
          }
        }), _defineProperty(_attributes, 'up_time', ' 127 days'), _defineProperty(_attributes, 'up_time_seconds', 23422), _defineProperty(_attributes, 'supports', {
          logs: true,
          configs: false,
          apps: false
        }), _defineProperty(_attributes, 'has_radio', true), _attributes)
      }
    });
  }, 750);
});


// CONCATENATED MODULE: ./src/devicehq/store/modules/devices/actions.js
// import {fetchDevices} from '@/devicehq/api/devices'



var actions_getDevices = function getDevices(context) {
  // fetchDevices
  DEVICEHQ.get('/api/v2/devices?limit=30', {
    data: {}
  }).then(function (response) {
    context.commit('DEVICES_UPDATED', response.data);
  }).catch(function (error) {
    // eslint-disable-next-line
    console.error(error);
  });
};

var actions_getDevice = function getDevice(context, payload) {
  DEVICEHQ.get('/api/v2/devices/' + payload.uuid, {
    data: {}
  }).then(function (response) {
    context.commit('DEVICE_UPDATED', response);
  }).catch(function (error) {
    // eslint-disable-next-line
    console.error(error);
  });
};

var actions_updateDevice = function updateDevice(context, payload) {
  console.log('update device with:');
  console.log(payload);
  // console.log(DEVICEHQ)
  DEVICEHQ.put('/api/v2/devices/' + payload.data.id, {
    data: payload.data
  }).then(function (response) {
    context.commit('DEVICE_UPDATED', response);
  }).catch(function (error) {
    // eslint-disable-next-line
    console.error(error);
  });
};

/* harmony default export */ var devices_actions = ({
  getDevices: actions_getDevices,
  getDevice: actions_getDevice,
  updateDevice: actions_updateDevice
});
// CONCATENATED MODULE: ./src/devicehq/store/modules/devices/getters.js
var devices = function devices(state) {
  return state.devices;
};
var device = function device(state) {
  return state.device.data;
};

/* harmony default export */ var devices_getters = ({
  devices: devices,
  device: device
});
// CONCATENATED MODULE: ./src/devicehq/store/modules/devices/mutations.js
var DEVICES_UPDATED = function DEVICES_UPDATED(state, devices) {
  state.devices = devices;
};

var DEVICE_UPDATED = function DEVICE_UPDATED(state, device) {
  state.device = device;
};

/* harmony default export */ var devices_mutations = ({
  DEVICES_UPDATED: DEVICES_UPDATED,
  DEVICE_UPDATED: DEVICE_UPDATED
});
// CONCATENATED MODULE: ./src/devicehq/store/modules/devices/index.js




var devices_state = {
  devices: [],
  device: {}
};

/* harmony default export */ var modules_devices = ({
  namespaced: true,
  state: devices_state,
  actions: devices_actions,
  getters: devices_getters,
  mutations: devices_mutations
});
// CONCATENATED MODULE: ./src/devicehq/store/modules/users/actions.js
// import {fetchUsers} from '@/devicehq/api/users'


var actions_getUsers = function getUsers(context) {
  // fetchUsers
  DEVICEHQ.get('/api/v2/account/users', {
    data: {}
  }).then(function (response) {
    context.commit('USERS_UPDATED', response.data);
  }).catch(function (error) {
    // eslint-disable-next-line
    console.error(error);
  });
};

/* harmony default export */ var users_actions = ({
  getUsers: actions_getUsers
});
// CONCATENATED MODULE: ./src/devicehq/store/modules/users/getters.js
var getters_users = function users(state) {
  return state.users;
};

/* harmony default export */ var users_getters = ({
  users: getters_users
});
// CONCATENATED MODULE: ./src/devicehq/store/modules/users/mutations.js
var USERS_UPDATED = function USERS_UPDATED(state, users) {
  state.users = users;
};

/* harmony default export */ var users_mutations = ({
  USERS_UPDATED: USERS_UPDATED
});
// CONCATENATED MODULE: ./src/devicehq/store/modules/users/index.js




var users_state = {
  users: []
};

/* harmony default export */ var modules_users = ({
  namespaced: true,
  state: users_state,
  actions: users_actions,
  getters: users_getters,
  mutations: users_mutations
});
// CONCATENATED MODULE: ./src/devicehq/store/modules/info/actions.js
// import {fetchInfo} from '@/devicehq/api/info'


var actions_getInfo = function getInfo(context) {
  // fetchInfo
  DEVICEHQ.get('/api/v2/info', {
    data: {}
  }).then(function (response) {
    context.commit('INFO_UPDATED', response.data);
  }).catch(function (error) {
    // eslint-disable-next-line
    console.error(error);
  });
};

/* harmony default export */ var info_actions = ({
  getInfo: actions_getInfo
});
// CONCATENATED MODULE: ./src/devicehq/store/modules/info/getters.js
var info = function info(state) {
  return state.info;
};

/* harmony default export */ var info_getters = ({
  info: info
});
// CONCATENATED MODULE: ./src/devicehq/store/modules/info/mutations.js
var INFO_UPDATED = function INFO_UPDATED(state, info) {
  state.info = info;
};

/* harmony default export */ var info_mutations = ({
  INFO_UPDATED: INFO_UPDATED
});
// CONCATENATED MODULE: ./src/devicehq/store/modules/info/index.js




var info_state = {
  info: {}
};

/* harmony default export */ var modules_info = ({
  namespaced: true,
  state: info_state,
  actions: info_actions,
  getters: info_getters,
  mutations: info_mutations
});
// CONCATENATED MODULE: ./src/devicehq/store/modules/commands/actions.js


var actions_createRebootCommand = function createRebootCommand(context, payload) {
  // create reboot command
  console.log('createRebootCommand');
  console.log(context, payload);
  DEVICEHQ.post('/api/v2/devices/' + payload.uuid + '/commands/reboot', {
    data: {}
  }).then(function (response) {
    context.commit('COMMAND_CREATED', response.data);
    //no need to reload device, but should reload command list for device 
  }).catch(function (error) {
    console.error(error);
  });
};
var actions_getForDevice = function getForDevice(context, payload) {
  // create reboot command
  console.log('getForDevice');
  console.log(context, payload);
  DEVICEHQ.get('/api/v2/devices/' + payload.uuid + '/commands', {
    data: {}
  }).then(function (response) {
    context.commit('DEVICE_COMMANDS_UPDATED', response.data);
  }).catch(function (error) {
    console.error(error);
  });
};

/* harmony default export */ var commands_actions = ({
  createRebootCommand: actions_createRebootCommand,
  getForDevice: actions_getForDevice
});
// CONCATENATED MODULE: ./src/devicehq/store/modules/commands/getters.js
var command = function command(state) {
  return state.command;
};
var commands = function commands(state) {
  return state.commands;
};

/* harmony default export */ var commands_getters = ({
  command: command,
  commands: commands
});
// CONCATENATED MODULE: ./src/devicehq/store/modules/commands/mutations.js
var COMMAND_CREATED = function COMMAND_CREATED(state, command) {
  state.command = command;
};
var DEVICE_COMMANDS_UPDATED = function DEVICE_COMMANDS_UPDATED(state, commands) {
  // let commands = response.data.data
  // let {data: {data: commands}} = response
  // response.data.map( c => c.attributes )
  console.log('DEVICE_COMMANDS_UPDATED');
  console.log(commands);
  state.commands = commands;
};

/* harmony default export */ var commands_mutations = ({
  COMMAND_CREATED: COMMAND_CREATED,
  DEVICE_COMMANDS_UPDATED: DEVICE_COMMANDS_UPDATED
});
// CONCATENATED MODULE: ./src/devicehq/store/modules/commands/index.js




var commands_state = {
  commands: [],
  command: {}
};

/* harmony default export */ var modules_commands = ({
  namespaced: true,
  state: commands_state,
  actions: commands_actions,
  getters: commands_getters,
  mutations: commands_mutations
});
// CONCATENATED MODULE: ./src/devicehq/store/devicehq_modules.js







/* harmony default export */ var devicehq_modules = ({
  modules: {
    dhq_session: modules_session,
    dhq_account: modules_account,
    dhq_devices: modules_devices,
    dhq_users: modules_users,
    dhq_info: modules_info,
    dhq_commands: modules_commands
  }
});
// CONCATENATED MODULE: ./src/modules/applicationNetworkStates/store/actions.js
var _this = this;

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }


var parseLinkHeader = __webpack_require__(63);

var actions_getAppNetStates = function getAppNetStates(context) {
  var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { page: 1 };

  axios_default.a.get('application_network_states?page=' + payload.page, {
    data: {}
  }).then(function (response) {
    context.commit('APP_NET_LIST_VIEW_UPDATED', {
      headerLinks: parseLinkHeader(response.headers.link),
      total: response.headers.total,
      perPage: response.headers['per-page'],
      context: 'Application Networks'
    });
    context.commit('APP_NET_STATES_UPDATED', response.data);
  }).catch(function (error) {
    // eslint-disable-next-line
    console.error(error);
  });
};

var actions_getAppNetRevisions = function getAppNetRevisions(context) {
  var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { page: 1 };

  axios_default.a.get('application_networks/' + payload.id + '/revisions?page=' + payload.page, {
    data: {}
  }).then(function (response) {
    context.commit('APP_NET_REVISIONS_VIEW_UPDATED', {
      headerLinks: parseLinkHeader(response.headers.link),
      total: response.headers.total,
      perPage: response.headers['per-page'],
      context: 'Application Network Revisions',
      collectionId: payload.id
    });
    context.commit('APP_NET_REVISIONS_UPDATED', response.data);
  }).catch(function (error) {
    // eslint-disable-next-line
    console.error(error);
  });
};

var setAppNetState = function setAppNetState(context, data) {
  context.commit('APP_NET_STATE_UPDATED', data);
};

var actions_getAppNetState = function getAppNetState(context, payload) {
  axios_default.a.get('application_network_states/' + payload.id, {
    data: {}
  }).then(function (response) {
    context.commit('APP_NET_STATE_UPDATED', response.data.data);
  }).catch(function (error) {
    // eslint-disable-next-line
    console.error(error);
  });
};

var actions_updateAppNetState = function updateAppNetState(context, payload) {
  axios_default.a.put('application_network_states/' + payload.data.id, {
    data: payload.data
  }).then(function (response) {
    context.commit('APP_NET_STATE_UPDATED', response.data.data);
  }).catch(function (error) {
    // eslint-disable-next-line
    console.error(error);
    context.commit('USER_ERROR', error.message);
  });
};

var clearUserError = function clearUserError(context) {
  context.commit('USER_ERROR', null);
};

var getApplicationNetworkState = function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(context, payload) {
    var fetchApplicationNetworkPromise;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            fetchApplicationNetworkPromise = void 0;
            _context.prev = 1;
            _context.next = 4;
            return axios_default.a.get('/application_networks/' + payload.id);

          case 4:
            fetchApplicationNetworkPromise = _context.sent;

            context.commit('SET_APPLICATION_NETWORK_STATE', fetchApplicationNetworkPromise.data.data);
            _context.next = 11;
            break;

          case 8:
            _context.prev = 8;
            _context.t0 = _context['catch'](1);
            return _context.abrupt('return', Promise.reject(_context.t0));

          case 11:
            return _context.abrupt('return', fetchApplicationNetworkPromise);

          case 12:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, _this, [[1, 8]]);
  }));

  return function getApplicationNetworkState(_x3, _x4) {
    return _ref.apply(this, arguments);
  };
}();

var updateApplicationNetworkState = function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(context, payload) {
    var updateApplicationNetworkPromise;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            updateApplicationNetworkPromise = void 0;
            _context2.prev = 1;
            _context2.next = 4;
            return axios_default.a.patch('/application_networks/' + payload.id, {
              data: {
                type: 'users',
                attributes: payload.attributes
              }
            });

          case 4:
            updateApplicationNetworkPromise = _context2.sent;

            context.commit('UPDATE_APPLICATION_NETWORK_STATE', payload);
            _context2.next = 11;
            break;

          case 8:
            _context2.prev = 8;
            _context2.t0 = _context2['catch'](1);
            return _context2.abrupt('return', Promise.reject(_context2.t0));

          case 11:
            return _context2.abrupt('return', updateApplicationNetworkPromise);

          case 12:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, _this, [[1, 8]]);
  }));

  return function updateApplicationNetworkState(_x5, _x6) {
    return _ref2.apply(this, arguments);
  };
}();

/* harmony default export */ var store_actions = ({
  getAppNetStates: actions_getAppNetStates,
  getAppNetRevisions: actions_getAppNetRevisions,
  setAppNetState: setAppNetState,
  getAppNetState: actions_getAppNetState,
  updateAppNetState: actions_updateAppNetState,
  clearUserError: clearUserError,
  getApplicationNetworkState: getApplicationNetworkState,
  updateApplicationNetworkState: updateApplicationNetworkState
});
// CONCATENATED MODULE: ./src/modules/applicationNetworkStates/store/getters.js
var app_net_states = function app_net_states(state) {
  return state.app_net_states;
};
var app_net_state = function app_net_state(state) {
  return state.app_net_state;
};
var app_net_list_view = function app_net_list_view(state) {
  return state.app_net_list_view;
};
var app_net_revisions = function app_net_revisions(state) {
  return state.app_net_revisions;
};
var app_net_revisions_view = function app_net_revisions_view(state) {
  return state.app_net_revisions_view;
};
var user_error = function user_error(state) {
  return state.user_error;
};
var application_network_state = function application_network_state(state) {
  return state.application_network_state;
};

/* harmony default export */ var store_getters = ({
  app_net_states: app_net_states,
  app_net_state: app_net_state,
  app_net_list_view: app_net_list_view,
  app_net_revisions: app_net_revisions,
  app_net_revisions_view: app_net_revisions_view,
  user_error: user_error,
  application_network_state: application_network_state
});
// CONCATENATED MODULE: ./src/modules/applicationNetworkStates/store/mutations.js
var APP_NET_STATES_UPDATED = function APP_NET_STATES_UPDATED(state, app_net_states) {
  state.app_net_states = app_net_states;
};

var APP_NET_STATE_UPDATED = function APP_NET_STATE_UPDATED(state, app_net_state) {
  state.app_net_state = app_net_state;
};

var APP_NET_LIST_VIEW_UPDATED = function APP_NET_LIST_VIEW_UPDATED(state, app_net_list_view) {
  state.app_net_list_view = app_net_list_view;
};

var APP_NET_REVISIONS_UPDATED = function APP_NET_REVISIONS_UPDATED(state, app_net_revisions) {
  state.app_net_revisions = app_net_revisions;
};

var APP_NET_REVISIONS_VIEW_UPDATED = function APP_NET_REVISIONS_VIEW_UPDATED(state, app_net_revisions_view) {
  state.app_net_revisions_view = app_net_revisions_view;
};

var USER_ERROR = function USER_ERROR(state, user_error) {
  state.user_error = user_error;
};

var SET_APPLICATION_NETWORK_STATE = function SET_APPLICATION_NETWORK_STATE(state, application_network_state) {
  state.application_network_state = application_network_state;
};

var UPDATE_APPLICATION_NETWORK_STATE = function UPDATE_APPLICATION_NETWORK_STATE(state, payload) {
  state.application_network_state = Object.assign({}, state.application_network_state, payload);
};

/* harmony default export */ var store_mutations = ({
  APP_NET_STATES_UPDATED: APP_NET_STATES_UPDATED,
  APP_NET_STATE_UPDATED: APP_NET_STATE_UPDATED,
  APP_NET_LIST_VIEW_UPDATED: APP_NET_LIST_VIEW_UPDATED,
  APP_NET_REVISIONS_UPDATED: APP_NET_REVISIONS_UPDATED,
  APP_NET_REVISIONS_VIEW_UPDATED: APP_NET_REVISIONS_VIEW_UPDATED,
  USER_ERROR: USER_ERROR,
  SET_APPLICATION_NETWORK_STATE: SET_APPLICATION_NETWORK_STATE,
  UPDATE_APPLICATION_NETWORK_STATE: UPDATE_APPLICATION_NETWORK_STATE
});
// CONCATENATED MODULE: ./src/modules/applicationNetworkStates/store/index.js




var store_state = {
  app_net_states: [],
  app_net_state: {},
  app_net_list_view: {},
  app_net_revisions: [],
  app_net_revisions_view: {},
  user_error: {},
  application_network_state: {}
};

/* harmony default export */ var store = ({
  namespaced: true,
  state: store_state,
  actions: store_actions,
  getters: store_getters,
  mutations: store_mutations
});
// EXTERNAL MODULE: ./src/utils/date.js
var date = __webpack_require__(136);

// CONCATENATED MODULE: ./src/modules/endDeviceStates/store/actions.js



var actions_parseLinkHeader = __webpack_require__(63);

var actions_getDeviceStates = function getDeviceStates(context) {
  var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { page: 1 };

  axios_default.a.get('end_device_states?page=' + payload.page, {
    data: {},
    params: payload.params
  }).then(function (response) {
    context.commit('END_DEVICE_LIST_VIEW_UPDATED', {
      headerLinks: actions_parseLinkHeader(response.headers.link),
      total: response.headers.total,
      perPage: response.headers['per-page'],
      context: 'End-Device States',
      collectionId: 0
    });
    context.commit('END_DEVICE_STATES_UPDATED', response.data);
  }).catch(function (error) {
    // eslint-disable-next-line
    console.error(error);
  });
};

var actions_getPromiseDeviceStates = function getPromiseDeviceStates(context) {
  var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { page: 1 };

  return new Promise(function (resolve, reject) {
    axios_default.a.get('end_device_states?page=' + payload.page, {
      data: {},
      params: payload.params
    }).then(function (response) {
      resolve(response);
    }, function (error) {
      reject(error);
    });
  });
};

var actions_patchDeviceStateReset = function patchDeviceStateReset(context) {
  var id = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { page: 1 };

  return new Promise(function (resolve, reject) {
    axios_default.a.patch('end_device_states/' + id + '/reset_state', {
      data: {}
    }).then(function (response) {
      resolve(response);
    }, function (error) {
      reject(error);
    });
  });
};

var actions_patchDeviceWatchlistReset = function patchDeviceWatchlistReset(context) {
  var id = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { page: 1 };

  return new Promise(function (resolve, reject) {
    axios_default.a.patch('end_device_states/' + id + '/reset_watchlist', {
      data: {}
    }).then(function (response) {
      resolve(response);
    }, function (error) {
      reject(error);
    });
  });
};

var actions_getDeviceRevisions = function getDeviceRevisions(context) {
  var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { page: 1 };

  axios_default.a.get('end_devices/' + payload.id + '/revisions?page=' + payload.page, {
    data: {}
  }).then(function (response) {
    context.commit('END_DEVICE_REVISIONS_VIEW_UPDATED', {
      headerLinks: actions_parseLinkHeader(response.headers.link),
      total: response.headers.total,
      perPage: response.headers['per-page'],
      context: 'End Device Revisions',
      collectionId: payload.id
    });
    context.commit('END_DEVICE_REVISIONS_UPDATED', response.data);
  }).catch(function (error) {
    // eslint-disable-next-line
    console.error(error);
  });
};

var actions_getDeviceProfileRevisions = function getDeviceProfileRevisions(context) {
  var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { page: 1 };

  axios_default.a.get('device_profiles/' + payload.id + '/revisions?page=' + payload.page, {
    data: {}
  }).then(function (response) {
    context.commit('DEVICE_PROFILE_REVISIONS_VIEW_UPDATED', {
      headerLinks: actions_parseLinkHeader(response.headers.link),
      total: response.headers.total,
      perPage: response.headers['per-page'],
      context: 'Device Profile Revisions',
      collectionId: payload.id
    });
    context.commit('DEVICE_PROFILE_REVISIONS_UPDATED', response.data);
  }).catch(function (error) {
    // eslint-disable-next-line
    console.error(error);
  });
};

var actions_getAppNetDeviceStates = function getAppNetDeviceStates(context, payload) {
  axios_default.a.get('application_network_states/' + payload.id + '/end_device_states?page=' + payload.page, {
    data: {}
  }).then(function (response) {
    context.commit('END_DEVICE_LIST_VIEW_UPDATED', {
      headerLinks: actions_parseLinkHeader(response.headers.link),
      total: response.headers.total,
      perPage: response.headers['per-page'],
      context: 'Joined Devices on this Application Network',
      collectionId: payload.id
    });
    context.commit('END_DEVICE_STATES_UPDATED', response.data);
  }).catch(function (error) {
    // eslint-disable-next-line
    console.error(error);
  });
};

var actions_getGatewayDeviceStates = function getGatewayDeviceStates(context, payload) {
  axios_default.a.get('gateway_states/' + payload.id + '/end_device_states?page=' + payload.page, {
    data: {}
  }).then(function (response) {
    context.commit('END_DEVICE_LIST_VIEW_UPDATED', {
      headerLinks: actions_parseLinkHeader(response.headers.link),
      total: response.headers.total,
      perPage: response.headers['per-page'],
      context: 'Joined Devices for this Gateway',
      collectionId: payload.id
    });
    context.commit('END_DEVICE_STATES_UPDATED', response.data);
  }).catch(function (error) {
    // eslint-disable-next-line
    console.error(error);
  });
};

var actions_getDeviceState = function getDeviceState(context, payload) {
  axios_default.a.get('end_device_states/' + payload.id, {
    data: {}
  }).then(function (response) {
    context.commit('END_DEVICE_STATE_UPDATED', response.data);
  }).catch(function (error) {
    // eslint-disable-next-line
    console.error(error);
  });
};

var actions_updateDeviceState = function updateDeviceState(context, payload) {
  axios_default.a.put('end_device_states/' + payload.data.id, {
    data: payload.data
  }).then(function (response) {
    context.commit('END_DEVICE_STATE_UPDATED', response.data);
  }).catch(function (error) {
    // eslint-disable-next-line
    console.error(error);
  });
};

var actions_getOperations = function getOperations(context, payload) {
  axios_default.a.get('/operations', {
    params: {
      skip: 0,
      limit: 100,
      sort: payload.sort
    }
  }).then(function (response) {
    context.commit('OPERATIONS_VIEW_UPDATED', {
      headerLinks: null,
      total: response.data.meta.pagination.count,
      perPage: response.data.meta.pagination.limit,
      context: 'Operation List',
      collectionId: payload.orgId,
      sort: payload.sort
    });
    context.commit('OPERATIONS_UPDATED', response.data.data);
  }).catch(function (error) {
    // eslint-disable-next-line
    console.error(error);
  });
};

var removeOperation = function removeOperation(context, payload) {
  context.commit('OPERATIONS_REMOVE_ITEM', payload);
};

var actions_deleteOperation = function deleteOperation(context, payload) {
  axios_default.a.delete('operations/' + payload.id).then(function (response) {
    console.log(response);
    context.commit('OPERATIONS_REMOVE_ITEM', payload.id);
  }).catch(function (error) {
    // eslint-disable-next-line
    console.error(error);
  });
};

var addOperation = function addOperation(context, payload) {
  context.commit('OPERATIONS_ADD_ITEM', payload);
};

var actions_getOperationDevices = function getOperationDevices(context, payload) {
  var op = context.state.operations.find(function (item) {
    return item.id === payload.id;
  });
  context.commit('OPERATION_DEVICES_UPDATED', op.attributes.eui_results);
  context.commit('OPERATION_DEVICES_STATUS_UPDATED', {
    type: op.attributes.operation_type,
    status: op.attributes.status_message,
    port: op.attributes.port,
    firmware: op.attributes.filename,
    description: op.attributes.description,
    last_updated: Object(date["f" /* formatTimestamp */])(op.attributes.updated_at),
    scheduled_to_run_at: Object(date["f" /* formatTimestamp */])(op.attributes.scheduled_to_run_at),
    started_at: Object(date["f" /* formatTimestamp */])(op.attributes.started_at),
    completed: op.attributes.percent_complete
  });
  context.commit('OPERATION_DEVICES_VIEW_UPDATED', {
    headerLinks: null,
    total: op.attributes.eui_results.length,
    perPage: 100,
    context: 'Operation Device List',
    collectionId: payload.id,
    sort: ''
  });
};

/* harmony default export */ var endDeviceStates_store_actions = ({
  getDeviceStates: actions_getDeviceStates,
  getPromiseDeviceStates: actions_getPromiseDeviceStates,
  patchDeviceStateReset: actions_patchDeviceStateReset,
  patchDeviceWatchlistReset: actions_patchDeviceWatchlistReset,
  getDeviceRevisions: actions_getDeviceRevisions,
  getAppNetDeviceStates: actions_getAppNetDeviceStates,
  getGatewayDeviceStates: actions_getGatewayDeviceStates,
  getDeviceState: actions_getDeviceState,
  updateDeviceState: actions_updateDeviceState,
  getDeviceProfileRevisions: actions_getDeviceProfileRevisions,
  getOperations: actions_getOperations,
  removeOperation: removeOperation,
  deleteOperation: actions_deleteOperation,
  addOperation: addOperation,
  getOperationDevices: actions_getOperationDevices
});
// CONCATENATED MODULE: ./src/modules/endDeviceStates/store/getters.js
var device_states = function device_states(state) {
  return state.device_states;
};
var device_state = function device_state(state) {
  return state.device_state;
};
var device_list_view = function device_list_view(state) {
  return state.device_list_view;
};
var device_revisions = function device_revisions(state) {
  return state.device_revisions;
};
var device_revisions_view = function device_revisions_view(state) {
  return state.device_revisions_view;
};
var profile_revisions = function profile_revisions(state) {
  return state.profile_revisions;
};
var profile_revisions_view = function profile_revisions_view(state) {
  return state.profile_revisions_view;
};
var operations = function operations(state) {
  return state.operations;
};
var operations_view = function operations_view(state) {
  return state.operations_view;
};
var operation_devices = function operation_devices(state) {
  return state.operation_devices;
};
var operation_devices_view = function operation_devices_view(state) {
  return state.operation_devices_view;
};
var operation_status = function operation_status(state) {
  return state.operation_status;
};

/* harmony default export */ var endDeviceStates_store_getters = ({
  device_states: device_states,
  device_state: device_state,
  device_list_view: device_list_view,
  device_revisions: device_revisions,
  device_revisions_view: device_revisions_view,
  profile_revisions: profile_revisions,
  profile_revisions_view: profile_revisions_view,
  operations: operations,
  operations_view: operations_view,
  operation_devices: operation_devices,
  operation_devices_view: operation_devices_view,
  operation_status: operation_status
});
// CONCATENATED MODULE: ./src/modules/endDeviceStates/store/mutations.js
var END_DEVICE_STATES_UPDATED = function END_DEVICE_STATES_UPDATED(state, device_states) {
  state.device_states = device_states;
  console.log('end-device states mutation set');
};

var END_DEVICE_STATE_UPDATED = function END_DEVICE_STATE_UPDATED(state, device_state) {
  state.device_state = device_state;
};

var END_DEVICE_LIST_VIEW_UPDATED = function END_DEVICE_LIST_VIEW_UPDATED(state, device_list_view) {
  state.device_list_view = device_list_view;
};

var END_DEVICE_REVISIONS_UPDATED = function END_DEVICE_REVISIONS_UPDATED(state, device_revisions) {
  state.device_revisions = device_revisions;
};

var END_DEVICE_REVISIONS_VIEW_UPDATED = function END_DEVICE_REVISIONS_VIEW_UPDATED(state, device_revisions_view) {
  state.device_revisions_view = device_revisions_view;
};

var DEVICE_PROFILE_REVISIONS_UPDATED = function DEVICE_PROFILE_REVISIONS_UPDATED(state, profile_revisions) {
  state.profile_revisions = profile_revisions;
};

var DEVICE_PROFILE_REVISIONS_VIEW_UPDATED = function DEVICE_PROFILE_REVISIONS_VIEW_UPDATED(state, profile_revisions_view) {
  state.profile_revisions_view = profile_revisions_view;
};

var OPERATIONS_UPDATED = function OPERATIONS_UPDATED(state, operations) {
  state.operations = operations;
};

var OPERATIONS_VIEW_UPDATED = function OPERATIONS_VIEW_UPDATED(state, operations_view) {
  state.operations_view = operations_view;
};

var OPERATIONS_REMOVE_ITEM = function OPERATIONS_REMOVE_ITEM(state, id) {
  var i = state.operations.data.findIndex(function (item) {
    item.id === id;
  });
  state.operations.data.splice(i, 1);
  state.operations_view.total--;
};

var OPERATIONS_ADD_ITEM = function OPERATIONS_ADD_ITEM(state, user) {
  state.operations.data.push(user);
  state.operations_view.total++;
};

var OPERATION_DEVICES_UPDATED = function OPERATION_DEVICES_UPDATED(state, operation_devices) {
  state.operation_devices = operation_devices;
};

var OPERATION_DEVICES_VIEW_UPDATED = function OPERATION_DEVICES_VIEW_UPDATED(state, operation_devices_view) {
  state.operation_devices_view = operation_devices_view;
};

var OPERATION_DEVICES_STATUS_UPDATED = function OPERATION_DEVICES_STATUS_UPDATED(state, operation_status) {
  state.operation_status = operation_status;
};

/* harmony default export */ var endDeviceStates_store_mutations = ({
  END_DEVICE_STATES_UPDATED: END_DEVICE_STATES_UPDATED,
  END_DEVICE_STATE_UPDATED: END_DEVICE_STATE_UPDATED,
  END_DEVICE_LIST_VIEW_UPDATED: END_DEVICE_LIST_VIEW_UPDATED,
  END_DEVICE_REVISIONS_UPDATED: END_DEVICE_REVISIONS_UPDATED,
  END_DEVICE_REVISIONS_VIEW_UPDATED: END_DEVICE_REVISIONS_VIEW_UPDATED,
  DEVICE_PROFILE_REVISIONS_UPDATED: DEVICE_PROFILE_REVISIONS_UPDATED,
  DEVICE_PROFILE_REVISIONS_VIEW_UPDATED: DEVICE_PROFILE_REVISIONS_VIEW_UPDATED,
  OPERATIONS_UPDATED: OPERATIONS_UPDATED,
  OPERATIONS_VIEW_UPDATED: OPERATIONS_VIEW_UPDATED,
  OPERATIONS_REMOVE_ITEM: OPERATIONS_REMOVE_ITEM,
  OPERATIONS_ADD_ITEM: OPERATIONS_ADD_ITEM,
  OPERATION_DEVICES_UPDATED: OPERATION_DEVICES_UPDATED,
  OPERATION_DEVICES_VIEW_UPDATED: OPERATION_DEVICES_VIEW_UPDATED,
  OPERATION_DEVICES_STATUS_UPDATED: OPERATION_DEVICES_STATUS_UPDATED
});
// CONCATENATED MODULE: ./src/modules/endDeviceStates/store/index.js




var endDeviceStates_store_state = {
  device_states: [],
  device_state: {},
  device_list_view: {},
  device_revisions: [],
  device_revisions_view: {},
  profile_revisions: [],
  profile_revisions_view: {},
  operations: [],
  operations_view: {},
  operation_devices: [],
  operation_devices_view: {},
  operation_status: {}
};

/* harmony default export */ var endDeviceStates_store = ({
  namespaced: true,
  state: endDeviceStates_store_state,
  actions: endDeviceStates_store_actions,
  getters: endDeviceStates_store_getters,
  mutations: endDeviceStates_store_mutations
});
// CONCATENATED MODULE: ./src/modules/gatewayStates/store/actions.js

var store_actions_parseLinkHeader = __webpack_require__(63);

/**
 * https://machinesaredigging.com/2014/04/27/binary-insert-how-to-keep-an-array-sorted-as-you-insert-data-in-it/
 * Example :
 * var a = [];
 * binaryInsert(value, a)
 * Don't insert duplicates
 * 
 * Spectral Scan Run
 * {
 *   key: <timestamp>
 *   value: <db_id>
 * }
 * 
 * Frequency
 * {
 *   key: <frequency>
 * }
 *
 */

function binaryInsert(value, array, startVal, endVal) {
  var length = array.length;
  var start = typeof startVal != 'undefined' ? startVal : 0;
  var end = typeof endVal != 'undefined' ? endVal : length - 1; //!! endVal could be 0 don't use || syntax
  var m = start + Math.floor((end - start) / 2);
  if (length == 0) {
    array.push(value);
    return;
  }
  if (value.key > array[end].key) {
    array.splice(end + 1, 0, value);
    return;
  }
  if (value.key < array[start].key) {
    //!!
    array.splice(start, 0, value);
    return;
  }
  if (start >= end) {
    return;
  }
  if (value.key < array[m].key) {
    binaryInsert(value, array, start, m - 1);
    return;
  }
  if (value.key > array[m].key) {
    binaryInsert(value, array, m + 1, end);
    return;
  }
  //we don't insert duplicates
}

var actions_getGatewayStates = function getGatewayStates(context) {
  var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { page: 1 };

  axios_default.a.get('gateway_states?page=' + payload.page, {
    data: {}
  }).then(function (response) {
    context.commit('GATEWAY_LIST_VIEW_UPDATED', {
      headerLinks: store_actions_parseLinkHeader(response.headers.link),
      total: response.headers.total,
      perPage: response.headers['per-page'],
      context: 'Gateways'
    });
    context.commit('GATEWAY_STATES_UPDATED', response.data);
  }).catch(function (error) {
    // eslint-disable-next-line
    console.error(error);
  });
};

var actions_getPromiseGatewayStates = function getPromiseGatewayStates(context) {
  var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { page: 1 };

  return new Promise(function (resolve, reject) {
    axios_default.a.get('gateway_states?page=' + payload.page, {
      data: {},
      params: payload.params
    }).then(function (response) {
      resolve(response);
    }, function (error) {
      reject(error);
    });
  });
};

var actions_getGatewayRevisions = function getGatewayRevisions(context) {
  var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { page: 1 };

  axios_default.a.get('gateways/' + payload.id + '/revisions?page=' + payload.page, {
    data: {}
  }).then(function (response) {
    context.commit('GATEWAY_REVISIONS_VIEW_UPDATED', {
      headerLinks: store_actions_parseLinkHeader(response.headers.link),
      total: response.headers.total,
      perPage: response.headers['per-page'],
      context: 'Gateway Revisions',
      collectionId: payload.id
    });
    context.commit('GATEWAY_REVISIONS_UPDATED', response.data);
  }).catch(function (error) {
    // eslint-disable-next-line
    console.error(error);
  });
};

var actions_getNetworkProfileRevisions = function getNetworkProfileRevisions(context) {
  var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { page: 1 };

  axios_default.a.get('network_profiles/' + payload.id + '/revisions?page=' + payload.page, {
    data: {}
  }).then(function (response) {
    context.commit('NETWORK_PROFILE_REVISIONS_VIEW_UPDATED', {
      headerLinks: store_actions_parseLinkHeader(response.headers.link),
      total: response.headers.total,
      perPage: response.headers['per-page'],
      context: 'Network Profile Revisions',
      collectionId: payload.id
    });
    context.commit('NETWORK_PROFILE_REVISIONS_UPDATED', response.data);
  }).catch(function (error) {
    // eslint-disable-next-line
    console.error(error);
  });
};

var setGatewayState = function setGatewayState(context, data) {
  context.commit('GATEWAY_STATE_UPDATED', data);
};

var actions_getGatewayState = function getGatewayState(context, payload) {
  axios_default.a.get('gateway_states/' + payload.id, {
    data: {}
  }).then(function (response) {
    context.commit('GATEWAY_STATE_UPDATED', response.data.data);
  }).catch(function (error) {
    // eslint-disable-next-line
    console.error(error);
  });
};

var actions_updateGatewayState = function updateGatewayState(context, payload) {
  axios_default.a.put('gateway_states/' + payload.data.id, {
    data: payload.data
  }).then(function (response) {
    context.commit('GATEWAY_STATE_UPDATED', response.data);
  }).catch(function (error) {
    // eslint-disable-next-line
    console.error(error);
  });
};

var actions_getGatewaySpectralScan = function getGatewaySpectralScan(context, payload) {
  axios_default.a.get('stats/gateway/' + payload.id + '/spectral/frequency_rssi_over_time', {
    params: {
      // limit: payload.limit || 100,
      page: payload.page || 1,
      start_at: payload.start_at || '',
      end_at: payload.end_at || ''
    }
  }).then(function (response) {
    // Build sorted distinct time series list
    var timeArray = [];
    if (response.data.included) {
      response.data.included.forEach(function (time_series) {
        var obj = {
          key: time_series.attributes.time,
          value: time_series.id
        };
        binaryInsert(obj, timeArray);
      });
    }
    // Build sorted distinct frequency list
    var freqArray = [];
    response.data.data.forEach(function (freq) {
      var obj = {
        key: freq.attributes.frequency
      };
      binaryInsert(obj, freqArray);
    });
    // Build time series with injected frequencies
    var time_rows = [];
    timeArray.forEach(function (time_series) {
      var freq_rows = [];
      response.data.data.forEach(function (freq) {
        if (freq.relationships['spectral-scan-run'].data.id == time_series.value) {
          freq_rows.push(freq.attributes);
        }
      });
      time_rows.push({
        timestamp: time_series.key,
        id: time_series.value,
        rows: freq_rows
      });
    });

    context.commit('SPECTRAL_SCAN_VIEW_UPDATED', {
      headerLinks: store_actions_parseLinkHeader(response.headers.link),
      total: response.headers.total,
      perPage: response.headers['per-page'],
      context: 'Spectral ' + payload.id
    });
    context.commit('SPECTRAL_SCAN_UPDATED', {
      data: {
        rows: time_rows,
        freq_list: freqArray
      }
    });
  }).catch(function (error) {
    // eslint-disable-next-line
    console.error(error);
  });
};

var actions_getLicenses = function getLicenses(context, payload) {
  return new Promise(function (resolve, reject) {
    axios_default.a.get('tokens', {
      params: {
        gateway_ids: payload.id
      }
    }).then(function (response) {
      resolve(response);
    }, function (error) {
      reject(error);
    });
  });
};

var actions_grab_token = function grab_token(context, payload) {
  return new Promise(function (resolve, reject) {
    axios_default.a.patch('gateways/' + payload.id + '/grab_token', {
      data: {}
    }).then(function (response) {
      resolve(response);
    }, function (error) {
      reject(error);
    });
  });
};

var actions_release_token = function release_token(context, payload) {
  return new Promise(function (resolve, reject) {
    axios_default.a.patch('gateways/' + payload.id + '/release_token', {
      data: {}
    }).then(function (response) {
      resolve(response);
    }, function (error) {
      reject(error);
    });
  });
};

/* harmony default export */ var gatewayStates_store_actions = ({
  getGatewayStates: actions_getGatewayStates,
  getPromiseGatewayStates: actions_getPromiseGatewayStates,
  setGatewayState: setGatewayState,
  getGatewayState: actions_getGatewayState,
  updateGatewayState: actions_updateGatewayState,
  getGatewayRevisions: actions_getGatewayRevisions,
  getNetworkProfileRevisions: actions_getNetworkProfileRevisions,
  getGatewaySpectralScan: actions_getGatewaySpectralScan,
  getLicenses: actions_getLicenses,
  grab_token: actions_grab_token,
  release_token: actions_release_token
});
// CONCATENATED MODULE: ./src/modules/gatewayStates/store/getters.js
var gateway_states = function gateway_states(state) {
  return state.gateway_states;
};
var gateway_state = function gateway_state(state) {
  return state.gateway_state;
};
var gateway_list_view = function gateway_list_view(state) {
  return state.gateway_list_view;
};
var gateway_revisions = function gateway_revisions(state) {
  return state.gateway_revisions;
};
var gateway_revisions_view = function gateway_revisions_view(state) {
  return state.gateway_revisions_view;
};
var getters_profile_revisions = function profile_revisions(state) {
  return state.profile_revisions;
};
var getters_profile_revisions_view = function profile_revisions_view(state) {
  return state.profile_revisions_view;
};
var spectral_scan = function spectral_scan(state) {
  return state.spectral_scan;
};
var spectral_scan_view = function spectral_scan_view(state) {
  return state.spectral_scan_view;
};

/* harmony default export */ var gatewayStates_store_getters = ({
  gateway_states: gateway_states,
  gateway_state: gateway_state,
  gateway_list_view: gateway_list_view,
  gateway_revisions: gateway_revisions,
  gateway_revisions_view: gateway_revisions_view,
  profile_revisions: getters_profile_revisions,
  profile_revisions_view: getters_profile_revisions_view,
  spectral_scan: spectral_scan,
  spectral_scan_view: spectral_scan_view
});
// CONCATENATED MODULE: ./src/modules/gatewayStates/store/mutations.js
var GATEWAY_STATES_UPDATED = function GATEWAY_STATES_UPDATED(state, gateway_states) {
  state.gateway_states = gateway_states;
};

var GATEWAY_STATE_UPDATED = function GATEWAY_STATE_UPDATED(state, gateway_state) {
  state.gateway_state = gateway_state;
};

var GATEWAY_LIST_VIEW_UPDATED = function GATEWAY_LIST_VIEW_UPDATED(state, gateway_list_view) {
  state.gateway_list_view = gateway_list_view;
};

var GATEWAY_REVISIONS_UPDATED = function GATEWAY_REVISIONS_UPDATED(state, gateway_revisions) {
  state.gateway_revisions = gateway_revisions;
};

var GATEWAY_REVISIONS_VIEW_UPDATED = function GATEWAY_REVISIONS_VIEW_UPDATED(state, gateway_revisions_view) {
  state.gateway_revisions_view = gateway_revisions_view;
};

var NETWORK_PROFILE_REVISIONS_UPDATED = function NETWORK_PROFILE_REVISIONS_UPDATED(state, profile_revisions) {
  state.profile_revisions = profile_revisions;
};

var NETWORK_PROFILE_REVISIONS_VIEW_UPDATED = function NETWORK_PROFILE_REVISIONS_VIEW_UPDATED(state, profile_revisions_view) {
  state.profile_revisions_view = profile_revisions_view;
};

var SPECTRAL_SCAN_UPDATED = function SPECTRAL_SCAN_UPDATED(state, spectral_scan) {
  state.spectral_scan = spectral_scan;
};

var SPECTRAL_SCAN_VIEW_UPDATED = function SPECTRAL_SCAN_VIEW_UPDATED(state, spectral_scan_view) {
  state.spectral_scan_view = spectral_scan_view;
};

/* harmony default export */ var gatewayStates_store_mutations = ({
  GATEWAY_STATES_UPDATED: GATEWAY_STATES_UPDATED,
  GATEWAY_STATE_UPDATED: GATEWAY_STATE_UPDATED,
  GATEWAY_LIST_VIEW_UPDATED: GATEWAY_LIST_VIEW_UPDATED,
  GATEWAY_REVISIONS_UPDATED: GATEWAY_REVISIONS_UPDATED,
  GATEWAY_REVISIONS_VIEW_UPDATED: GATEWAY_REVISIONS_VIEW_UPDATED,
  NETWORK_PROFILE_REVISIONS_UPDATED: NETWORK_PROFILE_REVISIONS_UPDATED,
  NETWORK_PROFILE_REVISIONS_VIEW_UPDATED: NETWORK_PROFILE_REVISIONS_VIEW_UPDATED,
  SPECTRAL_SCAN_UPDATED: SPECTRAL_SCAN_UPDATED,
  SPECTRAL_SCAN_VIEW_UPDATED: SPECTRAL_SCAN_VIEW_UPDATED
});
// CONCATENATED MODULE: ./src/modules/gatewayStates/store/index.js




var gatewayStates_store_state = {
  gateway_states: [],
  gateway_state: {},
  gateway_list_view: {},
  gateway_revisions: [],
  gateway_revisions_view: {},
  profile_revisions: [],
  profile_revisions_view: {},
  spectral_scan: {},
  spectral_scan_view: {}
};

/* harmony default export */ var gatewayStates_store = ({
  namespaced: true,
  state: gatewayStates_store_state,
  actions: gatewayStates_store_actions,
  getters: gatewayStates_store_getters,
  mutations: gatewayStates_store_mutations
});
// EXTERNAL MODULE: ./node_modules/jsonapi-normalizer/dist/index.js
var dist = __webpack_require__(32);
var dist_default = /*#__PURE__*/__webpack_require__.n(dist);

// CONCATENATED MODULE: ./src/modules/organizationStates/store/actions.js



var organizationStates_store_actions_parseLinkHeader = __webpack_require__(63);

var actions_getOrganizationSessions = function getOrganizationSessions(context) {
  var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { page: 1 };

  axios_default.a.get("organizations/" + payload.id + "/sessions?page=" + payload.page, {
    data: {}
  }).then(function (response) {
    context.commit("ORGANIZATION_SESSIONS_VIEW_UPDATED", {
      headerLinks: organizationStates_store_actions_parseLinkHeader(response.headers.link),
      total: response.headers.total,
      perPage: response.headers["per-page"],
      context: "Organization Sessions",
      collectionId: payload.id
    });
    context.commit("ORGANIZATION_SESSIONS_UPDATED", response.data);
  }).catch(function (error) {
    // eslint-disable-next-line
    console.error(error);
  });
};

var actions_getOrganizationRevisions = function getOrganizationRevisions(context) {
  var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { page: 1 };

  axios_default.a.get("organizations/" + payload.id + "/revisions?page=" + payload.page, {
    data: {}
  }).then(function (response) {
    context.commit("ORGANIZATION_REVISIONS_VIEW_UPDATED", {
      headerLinks: organizationStates_store_actions_parseLinkHeader(response.headers.link),
      total: response.headers.total,
      perPage: response.headers["per-page"],
      context: "Organization Create Revisions",
      collectionId: payload.id
    });
    context.commit("ORGANIZATION_REVISIONS_UPDATED", response.data);
  }).catch(function (error) {
    // eslint-disable-next-line
    console.error(error);
  });
};

var actions_getOrganizationCreateRevisions = function getOrganizationCreateRevisions(context) {
  var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { page: 1 };

  axios_default.a.get("organizations/" + payload.id + "/create_revisions?page=" + payload.page, {
    data: {}
  }).then(function (response) {
    context.commit("ORGANIZATION_CREATE_REVISIONS_VIEW_UPDATED", {
      headerLinks: organizationStates_store_actions_parseLinkHeader(response.headers.link),
      total: response.headers.total,
      perPage: response.headers["per-page"],
      context: "Organization Create Revisions",
      collectionId: payload.id
    });
    context.commit("ORGANIZATION_CREATE_REVISIONS_UPDATED", response.data);
  }).catch(function (error) {
    // eslint-disable-next-line
    console.error(error);
  });
};

var actions_getOrganizationUpdateRevisions = function getOrganizationUpdateRevisions(context) {
  var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { page: 1 };

  axios_default.a.get("organizations/" + payload.id + "/update_revisions?page=" + payload.page, {
    data: {}
  }).then(function (response) {
    context.commit("ORGANIZATION_UPDATE_REVISIONS_VIEW_UPDATED", {
      headerLinks: organizationStates_store_actions_parseLinkHeader(response.headers.link),
      total: response.headers.total,
      perPage: response.headers["per-page"],
      context: "Organization Create Revisions",
      collectionId: payload.id
    });
    context.commit("ORGANIZATION_UPDATE_REVISIONS_UPDATED", response.data);
  }).catch(function (error) {
    // eslint-disable-next-line
    console.error(error);
  });
};

var actions_getOrganizationDestroyRevisions = function getOrganizationDestroyRevisions(context) {
  var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { page: 1 };

  axios_default.a.get("organizations/" + payload.id + "/destroy_revisions?page=" + payload.page, {
    data: {}
  }).then(function (response) {
    context.commit("ORGANIZATION_DESTROY_REVISIONS_VIEW_UPDATED", {
      headerLinks: organizationStates_store_actions_parseLinkHeader(response.headers.link),
      total: response.headers.total,
      perPage: response.headers["per-page"],
      context: "Organization Create Revisions",
      collectionId: payload.id
    });
    context.commit("ORGANIZATION_DESTROY_REVISIONS_UPDATED", response.data);
  }).catch(function (error) {
    // eslint-disable-next-line
    console.error(error);
  });
};

var actions_getUserRevisions = function getUserRevisions(context) {
  var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { page: 1 };

  axios_default.a.get("users/" + payload.id + "/revisions?page=" + payload.page, {
    data: {}
  }).then(function (response) {
    context.commit("USER_REVISIONS_VIEW_UPDATED", {
      headerLinks: organizationStates_store_actions_parseLinkHeader(response.headers.link),
      total: response.headers.total,
      perPage: response.headers["per-page"],
      context: "User Revisions",
      collectionId: payload.id
    });
    context.commit("USER_REVISIONS_UPDATED", response.data);
  }).catch(function (error) {
    // eslint-disable-next-line
    console.error(error);
    context.commit("USER_REVISIONS_ERROR", error.message);
  });
};

var actions_getUserActions = function getUserActions(context) {
  var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { page: 1 };

  axios_default.a.get("users/" + payload.id + "/activities?page=" + payload.page, {
    data: {}
  }).then(function (response) {
    context.commit("USER_ACTIONS_VIEW_UPDATED", {
      headerLinks: organizationStates_store_actions_parseLinkHeader(response.headers.link),
      total: response.headers.total,
      perPage: response.headers["per-page"],
      context: "User Revisions",
      collectionId: payload.id
    });
    context.commit("USER_ACTIONS_UPDATED", response.data);
  }).catch(function (error) {
    // eslint-disable-next-line
    console.error(error);
    context.commit("USER_REVISIONS_ERROR", error.message);
  });
};

var clearUserRevisionsError = function clearUserRevisionsError(context) {
  context.commit("USER_REVISIONS_ERROR", null);
};

var setChangeAudit = function setChangeAudit(context, payload) {
  context.commit("CHANGE_AUDIT_UPDATED", payload);
};

var store_actions_getUsers = function getUsers(context, payload) {
  var request_string = "/users/";
  if (payload.orgId) {
    request_string = "organizations/" + payload.orgId + "/users";
  }
  axios_default.a.get(request_string, {
    params: {
      skip: 0,
      limit: 100,
      sort: payload.sort
    }
  }).then(function (response) {
    context.commit("USER_LIST_VIEW_UPDATED", {
      headerLinks: null,
      total: response.data.meta.pagination.count,
      perPage: response.data.meta.pagination.limit,
      context: "User List",
      collectionId: payload.orgId,
      sort: payload.sort
    });
    context.commit("USER_LIST_UPDATED", response.data);
  }).catch(function (error) {
    // eslint-disable-next-line
    console.error(error);
    context.commit("USER_REVISIONS_ERROR", error.message);
  });
};

var removeUser = function removeUser(context, payload) {
  context.commit("USER_LIST_REMOVE_ITEM", payload);
};

var actions_deleteUser = function deleteUser(context, payload) {
  axios_default.a.delete("users/" + payload.id).then(function (response) {
    console.log(response);
    context.commit("USER_LIST_REMOVE_ITEM", payload.id);
  }).catch(function (error) {
    // eslint-disable-next-line
    console.error(error);
    context.commit("USER_REVISIONS_ERROR", error.message);
  });
};

var addUser = function addUser(context, payload) {
  context.commit("USER_LIST_ADD_ITEM", payload);
};

var actions_updateUser = function updateUser(context, payload) {
  return new Promise(function (resolve, reject) {
    axios_default.a.patch("/users/" + payload.id, {
      data: {
        type: "users",
        attributes: payload.attributes
      }
    }).then(function (response) {
      if (response.status === 200) {
        var _normalize = dist_default()(response.data),
            entities = _normalize.entities;
        // Use commit to global states with root set to true


        context.commit("MODIFY_USER", entities.users[payload.id], {
          root: true
        }); // Does not update Session User Object
        context.commit("UPDATE_SESSION", {
          user: entities.users[payload.id]
        }, { root: true });
      }
      resolve(response);
    }, function (error) {
      reject(error);
    });
  });
};

var actions_getBroadcasts = function getBroadcasts(context, payload) {
  return new Promise(function (resolve, reject) {
    axios_default.a.get("organizations/" + payload.organization_id + "/broadcasts", {
      data: {}
    }).then(function (response) {
      if (response.status === 200) {
        context.commit("SET_BROADCASTS", {
          data: response.data.data,
          meta: {
            total: response.headers.total
          }
        });
      }
      resolve(response);
    }, function (error) {
      reject(error);
    });
  });
};

var actions_addBroadcast = function addBroadcast(context, payload) {
  return new Promise(function (resolve, reject) {
    axios_default.a.post("organizations/" + payload.organization_id + "/broadcasts", {
      data: {
        subject: payload.subject,
        body: payload.body,
        important: payload.important,
        message_type: payload.message_type
      }
    }).then(function (response) {
      if (response.status === 201) {
        window.console.log(response.data.data);
        context.commit("ADD_BROADCAST", {
          data: response.data.data
        });
        window.console.log(response.data);
      }
      resolve(response);
    }, function (error) {
      reject(error);
    });
  });
};

var actions_getJoinRequests = function getJoinRequests(context) {
  var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { page: 1 };

  return new Promise(function (resolve, reject) {
    axios_default.a.get("organizations/" + payload.organization_id + "/join_requests?page=" + payload.page, {
      data: {
        organization_id: payload.organization_id
      },
      params: payload.params
    }).then(function (response) {
      if (response.status === 200) {
        context.commit("ADD_JOIN_REQUESTS", {
          data: response.data.data,
          meta: response.data.meta,
          headerLinks: organizationStates_store_actions_parseLinkHeader(response.headers.link),
          total: response.headers.total,
          perPage: response.headers["per-page"],
          context: "OrganizationJoinRequests",
          collectionId: payload.organization_id
        });
      }
      resolve(response);
    }, function (error) {
      reject(error);
    });
  });
};

var actions_getSimpleJoinRequests = function getSimpleJoinRequests(context) {
  var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { page: 1 };

  return new Promise(function (resolve, reject) {
    axios_default.a.get("organizations/" + payload.organization_id + "/simple_join_requests?page=" + payload.page, {
      data: {
        organization_id: payload.organization_id
      },
      params: payload.params
    }).then(function (response) {
      if (response.status === 200) {
        context.commit("ADD_SIMPLE_JOIN_REQUESTS", {
          data: response.data.data,
          meta: response.data.meta,
          headerLinks: organizationStates_store_actions_parseLinkHeader(response.headers.link),
          total: response.headers.total,
          perPage: response.headers["per-page"],
          context: "OrganizationSimpleJoinRequests",
          collectionId: payload.organization_id
        });
      }
      resolve(response);
    }, function (error) {
      reject(error);
    });
  });
};

var actions_getPackets = function getPackets(context) {
  var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { page: 1 };

  return new Promise(function (resolve, reject) {
    axios_default.a.get("organizations/" + payload.organization_id + "/packets?page=" + payload.page, {
      data: {
        organization_id: payload.organization_id
      }
    }).then(function (response) {
      if (response.status === 200) {
        context.commit("ADD_PACKETS", {
          data: response.data.data,
          meta: response.data.meta,
          headerLinks: organizationStates_store_actions_parseLinkHeader(response.headers.link),
          total: response.headers.total,
          perPage: response.headers["per-page"],
          context: "OrganizationPackets",
          collectionId: payload.organization_id
        });
      }
      resolve(response);
    }, function (error) {
      reject(error);
    });
  });
};

var actions_getNetworkStatistics = function getNetworkStatistics(context) {
  var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { page: 1 };

  return new Promise(function (resolve, reject) {
    axios_default.a.get("organizations/" + payload.organization_id + "/network_statistics?page=" + payload.page, {
      data: {
        organization_id: payload.organization_id
      }
    }).then(function (response) {
      if (response.status === 200) {
        context.commit("ADD_NETWORK_STATISTICS", {
          data: response.data.data,
          meta: response.data.meta,
          headerLinks: organizationStates_store_actions_parseLinkHeader(response.headers.link),
          total: response.headers.total,
          perPage: response.headers["per-page"],
          context: "OrganizationNetworkStatistics",
          collectionId: payload.organization_id
        });
      }
      resolve(response);
    }, function (error) {
      reject(error);
    });
  });
};

var actions_getGatewayStatistics = function getGatewayStatistics(context) {
  var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { page: 1 };

  return new Promise(function (resolve, reject) {
    axios_default.a.get("organizations/" + payload.organization_id + "/gateway_statistics?page=" + payload.page, {
      data: {
        organization_id: payload.organization_id
      }
    }).then(function (response) {
      if (response.status === 200) {
        context.commit("ADD_GATEWAY_STATISTICS", {
          data: response.data.data,
          meta: response.data.meta,
          headerLinks: organizationStates_store_actions_parseLinkHeader(response.headers.link),
          total: response.headers.total,
          perPage: response.headers["per-page"],
          context: "OrganizationGatewayStatistics",
          collectionId: payload.organization_id
        });
      }
      resolve(response);
    }, function (error) {
      reject(error);
    });
  });
};

var actions_getJoinRequestsQuantities = function getJoinRequestsQuantities(context) {
  var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { page: 1 };

  return new Promise(function (resolve, reject) {
    axios_default.a.get("organizations/" + payload.organization_id + "/join_requests_quantities?page=" + payload.page, {
      data: {
        organization_id: payload.organization_id
      }
    }).then(function (response) {
      if (response.status === 200) {
        context.commit("ADD_JOIN_REQUESTS_QUANTITIES", {
          data: response.data.data,
          meta: response.data.meta,
          headerLinks: organizationStates_store_actions_parseLinkHeader(response.headers.link),
          total: response.headers.total,
          perPage: response.headers["per-page"],
          context: "OrganizationJoinRequestsQuantities",
          collectionId: payload.organization_id
        });
      }
      resolve(response);
    }, function (error) {
      reject(error);
    });
  });
};

var actions_getPacketsQuantities = function getPacketsQuantities(context) {
  var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { page: 1 };

  return new Promise(function (resolve, reject) {
    axios_default.a.get("organizations/" + payload.organization_id + "/packets_quantities?page=" + payload.page, {
      data: {
        organization_id: payload.organization_id
      }
    }).then(function (response) {
      if (response.status === 200) {
        context.commit("ADD_PACKETS_QUANTITIES", {
          data: response.data.data,
          meta: response.data.meta,
          headerLinks: organizationStates_store_actions_parseLinkHeader(response.headers.link),
          total: response.headers.total,
          perPage: response.headers["per-page"],
          context: "OrganizationPacketsQuantities",
          collectionId: payload.organization_id
        });
      }
      resolve(response);
    }, function (error) {
      reject(error);
    });
  });
};

var actions_getStats = function getStats(context) {
  var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { page: 1 };

  return new Promise(function (resolve, reject) {
    axios_default.a.get("organizations/" + payload.organization_id + "/stats?page=" + payload.page, {
      data: {
        organization_id: payload.organization_id
      }
    }).then(function (response) {
      if (response.status === 200) {
        context.commit("ADD_STATS", {
          data: response.data.data,
          meta: response.data.meta,
          headerLinks: organizationStates_store_actions_parseLinkHeader(response.headers.link),
          total: response.headers.total,
          perPage: response.headers["per-page"],
          context: "OrganizationStats",
          collectionId: payload.organization_id
        });
      }
      resolve(response);
    }, function (error) {
      reject(error);
    });
  });
};

var actions_getCrcErrors = function getCrcErrors(context) {
  var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { page: 1 };

  return new Promise(function (resolve, reject) {
    axios_default.a.get("organizations/" + payload.organization_id + "/crc_errors?page=" + payload.page, {
      data: {
        organization_id: payload.organization_id
      }
    }).then(function (response) {
      if (response.status === 200) {
        context.commit("ADD_CRC_ERRORS", {
          data: response.data.data,
          meta: response.data.meta,
          headerLinks: organizationStates_store_actions_parseLinkHeader(response.headers.link),
          total: response.headers.total,
          perPage: response.headers["per-page"],
          context: "OrganizationCrcErrors",
          collectionId: payload.organization_id
        });
      }
      resolve(response);
    }, function (error) {
      reject(error);
    });
  });
};

var actions_getMissedPackets = function getMissedPackets(context) {
  var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { page: 1 };

  return new Promise(function (resolve, reject) {
    axios_default.a.get("organizations/" + payload.organization_id + "/missed_packets?page=" + payload.page, {
      data: {
        organization_id: payload.organization_id
      }
    }).then(function (response) {
      if (response.status === 200) {
        context.commit("ADD_MISSED_PACKETS", {
          data: response.data.data,
          meta: response.data.meta,
          headerLinks: organizationStates_store_actions_parseLinkHeader(response.headers.link),
          total: response.headers.total,
          perPage: response.headers["per-page"],
          context: "OrganizationMissedPackets",
          collectionId: payload.organization_id
        });
      }
      resolve(response);
    }, function (error) {
      reject(error);
    });
  });
};

var actions_getSearchResults = function getSearchResults(context, payload) {
  return new Promise(function (resolve, reject) {
    context.commit("ADD_SEARCH_RESULTS", { data: null });
    axios_default.a.get("/search?q=" + payload).then(function (response) {
      if (response.status === 200) {
        context.commit("ADD_SEARCH_RESULTS", {
          data: response.data
        });
      }
      resolve(response);
    }, function (error) {
      reject(error);
    });
  });
};

var actions_getSystemSummary = function getSystemSummary(context, payload) {
  return new Promise(function (resolve, reject) {
    context.commit("ADD_SYSTEM_SUMMARY", { meta: null });
    axios_default.a.get("organizations/" + payload.organization_id + "/system_summary", {
      data: {
        organization_id: payload.organization_id
      }
    }).then(function (response) {
      console.log("getSystemSummary...do it");
      if (response.status === 200) {
        console.log("no, really...getSystemSummary...do it");
        context.commit("ADD_SYSTEM_SUMMARY", {
          meta: response.data.meta,
          context: "System Summary"
        });
      }
      resolve(response);
    }, function (error) {
      reject(error);
    });
  });
};

var store_actions_getLicenses = function getLicenses(context) {
  var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { page: 1 };

  return new Promise(function (resolve, reject) {
    axios_default.a.get("tokens?page=" + payload.page, {
      data: {
        organization_ids: payload.organization_ids
      },
      params: payload.params
    }).then(function (response) {
      if (response.status === 200) {
        context.commit("SET_LICENSES", {
          data: response.data.data,
          meta: response.data.meta,
          headerLinks: organizationStates_store_actions_parseLinkHeader(response.headers.link),
          total: response.headers.total,
          perPage: response.headers["per-page"],
          context: "VaultTokenTrans",
          collectionId: 1
        });
      }
      resolve(response);
    }, function (error) {
      reject(error);
    });
  });
};

var actions_updateLicense = function updateLicense(context, payload) {
  return new Promise(function (resolve, reject) {
    axios_default.a.patch("/tokens/" + payload.id, {
      data: Object.assign({}, payload.params)
    }).then(function (response) {
      resolve(response);
    }, function (error) {
      reject(error);
    });
  });
};

var actions_getOrganizationScheduleProvisioning = function getOrganizationScheduleProvisioning(context, payload) {
  return new Promise(function (resolve, reject) {
    axios_default.a.get("organizations/" + payload.organization_id + "/schedule_provisioning").then(function (response) {
      if (response.status === 200) {
        var res_arr = [];
        var res_data = response.data.data;
        var res_included = response.data.included;

        for (var i in res_data) {
          var res_schedule_provisioning_application_networks_join = res_data[i].relationships.schedule_provisioning_application_networks.data;
          var application_networks = [];

          var _loop = function _loop(j) {
            var span_id = res_schedule_provisioning_application_networks_join[j].id;
            var schedule_provisioning_application_network_obj = res_included.find(function (span) {
              return span.id == span_id;
            });
            application_networks.push(schedule_provisioning_application_network_obj.relationships.application_network.data.id);
          };

          for (var j in res_schedule_provisioning_application_networks_join) {
            _loop(j);
          }

          var res_item = {
            id: res_data[i].id,
            deviceType: res_data[i].attributes.device_type,
            devicesProvisionedOnLastRun: res_data[i].attributes.devices_provisioned_on_last_run ? res_data[i].attributes.devices_provisioned_on_last_run : 0,
            sku: res_data[i].attributes.sku,
            applicationNetworks: application_networks,
            lastRunOn: new Date(res_data[i].attributes.updated_at).toUTCString()
          };
          res_arr.push(res_item);
        }
        context.commit("SET_ORGANIZATION_SCHEDULE_PROVISIONING", res_arr);
      }
      resolve(response);
    }, function (error) {
      reject(error);
    });
  });
};

var actions_addOrganizationScheduleProvisioning = function addOrganizationScheduleProvisioning(context, payload) {
  var req = {
    data: {
      type: "schedule_provisionings",
      attributes: {
        organization_id: payload.organization_id,
        sku: payload.sku,
        device_type: payload.device_type,
        application_networks: payload.application_networks
      }
    }
  };
  return new Promise(function (resolve, reject) {
    axios_default.a.post("organizations/" + payload.organization_id + "/schedule_provisioning", req).then(function (response) {
      if (response.status === 201) {
        var res_data = response.data.data;
        var res_included = response.data.included;

        var res_schedule_provisioning_application_networks_join = res_data.relationships.schedule_provisioning_application_networks.data;
        var application_networks = [];

        var _loop2 = function _loop2(j) {
          var span_id = res_schedule_provisioning_application_networks_join[j].id;
          var schedule_provisioning_application_network_obj = res_included.find(function (span) {
            return span.id == span_id;
          });
          application_networks.push(schedule_provisioning_application_network_obj.relationships.application_network.data.id);
        };

        for (var j in res_schedule_provisioning_application_networks_join) {
          _loop2(j);
        }
        var res_item = {
          id: res_data.id,
          deviceType: res_data.attributes.device_type,
          devicesProvisionedOnLastRun: res_data.attributes.devices_provisioned_on_last_run ? res_data.attributes.devices_provisioned_on_last_run : 0,
          sku: res_data.attributes.sku,
          applicationNetworks: application_networks,
          lastRunOn: new Date(res_data.attributes.updated_at).toUTCString()
        };
        context.commit("ADD_ORGANIZATION_SCHEDULE_PROVISIONING", res_item);
      }
      resolve(response);
    }, function (error) {
      reject(error);
    });
  });
};

var actions_deleteOrganizationScheduleProvisioning = function deleteOrganizationScheduleProvisioning(context, payload) {
  return new Promise(function (resolve, reject) {
    axios_default.a.delete("organizations/" + payload.organization_id + "/schedule_provisioning/" + payload.id).then(function (response) {
      console.log("deleting schedule provisioning...do it");
      if (response.status === 204) {
        context.commit("REMOVE_ORGANIZATION_SCHEDULE_PROVISIONING", "" + payload.id);
      }
      resolve(response);
    }, function (error) {
      reject(error);
    });
  });
};

/* harmony default export */ var organizationStates_store_actions = ({
  getBroadcasts: actions_getBroadcasts,
  addBroadcast: actions_addBroadcast,
  getOrganizationSessions: actions_getOrganizationSessions,
  getOrganizationRevisions: actions_getOrganizationRevisions,
  getOrganizationCreateRevisions: actions_getOrganizationCreateRevisions,
  getOrganizationUpdateRevisions: actions_getOrganizationUpdateRevisions,
  getOrganizationDestroyRevisions: actions_getOrganizationDestroyRevisions,
  getUserRevisions: actions_getUserRevisions,
  getUserActions: actions_getUserActions,
  clearUserRevisionsError: clearUserRevisionsError,
  setChangeAudit: setChangeAudit,
  getUsers: store_actions_getUsers,
  removeUser: removeUser,
  deleteUser: actions_deleteUser,
  addUser: addUser,
  updateUser: actions_updateUser,
  getJoinRequests: actions_getJoinRequests,
  getSimpleJoinRequests: actions_getSimpleJoinRequests,
  getPackets: actions_getPackets,
  getNetworkStatistics: actions_getNetworkStatistics,
  getGatewayStatistics: actions_getGatewayStatistics,
  getJoinRequestsQuantities: actions_getJoinRequestsQuantities,
  getPacketsQuantities: actions_getPacketsQuantities,
  getStats: actions_getStats,
  getCrcErrors: actions_getCrcErrors,
  getMissedPackets: actions_getMissedPackets,
  getSearchResults: actions_getSearchResults,
  getSystemSummary: actions_getSystemSummary,
  getLicenses: store_actions_getLicenses,
  updateLicense: actions_updateLicense,
  getOrganizationScheduleProvisioning: actions_getOrganizationScheduleProvisioning,
  deleteOrganizationScheduleProvisioning: actions_deleteOrganizationScheduleProvisioning,
  addOrganizationScheduleProvisioning: actions_addOrganizationScheduleProvisioning
});
// CONCATENATED MODULE: ./src/modules/organizationStates/store/getters.js
var organization_sessions = function organization_sessions(state) {
  return state.organization_sessions;
};
var organization_sessions_view = function organization_sessions_view(state) {
  return state.organization_sessions_view;
};
var organization_revisions_view = function organization_revisions_view(state) {
  return state.organization_revisions_view;
};
var organization_revisions = function organization_revisions(state) {
  return state.organization_revisions;
};
var organization_create_revisions_view = function organization_create_revisions_view(state) {
  return state.organization_create_revisions_view;
};
var organization_create_revisions = function organization_create_revisions(state) {
  return state.organization_create_revisions;
};
var organization_update_revisions_view = function organization_update_revisions_view(state) {
  return state.organization_update_revisions_view;
};
var organization_update_revisions = function organization_update_revisions(state) {
  return state.organization_update_revisions;
};
var organization_destroy_revisions_view = function organization_destroy_revisions_view(state) {
  return state.organization_destroy_revisions_view;
};
var organization_destroy_revisions = function organization_destroy_revisions(state) {
  return state.organization_destroy_revisions;
};
var user_revisions = function user_revisions(state) {
  return state.user_revisions;
};
var user_revisions_view = function user_revisions_view(state) {
  return state.user_revisions_view;
};
var user_actions = function user_actions(state) {
  return state.user_actions;
};
var user_actions_view = function user_actions_view(state) {
  return state.user_actions_view;
};
var user_revisions_error = function user_revisions_error(state) {
  return state.user_revisions_error;
};
var change_audit = function change_audit(state) {
  return state.change_audit;
};
var sessionUser = function sessionUser(state) {
  return function (id) {
    return state.organization_sessions.included.find(function (user) {
      return user.id === id && user.type === "users";
    });
  };
};
var user_list = function user_list(state) {
  return state.user_list;
};
var user_list_view = function user_list_view(state) {
  return state.user_list_view;
};
var broadcasts = function broadcasts(state) {
  return state.broadcasts;
};
var getters_join_requests = function join_requests(state) {
  return state.join_requests;
};
var simple_join_requests = function simple_join_requests(state) {
  return state.simple_join_requests;
};
var getters_packets = function packets(state) {
  return state.packets;
};
var getters_network_statistics = function network_statistics(state) {
  return state.network_statistics;
};
var getters_gateway_statistics = function gateway_statistics(state) {
  return state.gateway_statistics;
};
var join_requests_quantities = function join_requests_quantities(state) {
  return state.join_requests_quantities;
};
var packets_quantities = function packets_quantities(state) {
  return state.packets_quantities;
};
var stats = function stats(state) {
  return state.stats;
};
var crc_errors = function crc_errors(state) {
  return state.crc_errors;
};
var missed_packets = function missed_packets(state) {
  return state.missed_packets;
};
var search_results = function search_results(state) {
  return state.search_results;
};
var system_summary = function system_summary(state) {
  return state.system_summary;
};
var licenses = function licenses(state) {
  return state.licenses_object;
};
var organization_schedule_provisioning = function organization_schedule_provisioning(state) {
  return state.organization_schedule_provisioning;
};

/* harmony default export */ var organizationStates_store_getters = ({
  broadcasts: broadcasts,
  organization_sessions: organization_sessions,
  organization_sessions_view: organization_sessions_view,
  organization_revisions: organization_revisions,
  organization_revisions_view: organization_revisions_view,
  organization_create_revisions: organization_create_revisions,
  organization_create_revisions_view: organization_create_revisions_view,
  organization_update_revisions: organization_update_revisions,
  organization_update_revisions_view: organization_update_revisions_view,
  organization_destroy_revisions: organization_destroy_revisions,
  organization_destroy_revisions_view: organization_destroy_revisions_view,
  user_revisions: user_revisions,
  user_revisions_view: user_revisions_view,
  user_actions: user_actions,
  user_actions_view: user_actions_view,
  user_revisions_error: user_revisions_error,
  change_audit: change_audit,
  sessionUser: sessionUser,
  user_list: user_list,
  user_list_view: user_list_view,
  join_requests: getters_join_requests,
  simple_join_requests: simple_join_requests,
  packets: getters_packets,
  network_statistics: getters_network_statistics,
  gateway_statistics: getters_gateway_statistics,
  join_requests_quantities: join_requests_quantities,
  packets_quantities: packets_quantities,
  stats: stats,
  crc_errors: crc_errors,
  missed_packets: missed_packets,
  search_results: search_results,
  system_summary: system_summary,
  licenses: licenses,
  organization_schedule_provisioning: organization_schedule_provisioning
});
// CONCATENATED MODULE: ./src/modules/organizationStates/store/mutations.js
var ORGANIZATION_SESSIONS_UPDATED = function ORGANIZATION_SESSIONS_UPDATED(state, organization_sessions) {
  state.organization_sessions = organization_sessions;
};

var ORGANIZATION_SESSIONS_VIEW_UPDATED = function ORGANIZATION_SESSIONS_VIEW_UPDATED(state, organization_sessions_view) {
  state.organization_sessions_view = organization_sessions_view;
};

var ORGANIZATION_REVISIONS_UPDATED = function ORGANIZATION_REVISIONS_UPDATED(state, organization_revisions) {
  state.organization_revisions = organization_revisions;
};

var ORGANIZATION_REVISIONS_VIEW_UPDATED = function ORGANIZATION_REVISIONS_VIEW_UPDATED(state, organization_revisions_view) {
  state.organization_revisions_view = organization_revisions_view;
};

var ORGANIZATION_CREATE_REVISIONS_UPDATED = function ORGANIZATION_CREATE_REVISIONS_UPDATED(state, organization_create_revisions) {
  state.organization_create_revisions = organization_create_revisions;
};

var ORGANIZATION_CREATE_REVISIONS_VIEW_UPDATED = function ORGANIZATION_CREATE_REVISIONS_VIEW_UPDATED(state, organization_create_revisions_view) {
  state.organization_create_revisions_view = organization_create_revisions_view;
};

var ORGANIZATION_UPDATE_REVISIONS_UPDATED = function ORGANIZATION_UPDATE_REVISIONS_UPDATED(state, organization_update_revisions) {
  state.organization_update_revisions = organization_update_revisions;
};

var ORGANIZATION_UPDATE_REVISIONS_VIEW_UPDATED = function ORGANIZATION_UPDATE_REVISIONS_VIEW_UPDATED(state, organization_update_revisions_view) {
  state.organization_update_revisions_view = organization_update_revisions_view;
};

var ORGANIZATION_DESTROY_REVISIONS_UPDATED = function ORGANIZATION_DESTROY_REVISIONS_UPDATED(state, organization_destroy_revisions) {
  state.organization_destroy_revisions = organization_destroy_revisions;
};

var ORGANIZATION_DESTROY_REVISIONS_VIEW_UPDATED = function ORGANIZATION_DESTROY_REVISIONS_VIEW_UPDATED(state, organization_destroy_revisions_view) {
  state.organization_destroy_revisions_view = organization_destroy_revisions_view;
};

var USER_REVISIONS_UPDATED = function USER_REVISIONS_UPDATED(state, user_revisions) {
  state.user_revisions = user_revisions;
};

var USER_REVISIONS_VIEW_UPDATED = function USER_REVISIONS_VIEW_UPDATED(state, user_revisions_view) {
  state.user_revisions_view = user_revisions_view;
};

var USER_ACTIONS_UPDATED = function USER_ACTIONS_UPDATED(state, user_actions) {
  state.user_actions = user_actions;
};

var USER_ACTIONS_VIEW_UPDATED = function USER_ACTIONS_VIEW_UPDATED(state, user_actions_view) {
  state.user_actions_view = user_actions_view;
};

var USER_REVISIONS_ERROR = function USER_REVISIONS_ERROR(state, user_revisions_error) {
  state.user_revisions_error = user_revisions_error;
};

var CHANGE_AUDIT_UPDATED = function CHANGE_AUDIT_UPDATED(state, change_audit) {
  state.change_audit = change_audit;
};

var USER_LIST_UPDATED = function USER_LIST_UPDATED(state, user_list) {
  state.user_list = user_list;
};

var USER_LIST_VIEW_UPDATED = function USER_LIST_VIEW_UPDATED(state, user_list_view) {
  state.user_list_view = user_list_view;
};

var USER_LIST_REMOVE_ITEM = function USER_LIST_REMOVE_ITEM(state, id) {
  var i = state.user_list.data.findIndex(function (item) {
    return item.id === id;
  });
  state.user_list.data.splice(i, 1);
  state.user_list_view.total--;
};

var USER_LIST_ADD_ITEM = function USER_LIST_ADD_ITEM(state, user) {
  state.user_list.data.push(user);
  state.user_list_view.total++;
};

var SET_BROADCASTS = function SET_BROADCASTS(state, broadcasts) {
  state.broadcasts = broadcasts;
};

var ADD_BROADCAST = function ADD_BROADCAST(state, broadcast) {
  state.broadcasts.data.push(broadcast.data);
};

var ADD_JOIN_REQUESTS = function ADD_JOIN_REQUESTS(state, items) {
  state.join_requests = items;
};

var ADD_SIMPLE_JOIN_REQUESTS = function ADD_SIMPLE_JOIN_REQUESTS(state, items) {
  state.simple_join_requests = items;
};

var ADD_PACKETS = function ADD_PACKETS(state, items) {
  state.packets = items;
};

var ADD_NETWORK_STATISTICS = function ADD_NETWORK_STATISTICS(state, items) {
  state.network_statistics = items;
};

var ADD_GATEWAY_STATISTICS = function ADD_GATEWAY_STATISTICS(state, items) {
  state.gateway_statistics = items;
};

var ADD_JOIN_REQUESTS_QUANTITIES = function ADD_JOIN_REQUESTS_QUANTITIES(state, items) {
  state.join_requests_quantities = items;
};

var ADD_PACKETS_QUANTITIES = function ADD_PACKETS_QUANTITIES(state, items) {
  state.packets_quantities = items;
};

var ADD_STATS = function ADD_STATS(state, items) {
  state.stats = items;
};

var ADD_CRC_ERRORS = function ADD_CRC_ERRORS(state, items) {
  state.crc_errors = items;
};

var ADD_MISSED_PACKETS = function ADD_MISSED_PACKETS(state, item) {
  state.missed_packets = item;
};

var ADD_SEARCH_RESULTS = function ADD_SEARCH_RESULTS(state, item) {
  state.search_results = item;
};

var ADD_SYSTEM_SUMMARY = function ADD_SYSTEM_SUMMARY(state, item) {
  state.system_summary = item;
};

var SET_LICENSES = function SET_LICENSES(state, payload) {
  state.licenses_object = payload;
};
var SET_ORGANIZATION_SCHEDULE_PROVISIONING = function SET_ORGANIZATION_SCHEDULE_PROVISIONING(state, payload) {
  state.organization_schedule_provisioning = payload;
};
var ADD_ORGANIZATION_SCHEDULE_PROVISIONING = function ADD_ORGANIZATION_SCHEDULE_PROVISIONING(state, payload) {
  state.organization_schedule_provisioning.push(payload);
};
var REMOVE_ORGANIZATION_SCHEDULE_PROVISIONING = function REMOVE_ORGANIZATION_SCHEDULE_PROVISIONING(state, id) {
  state.organization_schedule_provisioning.splice(state.organization_schedule_provisioning.findIndex(function (e) {
    return e.id === id;
  }), 1);
};

/* harmony default export */ var organizationStates_store_mutations = ({
  SET_BROADCASTS: SET_BROADCASTS,
  ADD_BROADCAST: ADD_BROADCAST,
  ORGANIZATION_SESSIONS_UPDATED: ORGANIZATION_SESSIONS_UPDATED,
  ORGANIZATION_SESSIONS_VIEW_UPDATED: ORGANIZATION_SESSIONS_VIEW_UPDATED,
  ORGANIZATION_REVISIONS_UPDATED: ORGANIZATION_REVISIONS_UPDATED,
  ORGANIZATION_REVISIONS_VIEW_UPDATED: ORGANIZATION_REVISIONS_VIEW_UPDATED,
  ORGANIZATION_CREATE_REVISIONS_UPDATED: ORGANIZATION_CREATE_REVISIONS_UPDATED,
  ORGANIZATION_CREATE_REVISIONS_VIEW_UPDATED: ORGANIZATION_CREATE_REVISIONS_VIEW_UPDATED,
  ORGANIZATION_UPDATE_REVISIONS_UPDATED: ORGANIZATION_UPDATE_REVISIONS_UPDATED,
  ORGANIZATION_UPDATE_REVISIONS_VIEW_UPDATED: ORGANIZATION_UPDATE_REVISIONS_VIEW_UPDATED,
  ORGANIZATION_DESTROY_REVISIONS_UPDATED: ORGANIZATION_DESTROY_REVISIONS_UPDATED,
  ORGANIZATION_DESTROY_REVISIONS_VIEW_UPDATED: ORGANIZATION_DESTROY_REVISIONS_VIEW_UPDATED,
  USER_REVISIONS_UPDATED: USER_REVISIONS_UPDATED,
  USER_REVISIONS_VIEW_UPDATED: USER_REVISIONS_VIEW_UPDATED,
  USER_ACTIONS_UPDATED: USER_ACTIONS_UPDATED,
  USER_ACTIONS_VIEW_UPDATED: USER_ACTIONS_VIEW_UPDATED,
  USER_REVISIONS_ERROR: USER_REVISIONS_ERROR,
  CHANGE_AUDIT_UPDATED: CHANGE_AUDIT_UPDATED,
  USER_LIST_UPDATED: USER_LIST_UPDATED,
  USER_LIST_VIEW_UPDATED: USER_LIST_VIEW_UPDATED,
  USER_LIST_REMOVE_ITEM: USER_LIST_REMOVE_ITEM,
  USER_LIST_ADD_ITEM: USER_LIST_ADD_ITEM,
  ADD_JOIN_REQUESTS: ADD_JOIN_REQUESTS,
  ADD_SIMPLE_JOIN_REQUESTS: ADD_SIMPLE_JOIN_REQUESTS,
  ADD_PACKETS: ADD_PACKETS,
  ADD_NETWORK_STATISTICS: ADD_NETWORK_STATISTICS,
  ADD_GATEWAY_STATISTICS: ADD_GATEWAY_STATISTICS,
  ADD_JOIN_REQUESTS_QUANTITIES: ADD_JOIN_REQUESTS_QUANTITIES,
  ADD_PACKETS_QUANTITIES: ADD_PACKETS_QUANTITIES,
  ADD_STATS: ADD_STATS,
  ADD_CRC_ERRORS: ADD_CRC_ERRORS,
  ADD_MISSED_PACKETS: ADD_MISSED_PACKETS,
  ADD_SEARCH_RESULTS: ADD_SEARCH_RESULTS,
  ADD_SYSTEM_SUMMARY: ADD_SYSTEM_SUMMARY,
  SET_LICENSES: SET_LICENSES,
  SET_ORGANIZATION_SCHEDULE_PROVISIONING: SET_ORGANIZATION_SCHEDULE_PROVISIONING,
  REMOVE_ORGANIZATION_SCHEDULE_PROVISIONING: REMOVE_ORGANIZATION_SCHEDULE_PROVISIONING,
  ADD_ORGANIZATION_SCHEDULE_PROVISIONING: ADD_ORGANIZATION_SCHEDULE_PROVISIONING
});
// CONCATENATED MODULE: ./src/modules/organizationStates/store/index.js




var organizationStates_store_state = {
  organization_sessions: [],
  organization_sessions_view: {},
  organization_revisions: [],
  organization_revisions_view: {},
  organization_create_revisions: [],
  organization_create_revisions_view: {},
  organization_update_revisions: [],
  organization_update_revisions_view: {},
  organization_destroy_revisions: [],
  organization_destroy_revisions_view: {},
  user_revisions: [],
  user_revisions_view: {},
  user_actions: [],
  user_actions_view: {},
  user_revisions_error: {},
  change_audit: {},
  user_list: [],
  user_list_view: {},
  broadcasts: {},
  join_requests: {},
  simple_join_requests: {},
  packets: {},
  network_statistics: {},
  gateway_statistics: {},
  join_requests_quantities: {},
  packets_quantities: {},
  stats: {},
  crc_errors: {},
  missed_packets: {},
  search_results: {},
  system_summary: {},
  licenses_object: {},
  organization_schedule_provisioning: []
};

/* harmony default export */ var organizationStates_store = ({
  namespaced: true,
  state: organizationStates_store_state,
  actions: organizationStates_store_actions,
  getters: organizationStates_store_getters,
  mutations: organizationStates_store_mutations
});
// CONCATENATED MODULE: ./src/modules/systemStates/store/actions.js

var systemStates_store_actions_parseLinkHeader = __webpack_require__(63);

var actions_getVaults = function getVaults(context) {
  var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { page: 1 };

  return new Promise(function (resolve, reject) {
    axios_default.a.get("vaults?page=" + payload.page, {
      data: {}
    }).then(function (response) {
      if (response.status === 200) {
        context.commit("set_vaults", {
          data: response.data.data,
          meta: response.data.meta,
          headerLinks: systemStates_store_actions_parseLinkHeader(response.headers.link),
          total: response.headers.total,
          perPage: response.headers["per-page"],
          context: "Vaults",
          collectionId: 1
        });
      }
      resolve(response);
    }, function (error) {
      reject(error);
    });
  });
};

var actions_getVaultTransactions = function getVaultTransactions(context) {
  var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { page: 1 };

  return new Promise(function (resolve, reject) {
    axios_default.a.get("vault_transactions?page=" + payload.page, {
      data: {}
    }).then(function (response) {
      if (response.status === 200) {
        context.commit("set_vault_transactions", {
          data: response.data.data,
          meta: response.data.meta,
          headerLinks: systemStates_store_actions_parseLinkHeader(response.headers.link),
          total: response.headers.total,
          perPage: response.headers["per-page"],
          context: "VaultTrans",
          collectionId: 1
        });
      }
      resolve(response);
    }, function (error) {
      reject(error);
    });
  });
};

var actions_getVault = function getVault(context, payload) {
  return new Promise(function (resolve, reject) {
    axios_default.a.get("vaults/" + payload.id, {
      data: {}
    }).then(function (response) {
      context.commit("set_vault", response.data.data);
      resolve(response);
    }, function (error) {
      reject(error);
    });
  });
};

var actions_addVault = function addVault(context, payload) {
  return new Promise(function (resolve, reject) {
    axios_default.a.post("vaults/", {
      data: payload.data
    }).then(function (response) {
      context.commit("set_vault", response.data.data);
      resolve(response);
    }, function (error) {
      reject(error);
    });
  });
};

var actions_updateVault = function updateVault(context, payload) {
  return new Promise(function (resolve, reject) {
    axios_default.a.patch("vaults/" + payload.id, {
      data: payload.params
    }).then(function (response) {
      context.commit("set_vault", response.data.data);
      resolve(response);
    }, function (error) {
      reject(error);
    });
  });
};

var actions_deleteVault = function deleteVault(context, payload) {
  return new Promise(function (resolve, reject) {
    axios_default.a.delete("vaults/" + payload.id, {
      data: {
        data: {}
      }
    }).then(function (response) {
      resolve(response);
    }, function (error) {
      reject(error);
    });
  });
};

var actions_serviceLogin = function serviceLogin(_ref, data) {
  var commit = _ref.commit,
      dispatch = _ref.dispatch;

  return axios_default.a.post("vaults/" + data.id + "/service-login", {
    data: {
      email: data.email,
      password: data.password
    }
  }).then(function (response) {
    commit("set_vault", response.data.data);
  }).catch(function (response) {
    // todo: popup an error box possibly
  });
};

var actions_vaultLogin = function vaultLogin(context, data) {
  return new Promise(function (resolve, reject) {
    axios_default()({
      method: "post",
      url: data.api + "auth/login",
      params: {
        email: data.email,
        password: data.password
      },
      headers: {
        "content-type": "application/vnd.api+json",
        accept: "application/vnd.api+json"
      }
    }).then(function (response) {
      if (response.data && response.data.auth_token) {
        // localStorage.token = response.data.auth_token
        context.commit("set_login_token", response.data.auth_token);
      }
      resolve(response);
    }, function (error) {
      reject(error);
    });
  });
};

var actions_vaultRenewToken = function vaultRenewToken(context, data) {
  var proxy_route = 'vaults';
  return axios_default.a.post([proxy_route, data.vault_id, 'relayer'].join("/"), {
    data: {
      http_verb: 'post',
      api_route: 'auth/renew-token',
      data: {}
    }
  });

  // const tmp = new Date();
  // tmp.setYear(new Date().getFullYear() + 1);
  // const utc = tmp.toUTCString();

  // const auth_token = "Bearer " + data.auth_token;
  // const api_uri = data.api.endsWith("/") ? data.api : data.api + "/";
  // const url = api_uri + "api/v1/jwts";
  // const payload = {
  //   data: {
  //     type: "jwts",
  //     attributes: {
  //       expires_at: utc,
  //       user_id: data.user_id,
  //     },
  //   },
  // };

  // return new Promise((resolve, reject) => {
  //   axios({
  //     method: "post",
  //     url: api_uri + "api/v1/jwts",
  //     data: payload,
  //     headers: {
  //       "Content-Type": "application/json",
  //       accept: "application/vnd.api+json",
  //       Authorization: auth_token,
  //     },
  //   }).then(
  //     (response) => {
  //       if (
  //         response.data &&
  //         response.data.attributes &&
  //         response.data.attributes.token
  //       ) {
  //         // localStorage.token = response.data.auth_token
  //         context.commit("set_login_token", response.data.attributes.token);
  //       }
  //       resolve(response);
  //     },
  //     (error) => {
  //       reject(error);
  //     }
  //   );
  // });
};

/* harmony default export */ var systemStates_store_actions = ({
  getVaults: actions_getVaults,
  getVaultTransactions: actions_getVaultTransactions,
  getVault: actions_getVault,
  addVault: actions_addVault,
  updateVault: actions_updateVault,
  deleteVault: actions_deleteVault,
  vaultLogin: actions_vaultLogin,
  vaultRenewToken: actions_vaultRenewToken,

  serviceLogin: actions_serviceLogin
});
// CONCATENATED MODULE: ./src/modules/systemStates/store/getters.js
var vaults = function vaults(state) {
  return state.vault_list_object;
};
var vault = function vault(state) {
  return state.vault;
};
var vault_token = function vault_token(state) {
  return state.vault_token;
};
var vault_transactions = function vault_transactions(state) {
  return state.vault_transactions_object;
};

/* harmony default export */ var systemStates_store_getters = ({
  vaults: vaults,
  vault: vault,
  vault_token: vault_token,
  vault_transactions: vault_transactions
});
// CONCATENATED MODULE: ./src/modules/systemStates/store/mutations.js
var set_vaults = function set_vaults(state, payload) {
  state.vault_list_object = payload;
};

var set_vault = function set_vault(state, payload) {
  state.vault = payload;
};

var set_login_token = function set_login_token(state, payload) {
  state.vault_token = payload;
};

var set_vault_transactions = function set_vault_transactions(state, payload) {
  state.vault_transactions_object = payload;
};

/* harmony default export */ var systemStates_store_mutations = ({
  set_vaults: set_vaults,
  set_vault: set_vault,
  set_login_token: set_login_token,
  set_vault_transactions: set_vault_transactions
});
// CONCATENATED MODULE: ./src/modules/systemStates/store/index.js




var systemStates_store_state = {
  vault_list_object: {},
  vault: {},
  vault_token: '',
  vault_transactions_object: {}
};

/* harmony default export */ var systemStates_store = ({
  namespaced: true,
  state: systemStates_store_state,
  actions: systemStates_store_actions,
  getters: systemStates_store_getters,
  mutations: systemStates_store_mutations
});
// CONCATENATED MODULE: ./src/modules/storeModules.js






/* harmony default export */ var storeModules = ({
  modules: {
    lens_an_states: store,
    lens_ed_states: endDeviceStates_store,
    lens_gw_states: gatewayStates_store,
    lens_org_states: organizationStates_store,
    lens_sys_states: systemStates_store
  }
});
// CONCATENATED MODULE: ./src/modules/systemStates/store/corporations.js

var corporations_proxy_route = 'vaults';
var api_route = 'api/v1/corporations';

// Define const Getters
var json_collection = function json_collection(state) {
  return state.json_collection;
};
var meta_collection = function meta_collection(state) {
  return state.meta_collection;
};
var json_element = function json_element(state) {
  return state.json_element;
};
var meta_element = function meta_element(state) {
  return state.meta_element;
};

var corporations = {
  namespaced: true,
  state: {
    json_collection: { data: [] },
    meta_collection: {},
    json_element: {},
    meta_element: {}
  },
  mutations: {
    store_collection: function store_collection(state, payload) {
      state.json_collection = payload.data;
      state.meta_collection = payload.meta;
    },
    store_element: function store_element(state, payload) {
      state.json_element = payload.data;
      state.meta_element = payload.meta;
    },
    add_element: function add_element(state, payload) {
      state.json_collection.data.push(payload);
    },
    update_element: function update_element(state, payload) {
      state.json_collection.data[state.json_collection.data.findIndex(function (e) {
        return e.id === payload.id;
      })] = payload;
    },
    remove_element: function remove_element(state, id) {
      state.json_collection.data.splice(state.json_collection.data.findIndex(function (e) {
        return e.id === id;
      }), 1);
    }
  },
  actions: {
    api_index: function api_index(context, data) {
      return new Promise(function (resolve, reject) {
        axios.post([corporations_proxy_route, data.vault_id, 'relayer'].join("/"), {
          data: Object.assign({
            http_verb: 'get',
            api_route: api_route
          }, data.params)
        }).then(function (response) {
          if (response.status === 200) {
            context.commit('store_collection', {
              data: response.data,
              meta: {
                pagination: {
                  // descending: false,
                  // page: data.params.page,
                  // sortBy: 'created-at',
                  rowsPerPage: response.headers['per-page'],
                  totalItems: response.headers.total
                }
              }
            });
          }
          resolve(response);
        }, function (error) {
          reject(error);
        });
      });
    },
    api_show: function api_show(context, data) {
      return new Promise(function (resolve, reject) {
        axios.post([corporations_proxy_route, data.vault_id, 'relayer'].join("/"), {
          data: Object.assign({
            http_verb: 'get',
            api_route: [api_route, data.id].join("/")
          }, data.params)
        }).then(function (response) {
          if (response.status === 200) {
            context.commit('store_element', {
              data: response.data.data,
              meta: {
                id: response.data.id
              }
            });
            context.commit('update_element', response.data.data);
          }
          resolve(response);
        }, function (error) {
          reject(error);
        });
      });
    },
    api_create: function api_create(context, data) {
      return new Promise(function (resolve, reject) {
        axios.post([corporations_proxy_route, data.vault_id, 'relayer'].join("/"), {
          data: Object.assign({
            http_verb: 'post',
            api_route: [api_route, data.id].join("/")
          }, data.params)
        }).then(function (response) {
          if (response.status === 201) {
            context.commit('store_element', {
              data: response.data.data,
              meta: {
                id: response.data.data.id
              }
            });
            context.commit('add_element', response.data.data);
          }
          resolve(response);
        }, function (error) {
          reject(error);
        });
      });
    },
    api_update: function api_update(context, data) {
      return new Promise(function (resolve, reject) {
        axios.post([corporations_proxy_route, data.vault_id, 'relayer'].join("/"), {
          data: Object.assign({
            http_verb: 'patch',
            api_route: [api_route, data.id].join("/")
          }, data.params)
        }).then(function (response) {
          if (response.status === 200) {
            context.commit('store_element', {
              data: response.data.data,
              meta: {
                id: response.data.data.id
              }
            });
            context.commit('update_element', response.data.data);
          }
          resolve(response);
        }, function (error) {
          reject(error);
        });
      });
    },
    api_destroy: function api_destroy(context, data) {
      return new Promise(function (resolve, reject) {
        axios.post([corporations_proxy_route, data.vault_id, 'relayer'].join("/"), {
          data: Object.assign({
            http_verb: 'delete',
            api_route: [api_route, data.id].join("/")
          }, data.params)
        }).then(function (response) {
          if (response.status < 400) {
            context.commit('remove_element', data.id);
          }
          resolve(response);
        }, function (error) {
          reject(error);
        });
      });
    }
  },
  getters: {
    json_collection: json_collection,
    meta_collection: meta_collection,
    json_element: json_element,
    meta_element: meta_element
  }
};

/* harmony default export */ var store_corporations = (corporations);
// CONCATENATED MODULE: ./src/modules/systemStates/store/lens_sites.js
// import {axios} from '../axios'
var lens_sites_proxy_route = 'vaults';
var lens_sites_api_route = 'api/v1/software_service_sites';

// Define const Getters
var lens_sites_json_collection = function json_collection(state) {
  return state.json_collection;
};
var lens_sites_meta_collection = function meta_collection(state) {
  return state.meta_collection;
};
var lens_sites_json_element = function json_element(state) {
  return state.json_element;
};
var lens_sites_meta_element = function meta_element(state) {
  return state.meta_element;
};

var lens_sites = {
  namespaced: true,
  state: {
    json_collection: { data: [] },
    meta_collection: {},
    json_element: {},
    meta_element: {}
  },
  mutations: {
    store_collection: function store_collection(state, payload) {
      state.json_collection = payload.data;
      state.meta_collection = payload.meta;
    },
    store_element: function store_element(state, payload) {
      state.json_element = payload.data;
      state.meta_element = payload.meta;
    },
    add_element: function add_element(state, payload) {
      state.json_collection.data.push(payload);
    },
    update_element: function update_element(state, payload) {
      state.json_collection.data[state.json_collection.data.findIndex(function (e) {
        return e.id === payload.id;
      })] = payload;
    },
    remove_element: function remove_element(state, id) {
      state.json_collection.data.splice(state.json_collection.data.findIndex(function (e) {
        return e.id === id;
      }), 1);
    }
  },
  actions: {
    api_index: function api_index(context, data) {
      return new Promise(function (resolve, reject) {
        axios.post([lens_sites_proxy_route, data.vault_id, 'relayer'].join("/"), {
          data: Object.assign({
            http_verb: 'get',
            api_route: lens_sites_api_route
          }, data.params)
        }).then(function (response) {
          if (response.status === 200) {
            context.commit('store_collection', {
              data: response.data,
              meta: {
                pagination: {
                  // descending: false,
                  // page: data.params.page,
                  // sortBy: 'created-at',
                  rowsPerPage: response.headers['per-page'],
                  totalItems: response.headers.total
                }
              }
            });
          }
          resolve(response);
        }, function (error) {
          reject(error);
        });
      });
    },
    api_show: function api_show(context, data) {
      return new Promise(function (resolve, reject) {
        axios.post([lens_sites_proxy_route, data.vault_id, 'relayer'].join("/"), {
          data: Object.assign({
            http_verb: 'get',
            api_route: [lens_sites_api_route, data.id].join("/")
          }, data.params)
        }).then(function (response) {
          if (response.status === 200) {
            context.commit('store_element', {
              data: response.data.data,
              meta: {
                id: response.data.data.id
              }
            });
            context.commit('update_element', response.data.data);
          }
          resolve(response);
        }, function (error) {
          reject(error);
        });
      });
    },
    api_create: function api_create(context, data) {
      return new Promise(function (resolve, reject) {
        axios.post([lens_sites_proxy_route, data.vault_id, 'relayer'].join("/"), {
          data: {
            http_verb: 'post',
            api_route: [lens_sites_api_route].join("/"),
            data: data.data
          }
        }).then(function (response) {
          if (response.status === 201) {
            context.commit('store_element', {
              data: response.data.data,
              meta: {
                id: response.data.data.id
              }
            });
            context.commit('add_element', response.data.data);
          }
          resolve(response);
        }, function (error) {
          reject(error);
        });
      });
    },
    api_update: function api_update(context, data) {
      return new Promise(function (resolve, reject) {
        axios.post([lens_sites_proxy_route, data.vault_id, 'relayer'].join("/"), {
          data: {
            http_verb: 'patch',
            api_route: [lens_sites_api_route, data.id].join("/"),
            data: data.data
          }
        }).then(function (response) {
          if (response.status === 200) {
            context.commit('store_element', {
              data: response.data.data,
              meta: {
                id: response.data.data.id
              }
            });
            context.commit('update_element', response.data.data);
          }
          resolve(response);
        }, function (error) {
          reject(error);
        });
      });
    },
    api_destroy: function api_destroy(context, data) {
      return new Promise(function (resolve, reject) {
        axios.post([lens_sites_proxy_route, data.vault_id, 'relayer'].join("/"), {
          data: Object.assign({
            http_verb: 'delete',
            api_route: [lens_sites_api_route, data.id].join("/")
          }, data.params)
        }).then(function (response) {
          if (response.status < 400) {
            context.commit('remove_element', data.id);
          }
          resolve(response);
        }, function (error) {
          reject(error);
        });
      });
    }
  },
  getters: {
    json_collection: lens_sites_json_collection,
    meta_collection: lens_sites_meta_collection,
    json_element: lens_sites_json_element,
    meta_element: lens_sites_meta_element
  }
};

/* harmony default export */ var store_lens_sites = (lens_sites);
// CONCATENATED MODULE: ./src/modules/systemStates/store/tenant_accounts.js

var tenant_accounts_proxy_route = 'vaults';
var tenant_accounts_api_route = 'api/v1/tenant_accounts';

// Define const Getters
var tenant_accounts_json_collection = function json_collection(state) {
  return state.json_collection;
};
var tenant_accounts_meta_collection = function meta_collection(state) {
  return state.meta_collection;
};
var tenant_accounts_json_element = function json_element(state) {
  return state.json_element;
};
var tenant_accounts_meta_element = function meta_element(state) {
  return state.meta_element;
};

var tenant_accounts = {
  namespaced: true,
  state: {
    json_collection: { data: [] },
    meta_collection: {},
    json_element: {},
    meta_element: {}
  },
  mutations: {
    store_collection: function store_collection(state, payload) {
      state.json_collection = payload.data;
      state.meta_collection = payload.meta;
    },
    store_element: function store_element(state, payload) {
      state.json_element = payload.data;
      state.meta_element = payload.meta;
    },
    add_element: function add_element(state, payload) {
      state.json_collection.data.push(payload);
    },
    update_element: function update_element(state, payload) {
      state.json_collection.data[state.json_collection.data.findIndex(function (e) {
        return e.id === payload.id;
      })] = payload;
    },
    remove_element: function remove_element(state, id) {
      state.json_collection.data.splice(state.json_collection.data.findIndex(function (e) {
        return e.id === id;
      }), 1);
    }
  },
  actions: {
    api_index: function api_index(context, data) {
      return new Promise(function (resolve, reject) {
        axios.post([tenant_accounts_proxy_route, data.vault_id, 'relayer'].join("/"), {
          data: Object.assign({
            http_verb: 'get',
            api_route: tenant_accounts_api_route
          }, data.params)
        }).then(function (response) {
          if (response.status === 200) {
            context.commit('store_collection', {
              data: response.data,
              meta: {
                pagination: {
                  // descending: false,
                  // page: data.params.page,
                  // sortBy: 'created-at',
                  rowsPerPage: response.headers['per-page'],
                  totalItems: response.headers.total
                }
              }
            });
          }
          resolve(response);
        }, function (error) {
          reject(error);
        });
      });
    },
    api_show: function api_show(context, data) {
      return new Promise(function (resolve, reject) {
        axios.post([tenant_accounts_proxy_route, data.vault_id, 'relayer'].join("/"), {
          data: Object.assign({
            http_verb: 'get',
            api_route: [tenant_accounts_api_route, data.tenant_account_id].join("/")
          }, data.params)
        }).then(function (response) {
          if (response.status === 200) {
            context.commit('store_element', {
              data: response.data.data,
              meta: {
                id: response.data.data.id
              }
            });
            context.commit('update_element', response.data.data);
          }
          resolve(response);
        }, function (error) {
          reject(error);
        });
      });
    },
    api_create: function api_create(context, data) {
      return new Promise(function (resolve, reject) {
        axios.post([tenant_accounts_proxy_route, data.vault_id, 'relayer'].join("/"), {
          data: Object.assign({
            http_verb: 'post',
            api_route: [tenant_accounts_api_route, data.id].join("/")
          }, data)
        }).then(function (response) {
          if (response.status === 201) {
            context.commit('store_element', {
              data: response.data.data,
              meta: {
                id: response.data.data.id
              }
            });
            context.commit('add_element', response.data.data);
          }
          resolve(response);
        }, function (error) {
          reject(error);
        });
      });
    },
    api_update: function api_update(context, data) {
      axios.post([tenant_accounts_proxy_route, data.vault_id, 'relayer'].join("/"), {
        data: {
          http_verb: 'patch',
          api_route: [tenant_accounts_api_route, data.id].join('/'),
          data: data.data
        }
      }).then(function (response) {
        if (response.status === 200) {
          context.commit('store_element', {
            data: response.data.data,
            meta: {
              id: response.data.data.id
            }
          });
          context.commit('update_element', response.data.data);
        }
      }).catch(function (error) {});
    },
    api_destroy: function api_destroy(context, data) {
      return new Promise(function (resolve, reject) {
        axios.post([tenant_accounts_proxy_route, data.vault_id, 'relayer'].join("/"), {
          data: {
            http_verb: 'delete',
            api_route: [tenant_accounts_api_route, data.id].join('/')
          }
        }).then(function (response) {
          if (response.status < 400) {
            context.commit('remove_element', data.id);
          }
          resolve(response);
        }, function (error) {
          reject(error);
        });
      });
    }
  },
  getters: {
    json_collection: tenant_accounts_json_collection,
    meta_collection: tenant_accounts_meta_collection,
    json_element: tenant_accounts_json_element,
    meta_element: tenant_accounts_meta_element
  }
};

/* harmony default export */ var store_tenant_accounts = (tenant_accounts);
// EXTERNAL MODULE: ./src/store/service_api_keys.js
var service_api_keys = __webpack_require__(234);

// CONCATENATED MODULE: ./src/store/index.js
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SET_UNSAVED_CHANGES_TRUE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SET_UNSAVED_CHANGES_FALSE; });
var _mutations;

function store__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

















vue_esm["default"].use(vuex_esm["a" /* default */]);

var SET_UNSAVED_CHANGES_TRUE = 'SET_UNSAVED_CHANGES_TRUE';
var SET_UNSAVED_CHANGES_FALSE = 'SET_UNSAVED_CHANGES_FALSE';

var productionOnlyPlugins =  false ? [] : [Object(vuex_persistedstate_es["a" /* default */])({
  paths: ['session', 'ui', 'entities.application_networks.statistics', 'entities.end_devices.statistics', 'entities.device_groups.statistics', 'entities.device_profiles.statistics', 'entities.policies.statistics', 'entities.gateways.statistics', 'entities.organizations', 'entities.service_api_keys.statistics']
})];

var initialState = function initialState() {
  return {
    unsavedChanges: false
  };
};

// strict mode not recommended for production:
// https://vuex.vuejs.org/guide/strict.html

/* harmony default export */ var src_store = __webpack_exports__["c"] = (new vuex_esm["a" /* default */].Store({
  strict: "production" !== 'production',
  plugins: [].concat(productionOnlyPlugins),
  modules: {
    entities: store_entities,
    notifications: notifications["d" /* default */],
    session: session["e" /* default */],
    ui: ui["f" /* default */],
    devicehq: devicehq_modules,
    lensmodules: storeModules,
    corporations: store_corporations,
    lens_sites: store_lens_sites,
    service_api_keys: service_api_keys["f" /* default */],
    tenant_accounts: store_tenant_accounts
  },
  state: initialState(),
  getters: {},
  mutations: (_mutations = {
    RESET_STATE: function RESET_STATE(state) {
      Object.assign(state, initialState());
    }
  }, store__defineProperty(_mutations, SET_UNSAVED_CHANGES_TRUE, function (state) {
    state.unsavedChanges = true;
  }), store__defineProperty(_mutations, SET_UNSAVED_CHANGES_FALSE, function (state) {
    state.unsavedChanges = false;
  }), _mutations),
  actions: {}
}));

/***/ }),

/***/ 980:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DataLoadingSkeletonString; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_random_int__ = __webpack_require__(997);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_random_int___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_random_int__);


var ANIMATION_CLASS = 'animated-loading-background';

var heightPx = function heightPx() {
  var height = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
  return height * 14 + 'px';
};
var widthPercent = function widthPercent() {
  return __WEBPACK_IMPORTED_MODULE_0_random_int___default()(30, 100) + '%';
};

var DataLoadingSkeletonString = function DataLoadingSkeletonString() {
  return '<div\n    class="' + ANIMATION_CLASS + ' mt2"\n    style="height: ' + heightPx() + '; width: ' + widthPercent() + ';"\n    ></div>';
};

/* harmony default export */ __webpack_exports__["b"] = ({
  name: 'DataLoadingSkeleton',
  functional: true,
  render: function render(createElement, _ref) {
    var _ref$props = _ref.props,
        height = _ref$props.height,
        width = _ref$props.width,
        data = _ref.data;

    if (!data.style) data.style = {};
    if (!data.staticClass) data.staticClass = '';
    data.staticClass += ' ' + ANIMATION_CLASS;
    data.style.height = heightPx(height);
    data.style.width = width || widthPercent();
    return createElement('div', data);
  }
});

/***/ }),

/***/ 992:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__(12);

// EXTERNAL MODULE: ./node_modules/@mdi/font/css/materialdesignicons.css
var materialdesignicons = __webpack_require__(451);
var materialdesignicons_default = /*#__PURE__*/__webpack_require__.n(materialdesignicons);

// EXTERNAL MODULE: ./node_modules/vuetify/dist/vuetify.js
var vuetify = __webpack_require__(452);
var vuetify_default = /*#__PURE__*/__webpack_require__.n(vuetify);

// EXTERNAL MODULE: ./node_modules/vuetify/dist/vuetify.min.css
var vuetify_min = __webpack_require__(453);
var vuetify_min_default = /*#__PURE__*/__webpack_require__.n(vuetify_min);

// EXTERNAL MODULE: ./node_modules/vue-the-mask/dist/vue-the-mask.js
var vue_the_mask = __webpack_require__(223);
var vue_the_mask_default = /*#__PURE__*/__webpack_require__.n(vue_the_mask);

// CONCATENATED MODULE: ./src/plugins/vuetify.js
 // Ensure you are using css-loader



 // Does not seem to be imported as needed...double check

vue_esm["default"].use(vuetify_default.a);

/* harmony default export */ var plugins_vuetify = (new vuetify_default.a({
  directives: {
    mask: vue_the_mask["mask"]
  },
  icons: {
    iconfont: 'mdi' // default - only for display purposes
  },
  theme: {
    dark: false,
    themes: {
      light: {
        primary: '#0072CE',
        secondary: '#707372',
        accent: '#40C1AC',
        error: '#D22630',
        info: '#9E007E',
        success: '#0cba00',
        warning: '#EAAA00'
      },
      dark: {
        primary: '#0072CE',
        secondary: '#707372',
        accent: '#40C1AC',
        error: '#D22630',
        info: '#9E007E',
        success: '#0cba00',
        warning: '#EAAA00'
      }
    }
  }
}));
// EXTERNAL MODULE: ./node_modules/vue-match-media/src/index.js
var src = __webpack_require__(454);

// EXTERNAL MODULE: ./node_modules/vuelidate-error-extractor/dist/vuelidate-error-extractor.js
var vuelidate_error_extractor = __webpack_require__(174);
var vuelidate_error_extractor_default = /*#__PURE__*/__webpack_require__.n(vuelidate_error_extractor);

// EXTERNAL MODULE: ./node_modules/vuetrend/dist/vue-trend.esm.js
var vue_trend_esm = __webpack_require__(455);

// EXTERNAL MODULE: ./node_modules/typeface-open-sans/index.css
var typeface_open_sans = __webpack_require__(456);
var typeface_open_sans_default = /*#__PURE__*/__webpack_require__.n(typeface_open_sans);

// EXTERNAL MODULE: ./node_modules/vue2-google-maps/dist/main.js
var main = __webpack_require__(239);
var main_default = /*#__PURE__*/__webpack_require__.n(main);

// EXTERNAL MODULE: ./node_modules/humanize-string/index.js
var humanize_string = __webpack_require__(470);
var humanize_string_default = /*#__PURE__*/__webpack_require__.n(humanize_string);

// EXTERNAL MODULE: ./src/store/index.js + 52 modules
var store = __webpack_require__(93);

// EXTERNAL MODULE: ./node_modules/vue-router/dist/vue-router.esm.js
var vue_router_esm = __webpack_require__(235);

// EXTERNAL MODULE: ./node_modules/fast-deep-equal/index.js
var fast_deep_equal = __webpack_require__(227);
var fast_deep_equal_default = /*#__PURE__*/__webpack_require__.n(fast_deep_equal);

// EXTERNAL MODULE: ./node_modules/delay/index.js
var delay = __webpack_require__(229);
var delay_default = /*#__PURE__*/__webpack_require__.n(delay);

// EXTERNAL MODULE: ./node_modules/object-path/index.js
var object_path = __webpack_require__(15);
var object_path_default = /*#__PURE__*/__webpack_require__.n(object_path);

// EXTERNAL MODULE: ./node_modules/date-fns/index.js
var date_fns = __webpack_require__(94);
var date_fns_default = /*#__PURE__*/__webpack_require__.n(date_fns);

// EXTERNAL MODULE: ./src/store/session.js
var session = __webpack_require__(17);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ApplicationNetworkSpeedDial.vue
//
//
//
//
//

var TopbarSpeedDial = function TopbarSpeedDial() {
  return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 1943));
};

/* harmony default export */ var ApplicationNetworkSpeedDial = ({
  name: 'ApplicationNetworkSpeedDial',
  props: {
    routeName: { type: String, default: '' },
    routeKey: { type: String, default: '' }
  },
  data: function data() {
    return {
      buttonsConfig: [{
        label: 'Create new application network',
        icon: 'add',
        colorClass: 'accent',
        showForListScreen: true,
        to: 'new'
      }]
    };
  },

  computed: {
    buttons: function buttons() {
      if (this.routeName.startsWith('ApplicationNetworks')) {
        return this.buttonsConfig.filter(function (btn) {
          return btn.showForListScreen;
        });
      } else {
        return this.buttonsConfig;
      }
    }
  },
  components: {
    TopbarSpeedDial: TopbarSpeedDial
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2d8f18fc","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ApplicationNetworkSpeedDial.vue
var ApplicationNetworkSpeedDial_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('TopbarSpeedDial',{attrs:{"buttons":_vm.buttons,"routeKey":_vm.routeKey}})}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__(14);

// CONCATENATED MODULE: ./src/components/ApplicationNetworkSpeedDial.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  ApplicationNetworkSpeedDial,
  ApplicationNetworkSpeedDial_render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_ApplicationNetworkSpeedDial = (Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/GatewaySpeedDial.vue
//
//
//
//
//

var GatewaySpeedDial_TopbarSpeedDial = function TopbarSpeedDial() {
  return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 1943));
};

/* harmony default export */ var GatewaySpeedDial = ({
  name: "GatewaySpeedDial",
  props: {
    routeName: { type: String, default: "" },
    routeKey: { type: String, default: "" }
  },
  data: function data() {
    return {
      buttonsConfig: [{
        label: "Provision new gateway",
        icon: "add",
        colorClass: "primary",
        showForGatewaysScreen: true,
        to: "new"
      }, {
        label: "Upload CSV of gateways",
        icon: "cloud_upload",
        colorClass: "primary",
        showForGatewaysScreen: true,
        to: "upload"
      }]
    };
  },

  computed: {
    buttons: function buttons() {
      if (this.routeName.startsWith("Gateways")) {
        return this.buttonsConfig.filter(function (btn) {
          return btn.showForGatewaysScreen;
        });
      } else {
        return this.buttonsConfig;
      }
    }
  },
  components: {
    TopbarSpeedDial: GatewaySpeedDial_TopbarSpeedDial
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6c8311de","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/GatewaySpeedDial.vue
var GatewaySpeedDial_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('TopbarSpeedDial',{attrs:{"buttons":_vm.buttons,"routeKey":_vm.routeKey}})}
var GatewaySpeedDial_staticRenderFns = []

// CONCATENATED MODULE: ./src/components/GatewaySpeedDial.vue
/* script */


/* template */

/* template functional */
var GatewaySpeedDial___vue_template_functional__ = false
/* styles */
var GatewaySpeedDial___vue_styles__ = null
/* scopeId */
var GatewaySpeedDial___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var GatewaySpeedDial___vue_module_identifier__ = null

var GatewaySpeedDial_Component = Object(component_normalizer["a" /* default */])(
  GatewaySpeedDial,
  GatewaySpeedDial_render,
  GatewaySpeedDial_staticRenderFns,
  GatewaySpeedDial___vue_template_functional__,
  GatewaySpeedDial___vue_styles__,
  GatewaySpeedDial___vue_scopeId__,
  GatewaySpeedDial___vue_module_identifier__
)

/* harmony default export */ var components_GatewaySpeedDial = (GatewaySpeedDial_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/EndDeviceSpeedDial.vue
//
//
//
//
//

var EndDeviceSpeedDial_TopbarSpeedDial = function TopbarSpeedDial() {
  return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 1943));
};

/* harmony default export */ var EndDeviceSpeedDial = ({
  name: 'EndDeviceSpeedDial',
  props: {
    routeName: { type: String, default: '' },
    routeKey: { type: String, default: '' }
  },
  data: function data() {
    return {
      buttonsConfig: [{
        label: 'Provision new end-device',
        icon: 'add',
        colorClass: 'primary',
        showForEndDevicesScreen: true,
        to: 'new'
      }, {
        label: 'Upload CSV of end-devices',
        icon: 'cloud_upload',
        colorClass: 'primary',
        showForEndDevicesScreen: true,
        to: 'upload'
      }]
    };
  },

  computed: {
    buttons: function buttons() {
      if (this.routeName.startsWith('EndDevices')) {
        return this.buttonsConfig.filter(function (btn) {
          return btn.showForEndDevicesScreen;
        });
      } else {
        return this.buttonsConfig;
      }
    }
  },
  components: {
    TopbarSpeedDial: EndDeviceSpeedDial_TopbarSpeedDial
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1c5e7fc8","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/EndDeviceSpeedDial.vue
var EndDeviceSpeedDial_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('TopbarSpeedDial',{attrs:{"buttons":_vm.buttons,"routeKey":_vm.routeKey}})}
var EndDeviceSpeedDial_staticRenderFns = []

// CONCATENATED MODULE: ./src/components/EndDeviceSpeedDial.vue
/* script */


/* template */

/* template functional */
var EndDeviceSpeedDial___vue_template_functional__ = false
/* styles */
var EndDeviceSpeedDial___vue_styles__ = null
/* scopeId */
var EndDeviceSpeedDial___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var EndDeviceSpeedDial___vue_module_identifier__ = null

var EndDeviceSpeedDial_Component = Object(component_normalizer["a" /* default */])(
  EndDeviceSpeedDial,
  EndDeviceSpeedDial_render,
  EndDeviceSpeedDial_staticRenderFns,
  EndDeviceSpeedDial___vue_template_functional__,
  EndDeviceSpeedDial___vue_styles__,
  EndDeviceSpeedDial___vue_scopeId__,
  EndDeviceSpeedDial___vue_module_identifier__
)

/* harmony default export */ var components_EndDeviceSpeedDial = (EndDeviceSpeedDial_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/service_api_keys/ServiceApiKeySpeedDial.vue
//
//
//
//
//

var ServiceApiKeySpeedDial_TopbarSpeedDial = function TopbarSpeedDial() {
  return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 1943));
};

/* harmony default export */ var ServiceApiKeySpeedDial = ({
  name: 'ServiceApiKeySpeedDial',
  props: {
    routeName: { type: String, default: '' },
    routeKey: { type: String, default: '' }
  },
  data: function data() {
    return {
      buttonsConfig: [{
        label: 'New Service Api Key',
        icon: 'add',
        colorClass: 'primary',
        to: 'new'
      }]
    };
  },

  computed: {
    buttons: function buttons() {
      return this.buttonsConfig;
    }
  },
  components: {
    TopbarSpeedDial: ServiceApiKeySpeedDial_TopbarSpeedDial
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d032979a","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/service_api_keys/ServiceApiKeySpeedDial.vue
var ServiceApiKeySpeedDial_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('TopbarSpeedDial',{attrs:{"buttons":_vm.buttons,"routeKey":_vm.routeKey}})}
var ServiceApiKeySpeedDial_staticRenderFns = []

// CONCATENATED MODULE: ./src/components/service_api_keys/ServiceApiKeySpeedDial.vue
/* script */


/* template */

/* template functional */
var ServiceApiKeySpeedDial___vue_template_functional__ = false
/* styles */
var ServiceApiKeySpeedDial___vue_styles__ = null
/* scopeId */
var ServiceApiKeySpeedDial___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ServiceApiKeySpeedDial___vue_module_identifier__ = null

var ServiceApiKeySpeedDial_Component = Object(component_normalizer["a" /* default */])(
  ServiceApiKeySpeedDial,
  ServiceApiKeySpeedDial_render,
  ServiceApiKeySpeedDial_staticRenderFns,
  ServiceApiKeySpeedDial___vue_template_functional__,
  ServiceApiKeySpeedDial___vue_styles__,
  ServiceApiKeySpeedDial___vue_scopeId__,
  ServiceApiKeySpeedDial___vue_module_identifier__
)

/* harmony default export */ var service_api_keys_ServiceApiKeySpeedDial = (ServiceApiKeySpeedDial_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/DeviceGroupSpeedDial.vue
//
//
//
//
//

var DeviceGroupSpeedDial_TopbarSpeedDial = function TopbarSpeedDial() {
  return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 1943));
};

/* harmony default export */ var DeviceGroupSpeedDial = ({
  name: 'DeviceGroupSpeedDial',
  props: {
    routeName: { type: String, default: '' },
    routeKey: { type: String, default: '' }
  },
  data: function data() {
    return {
      buttonsConfig: [{
        label: 'Create new group',
        icon: 'add',
        to: 'new'
      }]
    };
  },

  components: {
    TopbarSpeedDial: DeviceGroupSpeedDial_TopbarSpeedDial
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2ebc9f5b","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/DeviceGroupSpeedDial.vue
var DeviceGroupSpeedDial_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('TopbarSpeedDial',{attrs:{"buttons":_vm.buttonsConfig,"routeKey":_vm.routeKey}})}
var DeviceGroupSpeedDial_staticRenderFns = []

// CONCATENATED MODULE: ./src/components/DeviceGroupSpeedDial.vue
/* script */


/* template */

/* template functional */
var DeviceGroupSpeedDial___vue_template_functional__ = false
/* styles */
var DeviceGroupSpeedDial___vue_styles__ = null
/* scopeId */
var DeviceGroupSpeedDial___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var DeviceGroupSpeedDial___vue_module_identifier__ = null

var DeviceGroupSpeedDial_Component = Object(component_normalizer["a" /* default */])(
  DeviceGroupSpeedDial,
  DeviceGroupSpeedDial_render,
  DeviceGroupSpeedDial_staticRenderFns,
  DeviceGroupSpeedDial___vue_template_functional__,
  DeviceGroupSpeedDial___vue_styles__,
  DeviceGroupSpeedDial___vue_scopeId__,
  DeviceGroupSpeedDial___vue_module_identifier__
)

/* harmony default export */ var components_DeviceGroupSpeedDial = (DeviceGroupSpeedDial_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/DeviceProfileSpeedDial.vue
//
//
//
//
//

var DeviceProfileSpeedDial_TopbarSpeedDial = function TopbarSpeedDial() {
  return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 1943));
};

/* harmony default export */ var DeviceProfileSpeedDial = ({
  name: 'DeviceProfileSpeedDial',
  props: {
    routeName: { type: String, default: '' },
    routeKey: { type: String, default: '' }
  },
  data: function data() {
    return {
      buttonsConfig: [{
        label: 'Create Device Profile',
        icon: 'add',
        showForDeviceProfilesScreen: true,
        colorClass: 'accent',
        to: 'new'
      }]
    };
  },

  computed: {
    buttons: function buttons() {
      if (this.routeName.startsWith('DeviceProfiles')) {
        return this.buttonsConfig.filter(function (btn) {
          return btn.showForDeviceProfilesScreen;
        });
      } else {
        return this.buttonsConfig;
      }
    }
  },
  components: {
    TopbarSpeedDial: DeviceProfileSpeedDial_TopbarSpeedDial
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-242d7a94","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/DeviceProfileSpeedDial.vue
var DeviceProfileSpeedDial_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('TopbarSpeedDial',{attrs:{"buttons":_vm.buttons,"routeKey":_vm.routeKey}})}
var DeviceProfileSpeedDial_staticRenderFns = []

// CONCATENATED MODULE: ./src/components/DeviceProfileSpeedDial.vue
/* script */


/* template */

/* template functional */
var DeviceProfileSpeedDial___vue_template_functional__ = false
/* styles */
var DeviceProfileSpeedDial___vue_styles__ = null
/* scopeId */
var DeviceProfileSpeedDial___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var DeviceProfileSpeedDial___vue_module_identifier__ = null

var DeviceProfileSpeedDial_Component = Object(component_normalizer["a" /* default */])(
  DeviceProfileSpeedDial,
  DeviceProfileSpeedDial_render,
  DeviceProfileSpeedDial_staticRenderFns,
  DeviceProfileSpeedDial___vue_template_functional__,
  DeviceProfileSpeedDial___vue_styles__,
  DeviceProfileSpeedDial___vue_scopeId__,
  DeviceProfileSpeedDial___vue_module_identifier__
)

/* harmony default export */ var components_DeviceProfileSpeedDial = (DeviceProfileSpeedDial_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/NetworkProfileSpeedDial.vue
//
//
//
//
//

var NetworkProfileSpeedDial_TopbarSpeedDial = function TopbarSpeedDial() {
  return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 1943));
};

/* harmony default export */ var NetworkProfileSpeedDial = ({
  name: 'NetworkProfileSpeedDial',
  props: {
    routeName: { type: String, default: '' },
    routeKey: { type: String, default: '' }
  },
  data: function data() {
    return {
      buttonsConfig: [{
        label: 'Create Network Profile',
        icon: 'add',
        showForNetworkProfilesScreen: true,
        colorClass: 'accent',
        to: 'new'
      }]
    };
  },

  computed: {
    buttons: function buttons() {
      if (this.routeName.startsWith('NetworkProfiles')) {
        return this.buttonsConfig.filter(function (btn) {
          return btn.showForNetworkProfilesScreen;
        });
      } else {
        return this.buttonsConfig;
      }
    }
  },
  components: {
    TopbarSpeedDial: NetworkProfileSpeedDial_TopbarSpeedDial
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2701c966","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NetworkProfileSpeedDial.vue
var NetworkProfileSpeedDial_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('TopbarSpeedDial',{attrs:{"buttons":_vm.buttons,"routeKey":_vm.routeKey}})}
var NetworkProfileSpeedDial_staticRenderFns = []

// CONCATENATED MODULE: ./src/components/NetworkProfileSpeedDial.vue
/* script */


/* template */

/* template functional */
var NetworkProfileSpeedDial___vue_template_functional__ = false
/* styles */
var NetworkProfileSpeedDial___vue_styles__ = null
/* scopeId */
var NetworkProfileSpeedDial___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var NetworkProfileSpeedDial___vue_module_identifier__ = null

var NetworkProfileSpeedDial_Component = Object(component_normalizer["a" /* default */])(
  NetworkProfileSpeedDial,
  NetworkProfileSpeedDial_render,
  NetworkProfileSpeedDial_staticRenderFns,
  NetworkProfileSpeedDial___vue_template_functional__,
  NetworkProfileSpeedDial___vue_styles__,
  NetworkProfileSpeedDial___vue_scopeId__,
  NetworkProfileSpeedDial___vue_module_identifier__
)

/* harmony default export */ var components_NetworkProfileSpeedDial = (NetworkProfileSpeedDial_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/UserSpeedDial.vue
//
//
//
//
//

var UserSpeedDial_TopbarSpeedDial = function TopbarSpeedDial() {
  return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 1943));
};

/* harmony default export */ var UserSpeedDial = ({
  name: 'UserSpeedDial',
  props: {
    routeName: { type: String, default: '' },
    routeKey: { type: String, default: '' }
  },
  data: function data() {
    return {
      buttonsConfig: [{
        label: 'Invite a Person',
        icon: 'add',
        to: 'new'
      }]
    };
  },

  computed: {
    readOnlyUser: function readOnlyUser() {
      var rolesMask = this.$store.getters.currentUser.roles_mask;

      return rolesMask === 16 || rolesMask === 8;
    }
  },
  components: {
    TopbarSpeedDial: UserSpeedDial_TopbarSpeedDial
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d4ee58b4","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/UserSpeedDial.vue
var UserSpeedDial_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.readOnlyUser)?_c('TopbarSpeedDial',{attrs:{"buttons":_vm.buttonsConfig,"routeKey":_vm.routeKey}}):_vm._e()}
var UserSpeedDial_staticRenderFns = []

// CONCATENATED MODULE: ./src/components/UserSpeedDial.vue
/* script */


/* template */

/* template functional */
var UserSpeedDial___vue_template_functional__ = false
/* styles */
var UserSpeedDial___vue_styles__ = null
/* scopeId */
var UserSpeedDial___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var UserSpeedDial___vue_module_identifier__ = null

var UserSpeedDial_Component = Object(component_normalizer["a" /* default */])(
  UserSpeedDial,
  UserSpeedDial_render,
  UserSpeedDial_staticRenderFns,
  UserSpeedDial___vue_template_functional__,
  UserSpeedDial___vue_styles__,
  UserSpeedDial___vue_scopeId__,
  UserSpeedDial___vue_module_identifier__
)

/* harmony default export */ var components_UserSpeedDial = (UserSpeedDial_Component.exports);

// EXTERNAL MODULE: ./src/utils/api.js
var api = __webpack_require__(18);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/OrganizationSpeedDial.vue
//
//
//
//
//

var OrganizationSpeedDial_TopbarSpeedDial = function TopbarSpeedDial() {
  return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 1943));
};



/* harmony default export */ var OrganizationSpeedDial = ({
  name: 'OrganizationSpeedDial',
  extends: {
    methods: {
      sysAdmin: api["j" /* sysAdmin */]
    }
  },
  props: {
    routeName: { type: String, default: '' },
    routeKey: { type: String, default: '' }
  },
  data: function data() {
    return {
      buttonsConfig: [{
        label: 'Create new ... ',
        icon: 'add',
        to: 'new'
      }]
    };
  },
  mounted: function mounted() {},

  computed: {
    readOnlyUser: function readOnlyUser() {
      var rolesMask = this.$store.getters.currentUser.roles_mask;

      return rolesMask === 16 || rolesMask === 8;
    }
  },
  components: {
    TopbarSpeedDial: OrganizationSpeedDial_TopbarSpeedDial
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f2ddc99a","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OrganizationSpeedDial.vue
var OrganizationSpeedDial_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.sysAdmin)?_c('TopbarSpeedDial',{attrs:{"buttons":_vm.buttonsConfig,"routeKey":_vm.routeKey}}):_vm._e()}
var OrganizationSpeedDial_staticRenderFns = []

// CONCATENATED MODULE: ./src/components/OrganizationSpeedDial.vue
/* script */


/* template */

/* template functional */
var OrganizationSpeedDial___vue_template_functional__ = false
/* styles */
var OrganizationSpeedDial___vue_styles__ = null
/* scopeId */
var OrganizationSpeedDial___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var OrganizationSpeedDial___vue_module_identifier__ = null

var OrganizationSpeedDial_Component = Object(component_normalizer["a" /* default */])(
  OrganizationSpeedDial,
  OrganizationSpeedDial_render,
  OrganizationSpeedDial_staticRenderFns,
  OrganizationSpeedDial___vue_template_functional__,
  OrganizationSpeedDial___vue_styles__,
  OrganizationSpeedDial___vue_scopeId__,
  OrganizationSpeedDial___vue_module_identifier__
)

/* harmony default export */ var components_OrganizationSpeedDial = (OrganizationSpeedDial_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/PolicySpeedDial.vue
//
//
//
//
//

var PolicySpeedDial_TopbarSpeedDial = function TopbarSpeedDial() {
  return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 1943));
};

/* harmony default export */ var PolicySpeedDial = ({
  name: 'PolicySpeedDial',
  props: {
    routeName: { type: String, default: '' },
    routeKey: { type: String, default: '' }
  },
  data: function data() {
    return {
      buttonsConfig: [{
        label: 'Create new policy',
        icon: 'add',
        colorClass: 'accent',
        showForListScreen: true,
        to: 'new'
      }]
    };
  },

  computed: {
    buttons: function buttons() {
      if (this.routeName.startsWith('policies')) {
        return this.buttonsConfig.filter(function (btn) {
          return btn.showForListScreen;
        });
      } else {
        return this.buttonsConfig;
      }
    }
  },
  components: {
    TopbarSpeedDial: PolicySpeedDial_TopbarSpeedDial
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f56db022","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PolicySpeedDial.vue
var PolicySpeedDial_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('TopbarSpeedDial',{attrs:{"buttons":_vm.buttons,"routeKey":_vm.routeKey}})}
var PolicySpeedDial_staticRenderFns = []

// CONCATENATED MODULE: ./src/components/PolicySpeedDial.vue
/* script */


/* template */

/* template functional */
var PolicySpeedDial___vue_template_functional__ = false
/* styles */
var PolicySpeedDial___vue_styles__ = null
/* scopeId */
var PolicySpeedDial___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var PolicySpeedDial___vue_module_identifier__ = null

var PolicySpeedDial_Component = Object(component_normalizer["a" /* default */])(
  PolicySpeedDial,
  PolicySpeedDial_render,
  PolicySpeedDial_staticRenderFns,
  PolicySpeedDial___vue_template_functional__,
  PolicySpeedDial___vue_styles__,
  PolicySpeedDial___vue_scopeId__,
  PolicySpeedDial___vue_module_identifier__
)

/* harmony default export */ var components_PolicySpeedDial = (PolicySpeedDial_Component.exports);

// EXTERNAL MODULE: ./node_modules/offline-plugin/runtime.js
var runtime = __webpack_require__(220);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);

// CONCATENATED MODULE: ./src/router/index.js
var _this = this;

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
























var App = function App() {
  return __webpack_require__.e/* import() */(78).then(__webpack_require__.bind(null, 1944));
};
var Login = function Login() {
  return __webpack_require__.e/* import() */(62).then(__webpack_require__.bind(null, 1945));
};
var Dashboard = function Dashboard() {
  return __webpack_require__.e/* import() */(56).then(__webpack_require__.bind(null, 1946));
};
var MapView = function MapView() {
  return __webpack_require__.e/* import() */(93).then(__webpack_require__.bind(null, 1948));
};
var PacketsChart = function PacketsChart() {
  return __webpack_require__.e/* import() */(23).then(__webpack_require__.bind(null, 976));
};
var JoinRequestsChart = function JoinRequestsChart() {
  return __webpack_require__.e/* import() */(25).then(__webpack_require__.bind(null, 977));
};
var CrcPercentageChart = function CrcPercentageChart() {
  return __webpack_require__.e/* import() */(21).then(__webpack_require__.bind(null, 978));
};
var MissedPacketsChart = function MissedPacketsChart() {
  return __webpack_require__.e/* import() */(24).then(__webpack_require__.bind(null, 979));
};
var UnlockUser = function UnlockUser() {
  return __webpack_require__.e/* import() */(103).then(__webpack_require__.bind(null, 1949));
};
var ApplicationNetworksList = function ApplicationNetworksList() {
  return __webpack_require__.e/* import() */(95).then(__webpack_require__.bind(null, 1337));
};
var ApplicationNetworks = function ApplicationNetworks() {
  return __webpack_require__.e/* import() */(83).then(__webpack_require__.bind(null, 1950));
};
var ApplicationNetwork = function ApplicationNetwork() {
  return __webpack_require__.e/* import() */(68).then(__webpack_require__.bind(null, 1951));
};
var ApplicationNetworkDashboard = function ApplicationNetworkDashboard() {
  return __webpack_require__.e/* import() */(14).then(__webpack_require__.bind(null, 1953));
};
var NewApplicationNetworkModal = function NewApplicationNetworkModal() {
  return __webpack_require__.e/* import() */(77).then(__webpack_require__.bind(null, 1954));
};
var Gateways = function Gateways() {
  return __webpack_require__.e/* import() */(55).then(__webpack_require__.bind(null, 1955));
};
var GatewaysTable = function GatewaysTable() {
  return __webpack_require__.e/* import() */(81).then(__webpack_require__.bind(null, 1338));
};
var Gateway = function Gateway() {
  return __webpack_require__.e/* import() */(64).then(__webpack_require__.bind(null, 1958));
};
var GatewayDashboard = function GatewayDashboard() {
  return __webpack_require__.e/* import() */(16).then(__webpack_require__.bind(null, 1959));
};
var NewGatewayModal = function NewGatewayModal() {
  return __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, 1957));
};
var UploadGatewayModal = function UploadGatewayModal() {
  return __webpack_require__.e/* import() */(52).then(__webpack_require__.bind(null, 1960));
};
var GatewayDetails = function GatewayDetails() {
  return __webpack_require__.e/* import() */(15).then(__webpack_require__.bind(null, 1961));
};
var GatewayRevisions = function GatewayRevisions() {
  return __webpack_require__.e/* import() */(6).then(__webpack_require__.bind(null, 1962));
};
var AppAuth = function AppAuth() {
  return __webpack_require__.e/* import() */(6).then(__webpack_require__.bind(null, 1963));
};
var RssiSpectralScan = function RssiSpectralScan() {
  return __webpack_require__.e/* import() */(8).then(__webpack_require__.bind(null, 1964));
};
var GatewayLicense = function GatewayLicense() {
  return __webpack_require__.e/* import() */(111).then(__webpack_require__.bind(null, 1965));
};
var ApplicationNetworkRevisions = function ApplicationNetworkRevisions() {
  return __webpack_require__.e/* import() */(34).then(__webpack_require__.bind(null, 1966));
};
var EndDeviceRevisions = function EndDeviceRevisions() {
  return __webpack_require__.e/* import() */(30).then(__webpack_require__.bind(null, 1967));
};
var DeviceProfileRevisions = function DeviceProfileRevisions() {
  return __webpack_require__.e/* import() */(31).then(__webpack_require__.bind(null, 1968));
};
var NetworkProfileRevisions = function NetworkProfileRevisions() {
  return __webpack_require__.e/* import() */(39).then(__webpack_require__.bind(null, 1969));
};
var OrganizationActivity = function OrganizationActivity() {
  return __webpack_require__.e/* import() */(109).then(__webpack_require__.bind(null, 1970));
};
var OrganizationSessions = function OrganizationSessions() {
  return __webpack_require__.e/* import() */(46).then(__webpack_require__.bind(null, 1971));
};
var OrganizationRevisions = function OrganizationRevisions() {
  return __webpack_require__.e/* import() */(38).then(__webpack_require__.bind(null, 1972));
};
var OrganizationCreateRevisions = function OrganizationCreateRevisions() {
  return __webpack_require__.e/* import() */(32).then(__webpack_require__.bind(null, 1973));
};
var OrganizationUpdateRevisions = function OrganizationUpdateRevisions() {
  return __webpack_require__.e/* import() */(33).then(__webpack_require__.bind(null, 1974));
};
var OrganizationDestroyRevisions = function OrganizationDestroyRevisions() {
  return __webpack_require__.e/* import() */(42).then(__webpack_require__.bind(null, 1975));
};
var OrganizationBroadcast = function OrganizationBroadcast() {
  return __webpack_require__.e/* import() */(98).then(__webpack_require__.bind(null, 1976));
};
var OrganizationLicense = function OrganizationLicense() {
  return __webpack_require__.e/* import() */(49).then(__webpack_require__.bind(null, 1977));
};
var EulaAccept = function EulaAccept() {
  return __webpack_require__.e/* import() */(110).then(__webpack_require__.bind(null, 1978));
};
var OrganizationDashboard = function OrganizationDashboard() {
  return __webpack_require__.e/* import() */(9).then(__webpack_require__.bind(null, 1979));
};
var OrganizationSummary = function OrganizationSummary() {
  return __webpack_require__.e/* import() */(91).then(__webpack_require__.bind(null, 981));
};
var OrganizationAssignTokens = function OrganizationAssignTokens() {
  return __webpack_require__.e/* import() */(7).then(__webpack_require__.bind(null, 1371));
};
var OrganizationScheduleDeviceProvisioning = function OrganizationScheduleDeviceProvisioning() {
  return __webpack_require__.e/* import() */(7).then(__webpack_require__.bind(null, 1372));
};
var OrganizationJoinChart = function OrganizationJoinChart() {
  return __webpack_require__.e/* import() */(19).then(__webpack_require__.bind(null, 982));
};
var OrganizationPacketsChart = function OrganizationPacketsChart() {
  return __webpack_require__.e/* import() */(22).then(__webpack_require__.bind(null, 983));
};
var OrganizationCrcErrorsChart = function OrganizationCrcErrorsChart() {
  return __webpack_require__.e/* import() */(18).then(__webpack_require__.bind(null, 984));
};
var OrganizationMissedPacketsChart = function OrganizationMissedPacketsChart() {
  return __webpack_require__.e/* import() */(20).then(__webpack_require__.bind(null, 985));
};
var JoinRequests = function JoinRequests() {
  return __webpack_require__.e/* import() */(10).then(__webpack_require__.bind(null, 986));
};
var SimpleJoinRequests = function SimpleJoinRequests() {
  return __webpack_require__.e/* import() */(11).then(__webpack_require__.bind(null, 987));
};
var Packets = function Packets() {
  return __webpack_require__.e/* import() */(12).then(__webpack_require__.bind(null, 988));
};
var NetworkStatistics = function NetworkStatistics() {
  return __webpack_require__.e/* import() */(40).then(__webpack_require__.bind(null, 989));
};
var GatewayStatistics = function GatewayStatistics() {
  return __webpack_require__.e/* import() */(13).then(__webpack_require__.bind(null, 990));
};
var UserActions = function UserActions() {
  return __webpack_require__.e/* import() */(35).then(__webpack_require__.bind(null, 1980));
};
var UserRevisions = function UserRevisions() {
  return __webpack_require__.e/* import() */(41).then(__webpack_require__.bind(null, 1981));
};

var EndDevices = function EndDevices() {
  return __webpack_require__.e/* import() */(54).then(__webpack_require__.bind(null, 1982));
};

var ServiceApiKeys = function ServiceApiKeys() {
  return __webpack_require__.e/* import() */(57).then(__webpack_require__.bind(null, 1983));
};

var EndDevicesTable = function EndDevicesTable() {
  return __webpack_require__.e/* import() */(61).then(__webpack_require__.bind(null, 1220));
};
var EndDevice = function EndDevice() {
  return __webpack_require__.e/* import() */(66).then(__webpack_require__.bind(null, 1984));
};

var ServiceApiKeysTable = function ServiceApiKeysTable() {
  return __webpack_require__.e/* import() */(60).then(__webpack_require__.bind(null, 1373));
};
var ServiceApiKey = function ServiceApiKey() {
  return __webpack_require__.e/* import() */(65).then(__webpack_require__.bind(null, 1985));
};

var NetworkProfiles = function NetworkProfiles() {
  return __webpack_require__.e/* import() */(59).then(__webpack_require__.bind(null, 1986));
};
var NetworkProfile = function NetworkProfile() {
  return __webpack_require__.e/* import() */(63).then(__webpack_require__.bind(null, 1987));
};
var NewNetworkProfileModal = function NewNetworkProfileModal() {
  return __webpack_require__.e/* import() */(73).then(__webpack_require__.bind(null, 1754));
};
var EndDeviceDashboard = function EndDeviceDashboard() {
  return __webpack_require__.e/* import() */(17).then(__webpack_require__.bind(null, 1988));
};
var NewEndDeviceModal = function NewEndDeviceModal() {
  return __webpack_require__.e/* import() */(74).then(__webpack_require__.bind(null, 1989));
};

var ServiceApiKeyDashboard = function ServiceApiKeyDashboard() {
  return __webpack_require__.e/* import() */(107).then(__webpack_require__.bind(null, 1990));
};
var NewServiceApiKeyModal = function NewServiceApiKeyModal() {
  return __webpack_require__.e/* import() */(70).then(__webpack_require__.bind(null, 1991));
};

var UploadEndDeviceModal = function UploadEndDeviceModal() {
  return __webpack_require__.e/* import() */(53).then(__webpack_require__.bind(null, 1993));
};
var OrganizationDeviceProfiles = function OrganizationDeviceProfiles() {
  return __webpack_require__.e/* import() */(88).then(__webpack_require__.bind(null, 1994));
};
var DeviceProfiles = function DeviceProfiles() {
  return __webpack_require__.e/* import() */(85).then(__webpack_require__.bind(null, 1995));
};
var DeviceProfile = function DeviceProfile() {
  return __webpack_require__.e/* import() */(82).then(__webpack_require__.bind(null, 1996));
};
var DeviceProfileModal = function DeviceProfileModal() {
  return __webpack_require__.e/* import() */(75).then(__webpack_require__.bind(null, 1998));
};
var Operations = function Operations() {
  return __webpack_require__.e/* import() */(50).then(__webpack_require__.bind(null, 1999));
};
var DeviceGroups = function DeviceGroups() {
  return __webpack_require__.e/* import() */(87).then(__webpack_require__.bind(null, 2000));
};
var DeviceGroup = function DeviceGroup() {
  return __webpack_require__.e/* import() */(67).then(__webpack_require__.bind(null, 2001));
};
var NewDeviceGroupModal = function NewDeviceGroupModal() {
  return __webpack_require__.e/* import() */(76).then(__webpack_require__.bind(null, 2002));
};
var Policies = function Policies() {
  return __webpack_require__.e/* import() */(86).then(__webpack_require__.bind(null, 2003));
};
var Policy = function Policy() {
  return __webpack_require__.e/* import() */(80).then(__webpack_require__.bind(null, 2004));
};
var NewPolicyModal = function NewPolicyModal() {
  return __webpack_require__.e/* import() */(71).then(__webpack_require__.bind(null, 2006));
};
var NewOperation = function NewOperation() {
  return __webpack_require__.e/* import() */(51).then(__webpack_require__.bind(null, 2007));
};
var PacketsTable = function PacketsTable() {
  return __webpack_require__.e/* import() */(100).then(__webpack_require__.bind(null, 2008));
};
var JoinRequestsTable = function JoinRequestsTable() {
  return __webpack_require__.e/* import() */(101).then(__webpack_require__.bind(null, 2009));
};
var GatewayStatisticsTable = function GatewayStatisticsTable() {
  return __webpack_require__.e/* import() */(113).then(__webpack_require__.bind(null, 2010));
};
var NetworkStatisticsTable = function NetworkStatisticsTable() {
  return __webpack_require__.e/* import() */(112).then(__webpack_require__.bind(null, 2011));
};
var Users = function Users() {
  return __webpack_require__.e/* import() */(28).then(__webpack_require__.bind(null, 991));
};
var UserModal = function UserModal() {
  return __webpack_require__.e/* import() */(69).then(__webpack_require__.bind(null, 2012));
};
var Me = function Me() {
  return __webpack_require__.e/* import() */(79).then(__webpack_require__.bind(null, 2014));
};
var Organizations = function Organizations() {
  return __webpack_require__.e/* import() */(58).then(__webpack_require__.bind(null, 2015));
};
var Organization = function Organization() {
  return __webpack_require__.e/* import() */(5).then(__webpack_require__.bind(null, 2016));
};
var SystemOrganization = function SystemOrganization() {
  return __webpack_require__.e/* import() */(5).then(__webpack_require__.bind(null, 2017));
};
var OrganizationModal = function OrganizationModal() {
  return __webpack_require__.e/* import() */(72).then(__webpack_require__.bind(null, 2018));
};
var Support = function Support() {
  return __webpack_require__.e/* import() */(108).then(__webpack_require__.bind(null, 2019));
};
var SystemLimits = function SystemLimits() {
  return __webpack_require__.e/* import() */(105).then(__webpack_require__.bind(null, 2020));
};
var Vaults = function Vaults() {
  return __webpack_require__.e/* import() */(47).then(__webpack_require__.bind(null, 2021));
};
var VaultCreateController = function VaultCreateController() {
  return __webpack_require__.e/* import() */(102).then(__webpack_require__.bind(null, 2022));
};
var VaultUpdateController = function VaultUpdateController() {
  return __webpack_require__.e/* import() */(90).then(__webpack_require__.bind(null, 2023));
};
var VaultTransactions = function VaultTransactions() {
  return __webpack_require__.e/* import() */(48).then(__webpack_require__.bind(null, 2024));
};

var LensSiteCreateView = function LensSiteCreateView() {
  return __webpack_require__.e/* import() */(97).then(__webpack_require__.bind(null, 2025));
};
var LensSiteUpdateView = function LensSiteUpdateView() {
  return __webpack_require__.e/* import() */(84).then(__webpack_require__.bind(null, 2026));
};
var TenantAccountCreateView = function TenantAccountCreateView() {
  return __webpack_require__.e/* import() */(96).then(__webpack_require__.bind(null, 2027));
};
var TenantAccountUpdateView = function TenantAccountUpdateView() {
  return __webpack_require__.e/* import() */(104).then(__webpack_require__.bind(null, 2028));
};

var SystemBroadcast = function SystemBroadcast() {
  return __webpack_require__.e/* import() */(106).then(__webpack_require__.bind(null, 2029));
};

// DeviceHQ Views and Components
var DeviceHQLogin = function DeviceHQLogin() {
  return __webpack_require__.e/* import() */(89).then(__webpack_require__.bind(null, 2030));
};
var DeviceHQAccount = function DeviceHQAccount() {
  return __webpack_require__.e/* import() */(92).then(__webpack_require__.bind(null, 2031));
};
var DeviceHQUsers = function DeviceHQUsers() {
  return __webpack_require__.e/* import() */(45).then(__webpack_require__.bind(null, 2032));
};
var DeviceHQDevices = function DeviceHQDevices() {
  return __webpack_require__.e/* import() */(43).then(__webpack_require__.bind(null, 2033));
};
var DeviceHQDevice = function DeviceHQDevice() {
  return __webpack_require__.e/* import() */(94).then(__webpack_require__.bind(null, 2034));
};

var ApplicationNetworkStates = function ApplicationNetworkStates() {
  return __webpack_require__.e/* import() */(44).then(__webpack_require__.bind(null, 2035));
};
var EndDeviceStates = function EndDeviceStates() {
  return __webpack_require__.e/* import() */(26).then(__webpack_require__.bind(null, 2036));
};
var HealthCheckManagement = function HealthCheckManagement() {
  return __webpack_require__.e/* import() */(99).then(__webpack_require__.bind(null, 2037));
};
var GatewayStates = function GatewayStates() {
  return __webpack_require__.e/* import() */(29).then(__webpack_require__.bind(null, 2038));
};
var AppNetDeviceStates = function AppNetDeviceStates() {
  return __webpack_require__.e/* import() */(36).then(__webpack_require__.bind(null, 2039));
};
var GatewayDeviceStates = function GatewayDeviceStates() {
  return __webpack_require__.e/* import() */(37).then(__webpack_require__.bind(null, 2040));
};
var Operation = function Operation() {
  return __webpack_require__.e/* import() */(27).then(__webpack_require__.bind(null, 2041));
};

vue_esm["default"].use(vue_router_esm["a" /* default */]);

var routes = [{
  path: "/login",
  alias: ["/reset-password", "/set-password"],
  name: Login.name,
  component: Login,
  meta: { noAuth: true }
}, {
  path: "/logout",
  beforeEnter: function beforeEnter(to, from, next) {
    store["c" /* default */].commit(session["c" /* REMOVE_SESSION */]);
    next("/login");
  },
  meta: { noAuth: true }
}, {
  path: "/unlock-user",
  name: "UnlockUser",
  component: UnlockUser,
  meta: { noAuth: true }
}, {
  path: "/",
  component: App,
  children: [{
    path: "eula",
    name: "EulaAccept",
    component: EulaAccept
  }, {
    path: "/devicehq/login",
    // alias: ['/devicehq/reset-password', 'devicehq/set-password'],
    name: DeviceHQLogin.name,
    component: DeviceHQLogin,
    meta: { noAuth: true }
  }, {
    path: "devicehq/account",
    name: DeviceHQAccount.name,
    component: DeviceHQAccount
  }, {
    path: "devicehq/users",
    name: DeviceHQUsers.name,
    component: DeviceHQUsers
  }, {
    path: "devicehq/devices",
    name: DeviceHQDevices.name,
    component: DeviceHQDevices
  }, {
    path: "devicehq/devices/:uuid",
    name: DeviceHQDevice.name,
    component: DeviceHQDevice
  }, {
    path: "application-network-states",
    name: ApplicationNetworkStates.name,
    component: ApplicationNetworkStates
  }, {
    path: "end-device-states",
    name: EndDeviceStates.name,
    component: EndDeviceStates
  }, {
    path: "health-check-management",
    name: "Health Check Management",
    component: HealthCheckManagement
  }, {
    path: "gateway-states",
    name: GatewayStates.name,
    component: GatewayStates
  }, {
    path: "application-network-states/device-states/:id",
    name: AppNetDeviceStates.name,
    component: AppNetDeviceStates,
    props: true
  }, {
    path: "gateway-states/device-states/:id",
    name: GatewayDeviceStates.name,
    component: GatewayDeviceStates,
    props: true
  }, {
    path: "",
    redirect: "dashboard"
  }, {
    path: "dashboard",
    name: Dashboard.name,
    component: Dashboard,
    children: [{
      path: "",
      redirect: "map_view"
    }, {
      path: "map_view",
      name: "MapView",
      component: MapView
    }, {
      path: "packets_chart",
      name: "PacketsChart",
      component: PacketsChart
    }, {
      path: "join_requests_chart",
      name: "JoinRequestsChart",
      component: JoinRequestsChart
    }, {
      path: "crc_percentage_chart",
      name: "CrcPercentageChart",
      component: CrcPercentageChart
    }, {
      path: "missed_packets_chart",
      name: "MissedPacketsChart",
      component: MissedPacketsChart
    }]
  }, {
    path: "application-networks",
    name: ApplicationNetworks.name,
    components: {
      default: ApplicationNetworks,
      speeddial: components_ApplicationNetworkSpeedDial
    },
    props: {
      speeddial: function speeddial(route) {
        return {
          routeName: route.name,
          routeKey: route.path.split("/")[1]
        };
      }
    },
    children: [{
      path: "new",
      name: "ApplicationNetworksNew",
      component: NewApplicationNetworkModal
    }]
  }, {
    path: "application-networks/profiles",
    name: NetworkProfiles.name,
    components: {
      default: NetworkProfiles,
      speeddial: components_NetworkProfileSpeedDial
    },
    props: {
      speeddial: function speeddial(route) {
        return {
          routeName: route.name,
          routeKey: route.path.split("/")[1]
        };
      }
    },
    children: [{
      path: "new",
      name: "NewNetworkProfileModal",
      component: NewNetworkProfileModal
    }]
  }, {
    path: "application-networks/profiles/:id",
    components: {
      default: NetworkProfile
      //   speeddial: NetworkProfileSpeedDial,  FIXME: The SpeedDial does not allow NewNetworkProfileModal to work correctly
    },
    props: {
      default: true
    },
    children: [{
      path: "(.*)?new",
      name: "NetworkProfileNew",
      components: { modal: NewNetworkProfileModal }
    }, {
      path: "",
      redirect: "revisions"
    }, {
      path: "revisions",
      name: "NetworkProfileRevisions",
      component: NetworkProfileRevisions,
      props: true
    }]
  }, {
    path: "application-networks/:eui",
    components: {
      default: ApplicationNetwork,
      speeddial: components_ApplicationNetworkSpeedDial
    },
    props: {
      default: true
    },
    children: [{
      path: "",
      redirect: "dashboard"
    }, {
      path: "dashboard",
      name: "ApplicationNetworkDashboard",
      component: ApplicationNetworkDashboard,
      props: true
    }, {
      path: "join-requests",
      name: "ApplicationNetworkJoinRequests",
      component: JoinRequestsTable,
      props: function props(route) {
        return {
          appEui: route.params.eui,
          hidden: ["app_eui"]
        };
      }
    }, {
      path: "packets",
      name: "ApplicationNetworkPackets",
      component: PacketsTable,
      props: function props(route) {
        return {
          appEui: route.params.eui,
          uplink: true,
          downlink: true,
          hidden: ["app_eui"]
        };
      }
    }, {
      path: "device-states",
      name: "ApplicationNetworkDeviceStates",
      component: AppNetDeviceStates
    }, {
      path: "app_auth",
      name: "AppAuth",
      component: AppAuth,
      props: true
    }, {
      path: "revisions",
      name: "ApplicationNetworkRevisions",
      component: ApplicationNetworkRevisions,
      props: true
    }, {
      path: "gateways",
      name: "ApplicationNetworkGateways",
      component: GatewaysTable,
      props: function props(route) {
        return { appEui: route.params.eui };
      }
    }, {
      path: "end-devices",
      name: "ApplicationNetworkEndDevices",
      component: EndDevicesTable,
      props: function props(route) {
        return {
          appEui: route.params.eui,
          hidden: ["application_network_id"]
        };
      }
    }, {
      path: "(.*)?new",
      name: "ApplicationNetworkNew",
      components: { modal: NewApplicationNetworkModal }
    }]
  }, {
    path: "organization/:id",
    name: "OrganizationActivity",
    component: OrganizationActivity,
    props: true,
    children: [{
      path: "",
      redirect: "sessions"
    }, {
      path: "sessions",
      name: "OrganizationSessions",
      component: OrganizationSessions,
      props: true
    }, {
      path: "create_revisions",
      name: "OrganizationCreateRevisions",
      component: OrganizationCreateRevisions,
      props: true
    }, {
      path: "update_revisions",
      name: "OrganizationUpdateRevisions",
      component: OrganizationUpdateRevisions,
      props: true
    }, {
      path: "destroy_revisions",
      name: "OrganizationDestroyRevisions",
      component: OrganizationDestroyRevisions,
      props: true
    }]
  }, {
    path: "organization/:id/license",
    name: "OrganizationLicense",
    component: OrganizationLicense,
    props: true
  }, {
    path: "organization/:id/broadcasts",
    name: "OrganizationBroadcast",
    component: OrganizationBroadcast,
    props: true
  }, {
    path: "my_organization/:id",
    name: Organization.name,
    component: Organization,
    props: true,
    children: [{
      path: "",
      redirect: "revisions"
    },
    // {
    //   path: 'dashboard',
    //   name: 'OrganizationDashboard',
    //   component: OrganizationDashboard,
    //   props: route => ({
    //     orgId: route.params.id,
    //   })
    // },
    // {
    //   path: 'join_requests',
    //   name: 'OrganizationJoinRequests',
    //   component: JoinRequests,
    //   props: route => ({
    //     orgId: route.params.id,
    //   })
    // },
    // {
    //   path: 'packets',
    //   name: 'OrganizationPackets',
    //   component: Packets,
    //   props: route => ({
    //     orgId: route.params.id,
    //   })
    // },
    // {
    //   path: 'network_statistics',
    //   name: 'OrganizationNetworkStatistics',
    //   component: NetworkStatistics,
    //   props: route => ({
    //     orgId: route.params.id,
    //   })
    // },
    // {
    //   path: 'gateway_statistics',
    //   name: 'OrganizationGatewayStatistics',
    //   component: GatewayStatistics,
    //   props: route => ({
    //     orgId: route.params.id,
    //   })
    // },
    {
      path: "revisions",
      name: "OrganizationRevisions",
      component: OrganizationRevisions,
      props: true
    }]
  }, {
    path: "organizations",
    name: Organization.name,
    components: {
      default: Organizations,
      speeddial: components_OrganizationSpeedDial
    },
    props: {
      speeddial: function speeddial(route) {
        return {
          routeName: route.name,
          routeKey: route.path.split("/")[1]
        };
      }
    },
    children: [{
      path: "new",
      name: "OrganizationsNew",
      component: OrganizationModal
    }]
  }, {
    path: "organizations/:id",
    components: {
      default: SystemOrganization,
      speeddial: components_OrganizationSpeedDial
    },
    props: {
      default: true
    },
    children: [{
      path: "",
      redirect: "dashboard"
    }, {
      path: "dashboard",
      name: "OrganizationDashboard",
      component: OrganizationDashboard,
      props: function props(route) {
        return {
          orgId: route.params.id
        };
      },
      children: [{
        path: "",
        redirect: "organization_summary"
      }, {
        path: "organization_summary",
        name: "OrganizationSummary",
        component: OrganizationSummary,
        props: function props(route) {
          return {
            orgId: route.params.id
          };
        }
      }, {
        path: "assign_tokens",
        name: "OrganizationAssignTokens",
        component: OrganizationAssignTokens
      }, {
        path: "schedule_device_provisioning",
        name: "OrganizationScheduleDeviceProvisioning",
        component: OrganizationScheduleDeviceProvisioning
      }, {
        path: "join_chart",
        name: "OrganizationJoinChart",
        component: OrganizationJoinChart,
        props: function props(route) {
          return {
            orgId: route.params.id
          };
        }
      }, {
        path: "packets_chart",
        name: "OrganizationPacketsChart",
        component: OrganizationPacketsChart,
        props: function props(route) {
          return {
            orgId: route.params.id
          };
        }
      }, {
        path: "crc_errors_chart",
        name: "OrganizationCrcErrorsChart",
        component: OrganizationCrcErrorsChart,
        props: function props(route) {
          return {
            orgId: route.params.id
          };
        }
      }, {
        path: "missed_packets_chart",
        name: "OrganizationMissedPacketsChart",
        component: OrganizationMissedPacketsChart,
        props: function props(route) {
          return {
            orgId: route.params.id
          };
        }
      }, {
        path: "join_requests",
        name: "OrganizationJoinRequests",
        component: JoinRequests,
        props: function props(route) {
          return {
            orgId: route.params.id
          };
        }
      }, {
        path: "simple_join_requests",
        name: "SimpleJoinRequests",
        component: SimpleJoinRequests,
        props: function props(route) {
          return {
            orgId: route.params.id
          };
        }
      }, {
        path: "packets",
        name: "OrganizationPackets",
        component: Packets,
        props: function props(route) {
          return {
            orgId: route.params.id
          };
        }
      }, {
        path: "network_statistics",
        name: "OrganizationNetworkStatistics",
        component: NetworkStatistics,
        props: function props(route) {
          return {
            orgId: route.params.id
          };
        }
      }, {
        path: "gateway_statistics",
        name: "OrganizationGatewayStatistics",
        component: GatewayStatistics,
        props: function props(route) {
          return {
            orgId: route.params.id
          };
        }
      }]
    }, {
      path: "gateways",
      name: "OrganizationGateways",
      component: GatewaysTable,
      props: function props(route) {
        return {
          orgId: route.params.id
        };
      },
      children: [{
        path: "new",
        name: "OrganizationGatewaysNew",
        props: true,
        components: {
          orgModal: NewGatewayModal
        }
      }]
    }, {
      path: "end_devices",
      name: "OrganizationEndDevices",
      component: EndDevicesTable,
      props: function props(route) {
        return {
          orgId: route.params.id
        };
      },
      children: [{
        path: "new",
        name: "OrganizationEndDevicesNew",
        props: true,
        components: {
          orgModal: NewEndDeviceModal
        }
      }]
    }, {
      path: "app_networks",
      name: "OrganizationAppNetworks",
      component: ApplicationNetworksList,
      props: function props(route) {
        return {
          orgId: route.params.id
        };
      },
      children: [{
        path: "new",
        name: "AppNetworksNew",
        props: true,
        components: {
          orgModal: NewApplicationNetworkModal
        }
      }]
    }, {
      path: "users",
      name: "OrganizationUsers",
      component: Users,
      props: function props(route) {
        return {
          id: route.params.userId,
          orgId: route.params.id
        };
      },
      children: [{
        path: "new",
        name: "OrganizationUsersNew",
        props: true,
        components: {
          default: UserModal
        }
      }, {
        path: ":userId/edit",
        name: "OrganizationUserEdit",
        components: {
          default: UserModal
        }
      }]
    }, {
      path: "end-devices/profiles",
      name: "OrganizationDeviceProfiles",
      component: OrganizationDeviceProfiles,
      props: true,
      children: [{
        path: ":deviceProfileId",
        name: "OrganizationDeviceProfileEdit",
        components: {
          default: DeviceProfileModal
        }
      }]
    }, {
      path: "sessions",
      name: "OrganizationSessions",
      component: OrganizationSessions,
      props: true
    }, {
      path: "create_revisions",
      name: "OrganizationCreateRevisions",
      component: OrganizationCreateRevisions,
      props: true
    }, {
      path: "update_revisions",
      name: "OrganizationUpdateRevisions",
      component: OrganizationUpdateRevisions,
      props: true
    }, {
      path: "destroy_revisions",
      name: "OrganizationDestroyRevisions",
      component: OrganizationDestroyRevisions,
      props: true
    }]
  }, {
    path: "gateways",
    name: Gateways.name,
    components: {
      default: Gateways,
      speeddial: components_GatewaySpeedDial
    },
    props: {
      speeddial: function speeddial(route) {
        return {
          routeName: route.name,
          routeKey: route.path.split("/")[1]
        };
      }
    },
    children: [{
      path: "new",
      name: "GatewaysNew",
      component: NewGatewayModal
    }, {
      path: "upload",
      name: "GatewaysUpload",
      component: UploadGatewayModal
    }]
  }, {
    path: "gateways/:eui",
    components: {
      default: Gateway,
      speeddial: components_GatewaySpeedDial
    },
    props: {
      default: true
    },
    children: [{
      path: "",
      redirect: "dashboard"
    }, {
      path: "dashboard",
      name: "GatewayDashboard",
      component: GatewayDashboard,
      props: true
    }, {
      path: "join-requests",
      name: "GatewayJoinRequests",
      component: JoinRequestsTable,
      props: function props(route) {
        return {
          gatewayEui: route.params.eui,
          hidden: ["gw_eui"]
        };
      }
    }, {
      path: "device-states",
      name: "LocalGatewayDeviceStates",
      component: GatewayDeviceStates
    }, {
      path: "packets",
      name: "GatewayPackets",
      component: PacketsTable,
      props: function props(route) {
        return {
          gatewayEui: route.params.eui,
          uplink: true,
          downlink: true,
          hidden: ["gateway_eui"]
        };
      }
    }, {
      path: "statistics",
      name: "GatewayStatistics",
      component: GatewayStatisticsTable,
      props: true
    }, {
      path: "network-statistics",
      name: "NetworkStatistics",
      component: NetworkStatisticsTable,
      props: true
    }, {
      path: "details",
      name: "GatewayDetails",
      component: GatewayDetails,
      props: true
    }, {
      path: "revisions",
      name: "GatewayRevisions",
      component: GatewayRevisions,
      props: true
    }, {
      path: "rssi-spectral-scan",
      name: "RssiSpectralScan",
      component: RssiSpectralScan,
      props: true
    }, {
      path: "gateway-license",
      name: "GatewayLicense",
      component: GatewayLicense,
      props: true
    }, {
      path: "(.*)?new",
      name: "GatewayNew",
      components: { modal: NewGatewayModal }
    }, {
      path: "(.*)?upload",
      name: "GatewayUpload",
      components: { modal: UploadGatewayModal }
    }]
  }, {
    path: "end-devices/profiles",
    name: DeviceProfiles.name,
    components: {
      default: DeviceProfiles,
      speeddial: components_DeviceProfileSpeedDial
    },
    props: {
      speeddial: function speeddial(route) {
        return {
          routeName: route.name,
          routeKey: route.path.split("/")[1]
        };
      }
    },
    children: [{
      path: "new",
      name: "DeviceProfilesNew",
      component: DeviceProfileModal
    }]
  }, {
    path: "end-devices/profiles/:id",
    components: {
      default: DeviceProfile,
      speeddial: components_DeviceProfileSpeedDial
    },
    props: {
      default: true
    },
    children: [{
      path: "(.*)?new",
      name: "DeviceProfileNew",
      components: { modal: DeviceProfileModal }
    }, {
      path: "",
      redirect: "revisions"
    }, {
      path: "revisions",
      name: "DeviceProfileRevisions",
      component: DeviceProfileRevisions,
      props: true
    }]
  }, {
    path: "policies",
    name: Policies.name,
    components: {
      default: Policies,
      speeddial: components_PolicySpeedDial
    },
    props: {
      speeddial: function speeddial(route) {
        return {
          routeName: route.name,
          routeKey: "/policies/new"
        };
      }
    },
    children: [{
      path: "new",
      name: "PoliciesNew",
      component: NewPolicyModal
    }]
  }, {
    path: "policies/:id",
    name: Policy.name,
    components: {
      default: Policy,
      speeddial: components_PolicySpeedDial
    },
    props: {
      default: true,
      speeddial: function speeddial(route) {
        return {
          routeName: route.name,
          routeKey: "/policies/new"
        };
      }
    },
    children: [{
      path: "(.*)?new",
      name: "PolicyNew",
      components: { modal: NewPolicyModal }
    }]
  }, {
    path: "people",
    name: Users.name,
    components: {
      default: Users,
      speeddial: components_UserSpeedDial
    },
    children: [{
      path: "new",
      name: "UserNew",
      component: UserModal,
      props: { creator: true, newUser: true }
    }, {
      path: ":id",
      name: "UserEdit",
      component: UserModal,
      props: true
    }]
  }, {
    path: "people/:id/actions",
    name: "UserActions",
    component: UserActions,
    props: true
  }, {
    path: "people/:id/revisions",
    name: "UserRevisions",
    component: UserRevisions,
    props: true
  }, {
    path: "me",
    name: Me.name,
    component: Me
  }, {
    path: "support",
    name: Support.name,
    component: Support
  }, {
    path: "operations",
    name: Operations.name,
    component: Operations
  }, {
    path: "end-devices/groups",
    name: DeviceGroups.name,
    components: {
      default: DeviceGroups,
      speeddial: components_DeviceGroupSpeedDial
    },
    children: [{
      path: "new",
      name: "NewDeviceGroup",
      component: NewDeviceGroupModal
    }]
  }, {
    path: "end-devices/groups/:id",
    components: {
      default: DeviceGroup,
      speeddial: components_DeviceGroupSpeedDial
    },
    props: {
      default: true
    },
    children: [{
      path: "",
      redirect: "devices"
    }, {
      path: "devices",
      name: "DeviceGroupEndDevices",
      component: EndDevicesTable,
      props: function props(route) {
        return {
          deviceGroupEui: route.params.id || route.params.eui,
          showGroupAddRemoveControls: true,
          suppressBulkEdit: true
        };
      }
    }, {
      path: "add-devices",
      name: "DeviceGroupAddEndDevices",
      component: EndDevicesTable,
      props: function props(route) {
        return {
          deviceGroupEui: route.params.id || route.params.eui,
          excludeDeviceGroup: true,
          showGroupAddRemoveControls: true,
          suppressBulkEdit: true
        };
      }
    }]
  }, {
    path: "operations/new-message",
    name: "NewOperationMessage",
    component: NewOperation,
    props: {
      type: "message"
    }
  }, {
    path: "operations/firmware-upgrade",
    name: "NewFirmwareUpgrade",
    component: NewOperation,
    props: {
      type: "firmware"
    }
  }, {
    path: "operations/:id/",
    name: "Operation",
    component: Operation,
    props: true
  }, {
    path: "end-devices",
    name: EndDevices.name,
    components: {
      default: EndDevices,
      speeddial: components_EndDeviceSpeedDial
    },
    props: {
      speeddial: function speeddial(route) {
        return {
          routeName: route.name,
          routeKey: route.path.split("/")[1]
        };
      }
    },
    children: [{
      path: "new",
      name: "EndDevicesNew",
      component: NewEndDeviceModal
    }, {
      path: "upload",
      name: "EndDevicesUpload",
      component: UploadEndDeviceModal
    }]
  }, {
    path: "end-devices/:eui",
    components: {
      default: EndDevice,
      speeddial: components_EndDeviceSpeedDial
    },
    props: {
      default: true
    },
    children: [{
      path: "",
      redirect: "dashboard"
    }, {
      path: "dashboard",
      name: "EndDeviceDashboard",
      component: EndDeviceDashboard,
      props: true
    }, {
      path: "join-requests",
      name: "EndDeviceJoinRequests",
      component: JoinRequestsTable,
      props: function props(route) {
        return {
          endDeviceEui: route.params.eui,
          hidden: ["dev_eui"]
        };
      }
    }, {
      path: "packets",
      name: "EndDevicePackets",
      component: PacketsTable,
      props: function props(route) {
        return {
          endDeviceEui: route.params.eui,
          uplink: true,
          downlink: true,
          hidden: ["end_device_eui"]
        };
      }
    }, {
      path: "revisions",
      name: "EndDeviceRevisions",
      component: EndDeviceRevisions,
      props: true
    }, {
      path: "(.*)?new",
      name: "EndDeviceNew",
      components: { modal: NewEndDeviceModal }
    }, {
      path: "(.*)?upload",
      name: "EndDeviceUpload",
      components: { modal: UploadEndDeviceModal }
    }]
  }, {
    path: "systemlimits",
    name: "SettingsSystemLimits",
    component: SystemLimits
  }, {
    path: "vaults",
    name: "Vaults",
    component: Vaults,
    children: [{
      name: "VaultTransactions",
      path: 'transactions',
      component: VaultTransactions
    }]
  }, {
    path: "vaults/new",
    name: "VaultCreateController",
    component: VaultCreateController
  }, {
    path: "vaults/:id/update",
    name: "VaultUpdateController",
    component: VaultUpdateController,
    props: true,
    children: [{
      path: "site_create",
      name: "LensSiteCreateView",
      component: LensSiteCreateView,
      props: true
    }, {
      path: "site_update/:site_id",
      name: "LensSiteUpdateView",
      component: LensSiteUpdateView,
      props: true,
      children: [{
        path: "org_create",
        name: "TenantAccountCreateView",
        component: TenantAccountCreateView,
        props: true
      }, {
        path: "org_update/:tenant_account_id",
        name: "TenantAccountUpdateView",
        component: TenantAccountUpdateView,
        props: true
      }]
    }]
  }, {
    path: "systembroadcast",
    name: "SystemBroadcast",
    component: SystemBroadcast
  }, {
    path: 'service-api-keys',
    name: 'ServiceApiKeys',
    components: {
      default: ServiceApiKeys,
      speeddial: service_api_keys_ServiceApiKeySpeedDial
    },
    props: function props(route) {
      return {
        id: route.params.id
      };
    },
    children: [{
      path: 'new',
      name: 'NewServiceApiKeyModal',
      props: {
        speeddial: function speeddial(route) {
          return {
            routeName: route.name,
            routeKey: route.path.split('/')[1]
          };
        }
      },
      components: {
        orgModal: NewServiceApiKeyModal
      }
    }, {
      path: ':id',
      name: 'EditServiceApiKeyModal',
      props: true,
      components: {
        orgModal: NewServiceApiKeyModal
      }
    }]
  }]
}];

var router = new vue_router_esm["a" /* default */]({ routes: routes });

var resolveTopLevelRouteComponents = function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
    var AppRoute, topLevelRouteComponets, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, component;

    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return delay_default()(3500);

          case 2:
            AppRoute = routes.find(function (route) {
              return route.path === "/";
            });

            if (AppRoute) {
              _context.next = 5;
              break;
            }

            throw new Error("[router.js] The AppRoute cannot be found!");

          case 5:

            // $FlowFixMe
            topLevelRouteComponets = AppRoute.children.filter(function (route) {
              return route.component || object_path_default.a.get(route, "components.default");
            }).map(function (route) {
              return route.component || route.components && route.components.default;
            });

            // Resolve all the top level route components so they will be ready to use

            _iteratorNormalCompletion = true;
            _didIteratorError = false;
            _iteratorError = undefined;
            _context.prev = 9;
            _iterator = topLevelRouteComponets[Symbol.iterator]();

          case 11:
            if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
              _context.next = 19;
              break;
            }

            component = _step.value;

            if (!(typeof component === "function")) {
              _context.next = 16;
              break;
            }

            _context.next = 16;
            return component();

          case 16:
            _iteratorNormalCompletion = true;
            _context.next = 11;
            break;

          case 19:
            _context.next = 25;
            break;

          case 21:
            _context.prev = 21;
            _context.t0 = _context["catch"](9);
            _didIteratorError = true;
            _iteratorError = _context.t0;

          case 25:
            _context.prev = 25;
            _context.prev = 26;

            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }

          case 28:
            _context.prev = 28;

            if (!_didIteratorError) {
              _context.next = 31;
              break;
            }

            throw _iteratorError;

          case 31:
            return _context.finish(28);

          case 32:
            return _context.finish(25);

          case 33:
            // Also resolve these since they are large assets
            __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 1952));
            __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 1956));
            __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, 2013));

          case 36:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, _this, [[9, 21, 25, 33], [26,, 28, 32]]);
  }));

  return function resolveTopLevelRouteComponents() {
    return _ref.apply(this, arguments);
  };
}();

// Called when the router has completed the initial navigation, which means it has resolved
// all async enter hooks and async components that are associated with the initial route.
router.onReady(resolveTopLevelRouteComponents);

var router_simpleSubRouteChange = function simpleSubRouteChange(to, from) {
  return from.matched.length === to.matched.length && to.matched.length > 2 && fast_deep_equal_default()(from.params, to.params);
};

var isMajorRouteChange = function isMajorRouteChange(to, from) {
  return !router_simpleSubRouteChange(to, from);
};

router.beforeEach(function (to, from, next) {
  // Don't run for route change like /gateways/:eui/packets to /gateways/:eui/statistics
  if (isMajorRouteChange(to, from)) {
    if (store["c" /* default */].state.unsavedChanges) {
      if (!window.confirm("You have unsaved changes! They will be discarded")) {
        next(false);
        return;
      }
      store["c" /* default */].commit(store["a" /* SET_UNSAVED_CHANGES_FALSE */]);
    }

    window.scrollTo(0, 0);
  }

  if (to.matched.every(function (record) {
    return record.meta.noAuth;
  })) {
    // Route doesn't require auth
    return next();
  } else if (!store["c" /* default */].state.session.authToken || Object(date_fns["isPast"])(store["c" /* default */].state.session.expiresAt)) {
    // Route requires auth
    if (false) {
      // eslint-disable-next-line no-console
      console.log("Router requires auth, redirecting...");
    }
    return next({
      path: "/login",
      query: { redirect: to.fullPath }
    });
  } else if (to.matched.some(function (record) {
    return record.meta.adminOnly;
  }) && store["c" /* default */].getters.currentUser.roles_mask > 4) {
    // Only admins can access these routes, so redirect to dashboard
    return next({
      path: "/dashboard"
    });
  }
  if (store["c" /* default */].state.session.user.eula_accepted_rev != store["c" /* default */].state.session.user.eula_current_rev && to.path.includes("/eula") === false) {
    // If you are already at eula, don't keep going to eula otherwise you will get a recurrsion problem
    next("/eula");
  } else {
    next();
  }
});

router.afterEach(function (to, from) {
  if (true) {
    if (Object({"NODE_ENV":"production","VUE_APP_CLOUD_ENV":"aws-dev"}).GIT_NEW_FRONTEND_VERSION !== "v1.6.2-dirty" || window.serviceWorkerUpdateIsReady && isMajorRouteChange(to, from)) {
      // This will cause the new service worker to take over.
      // Old service worker cache will be deleted
      // When the onUpdated event fires, we force a page reload to use the new assets
      runtime_default.a.applyUpdate();
    }
  }
});

/* harmony default export */ var src_router = (router);
// EXTERNAL MODULE: ./src/validations.js
var validations = __webpack_require__(222);

// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__(7);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);

// CONCATENATED MODULE: ./src/axios.js








window.axios = axios_default.a;
axios_default.a.defaults.baseURL = '/api/v2';
axios_default.a.defaults.timeout = 60000;
axios_default.a.defaults.headers.common['Accept'] = 'application/vnd.api+json';
axios_default.a.defaults.headers.common['Content-Type'] = 'application/vnd.api+json';

if (store["c" /* default */].state.session.authToken) {
  axios_default.a.defaults.headers.common['X-AUTH-TOKEN'] = store["c" /* default */].state.session.authToken;
}

axios_default.a.interceptors.response.use(function (response) {
  store["c" /* default */].commit(session["d" /* UPDATE_SESSION */], {
    expiresAt: object_path_default.a.get(response, 'headers.x-session-expires-at')
  });
  return response;
}, function (error) {
  var message = error.message,
      _error$code = error.code,
      code = _error$code === undefined ? '' : _error$code,
      _error$config = error.config,
      url = _error$config.url,
      _error$config$method = _error$config.method,
      method = _error$config$method === undefined ? '' : _error$config$method;


  if (!url.includes('eui') && !url.includes('validate')) {
    // eslint-disable-next-line no-console
    console.error(method.toUpperCase() + ' ' + url + ' - ' + message + ' - ' + code + ' -', object_path_default.a.get(error, 'response.data.errors'));
  }

  var detail = object_path_default.a.get(error, 'response.data.errors.0.detail');
  if (typeof detail === 'string') {
    if (detail.toLowerCase().includes('invalid session') || detail.toLowerCase().includes('session expired')) {
      store["c" /* default */].commit(session["c" /* REMOVE_SESSION */]);
      src_router.push({
        path: '/login',
        query: { redirect: src_router.currentRoute.fullPath }
      });
      return;
    } else {
      error.message = detail;
    }
  }
  return Promise.reject(error);
});
// EXTERNAL MODULE: ./src/styles/material-icons.css
var material_icons = __webpack_require__(998);
var material_icons_default = /*#__PURE__*/__webpack_require__.n(material_icons);

// EXTERNAL MODULE: ./src/styles/basscss.css
var basscss = __webpack_require__(999);
var basscss_default = /*#__PURE__*/__webpack_require__.n(basscss);

// EXTERNAL MODULE: ./node_modules/animate.css/animate.min.css
var animate_min = __webpack_require__(1000);
var animate_min_default = /*#__PURE__*/__webpack_require__.n(animate_min);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/AppWrapper.vue
//
//
//
//
//

/* harmony default export */ var AppWrapper = ({
  name: 'AppWrapper'
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-47016b14","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/AppWrapper.vue
var AppWrapper_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-view')}
var AppWrapper_staticRenderFns = []

// CONCATENATED MODULE: ./src/AppWrapper.vue
function injectStyle (context) {
  __webpack_require__(1001)
  __webpack_require__(1002)
}
/* script */


/* template */

/* template functional */
var AppWrapper___vue_template_functional__ = false
/* styles */
var AppWrapper___vue_styles__ = injectStyle
/* scopeId */
var AppWrapper___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var AppWrapper___vue_module_identifier__ = null

var AppWrapper_Component = Object(component_normalizer["a" /* default */])(
  AppWrapper,
  AppWrapper_render,
  AppWrapper_staticRenderFns,
  AppWrapper___vue_template_functional__,
  AppWrapper___vue_styles__,
  AppWrapper___vue_scopeId__,
  AppWrapper___vue_module_identifier__
)

/* harmony default export */ var src_AppWrapper = (AppWrapper_Component.exports);

// CONCATENATED MODULE: ./src/components/InputErrorWrapper.js


/* harmony default export */ var InputErrorWrapper = ({
  mixins: [vuelidate_error_extractor["extractorMixin"]],
  render: function render() {
    return this.$scopedSlots.default({
      errors: this.hasErrors ? [this.firstErrorMessage] : []
    });
  }
});
// EXTERNAL MODULE: ./src/components/DataLoadingSkeleton.js
var DataLoadingSkeleton = __webpack_require__(980);

// CONCATENATED MODULE: ./src/index.js



























if (true) {
  // eslint-disable-next-line no-console
  console.log('GIT VERSION:              ' + "v1.6.2-dirty");
  console.log('GIT NEW FRONTEND VERSION: ' + Object({"NODE_ENV":"production","VUE_APP_CLOUD_ENV":"aws-dev"}).GIT_NEW_FRONTEND_VERSION);

  // Wait to install the service worker to make sure intial load is complete
  setTimeout(function () {
    runtime_default.a.install({
      // Set a global variable that is checked in router.afterEach()
      onUpdateReady: function onUpdateReady() {
        return window.serviceWorkerUpdateIsReady = true;
      },
      // The router has triggered the update on a navigation event,
      // so go ahead and reload to use the new assets
      onUpdated: function onUpdated() {
        return window.location.reload();
      }
    });
  }, 7000);
}

vue_esm["default"].config.productionTip = false;
vue_esm["default"].use(src["a" /* default */]);
vue_esm["default"].use(vuelidate_error_extractor_default.a, {
  name: 'ErrorProvider',
  template: InputErrorWrapper,
  messages: validations["j" /* validationMessages */]
});
vue_esm["default"].use(vue_trend_esm["a" /* default */]);
vue_esm["default"].use(main, {
  load: { key: 'AIzaSyBAuM2AUaMMz6BzF0H42QRmHa2fWK6VNSA' },
  installComponents: true
});
vue_esm["default"].component(DataLoadingSkeleton["b" /* default */].name, DataLoadingSkeleton["b" /* default */]);
vue_esm["default"].component('Grid', {
  functional: true,
  render: function render(createElement, _ref) {
    var data = _ref.data,
        children = _ref.children;

    if (!data.style) data.style = {};
    data.style.display = 'grid';
    return createElement('div', data, children);
  }
});
vue_esm["default"].filter('roleText', function (value) {
  var role = api["h" /* roles */].find(function (role) {
    return role.value === value;
  }) || {};
  return role.text || value;
});
vue_esm["default"].filter('humanize', function (value) {
  return humanize_string_default()(value);
});

// eslint-disable-next-line no-new
new vue_esm["default"]({
  el: '#app',
  vuetify: plugins_vuetify,
  store: store["c" /* default */],
  router: src_router,
  render: function render(h) {
    return h(src_AppWrapper);
  },
  mq: {
    xs: '(max-width: 599px)',
    sm: '(min-width: 600px)',
    md_sm: '(min-width: 760px)',
    md: '(min-width: 1024px)',
    md_lg: '(min-width: 1200px)',
    lg: '(min-width: 1440px)',
    xl: '(min-width: 1920px)'
  }
});

/***/ }),

/***/ 993:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vue2-google-maps/dist/components/infoWindow.vue
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var infoWindow = ((function (x) {
  return x.default || x;
})(__webpack_require__(462)));
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-25e3f758","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vue2-google-maps/dist/components/infoWindow.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{ref:"flyaway"},[_vm._t("default")],2)])}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__(14);

// CONCATENATED MODULE: ./node_modules/vue2-google-maps/dist/components/infoWindow.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  infoWindow,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_infoWindow = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 994:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vue2-google-maps/dist/components/map.vue
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var map = ((function (x) {
  return x.default || x;
})(__webpack_require__(464)));
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6839df3e","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vue2-google-maps/dist/components/map.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vue-map-container"},[_c('div',{ref:"vue-map",staticClass:"vue-map"}),_vm._v(" "),_c('div',{staticClass:"vue-map-hidden"},[_vm._t("default")],2),_vm._v(" "),_vm._t("visible")],2)}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__(14);

// CONCATENATED MODULE: ./node_modules/vue2-google-maps/dist/components/map.vue
function injectStyle (context) {
  __webpack_require__(463)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  map,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_map = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 995:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vue2-google-maps/dist/components/streetViewPanorama.vue
//
//
//
//
//
//
//

/* harmony default export */ var streetViewPanorama = ((function (x) {
  return x.default || x;
})(__webpack_require__(466)));
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-50f7f8d6","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vue2-google-maps/dist/components/streetViewPanorama.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vue-street-view-pano-container"},[_c('div',{ref:"vue-street-view-pano",staticClass:"vue-street-view-pano"}),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__(14);

// CONCATENATED MODULE: ./node_modules/vue2-google-maps/dist/components/streetViewPanorama.vue
function injectStyle (context) {
  __webpack_require__(465)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  streetViewPanorama,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_streetViewPanorama = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 996:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vue2-google-maps/dist/components/autocomplete.vue
//
//
//
//
//

/* harmony default export */ var autocomplete = ((function (x) {
  return x.default || x;
})(__webpack_require__(469)));
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e5bf798c","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vue2-google-maps/dist/components/autocomplete.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{ref:"input",attrs:{"type":"text","placeholder":_vm.placeholder},domProps:{"value":_vm.value}})}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__(14);

// CONCATENATED MODULE: ./node_modules/vue2-google-maps/dist/components/autocomplete.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  autocomplete,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_autocomplete = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 998:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 999:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},[246]);


// WEBPACK FOOTER //
// static/js/app.7b5c18ec.js